<template>
  <v-container fluid>
    <!-- Encabezado -->
    <v-row class="mb-2" align="center">
      <v-col>
        <span class="text-h6 font-weight-bold">{{ esModoReparacion0km ? 'Gestión de Tickets — Reparación de Vehículos 0km' : 'Gestión de Tickets — Garantías' }}</span>
      </v-col>
      <v-col class="d-flex justify-end" cols="auto">
        <v-btn v-if="esTabReclamoGarantia || esTabReclamoTransporte || esModoReparacion0km" color="info" class="mr-2" @click="abrirNuevoTicket">
          <v-icon left>fas fa-plus</v-icon>Nuevo ticket
        </v-btn>
        <v-btn v-if="!esRol56" color="primary" class="mr-2" :loading="cargando" @click="buscar">
          <v-icon left>fas fa-search</v-icon>Buscar
        </v-btn>
        <v-btn v-if="esRol56" color="primary" outlined class="mr-2" @click="abrirGestionSubEstados">
          <v-icon left>fas fa-list-ul</v-icon>Sub-estados
        </v-btn>
        <v-btn
          v-if="puedeGestionarDestinatariosReparacion && esModoReparacion0km"
          color="primary"
          outlined
          class="mr-2"
          @click="abrirGestionDestinatariosReparacion"
        >
          <v-icon left>fas fa-envelope</v-icon>Destinatarios alertas
        </v-btn>
        <v-btn icon @click="panelFiltros = !panelFiltros" :color="panelFiltros ? 'primary' : ''">
          <v-icon>fas fa-filter</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Alertas daños -->
    <!-- <v-alert
      v-if="alertasDanos.length > 0"
      type="warning"
      prominent
      border="left"
      class="mb-4"
      dense
    >
      <span class="font-weight-bold">{{ alertasDanos.length }} alerta(s) de unidades dañadas activas.</span>
      <v-btn small text @click="dialogAlertas = true" class="ml-2">Ver detalle</v-btn>
    </v-alert> -->

    <!-- Panel Filtros -->
    <v-expand-transition>
      <v-card v-show="panelFiltros" outlined class="mb-4">
        <v-card-text>
          <v-form @submit.prevent="buscar">
            <v-row dense>
              <v-col cols="12" sm="2" class="py-1">
                <v-text-field v-model="filtro.ticket_id" label="N° Ticket" type="number" clearable dense outlined
                  hide-details />
              </v-col>
              <v-col cols="12" sm="4" class="py-1">
                <v-text-field v-model="filtro.asunto" label="Asunto" clearable dense outlined hide-details />
              </v-col>
              <!-- <v-col cols="12" sm="3" class="py-1">
              <v-autocomplete
                v-model="filtro.solicitante"
                :items="solicitantes"
                item-value="Usuario_id"
                :item-text="u => `${u.Apellido}, ${u.Nombre}`"
                label="Solicitante"
                clearable dense outlined hide-details
              />
            </v-col> -->
              <!-- <v-col cols="12" sm="3" class="py-1">
              <v-autocomplete
                v-model="filtro.usuario_asignado"
                :items="usuariosAsignables"
                item-value="Usuario_id"
                :item-text="u => `${u.Apellido}, ${u.Nombre}`"
                label="Usuario asignado"
                clearable dense outlined hide-details
              />
            </v-col> -->
              <v-col cols="12" sm="2" class="py-1">
                <v-autocomplete v-model="filtro.estado" :items="estados" item-value="id" item-text="nombre"
                  label="Estado" clearable dense outlined hide-details />
              </v-col>
              <v-col cols="12" sm="3" class="py-1">
                <v-autocomplete v-model="filtro.sub_estado" :items="subEstadosFiltrados" item-value="id"
                  item-text="nombre" label="Sub-estado" clearable dense outlined hide-details />
              </v-col>
              <!-- <v-col cols="12" sm="2" class="py-1">
              <v-autocomplete v-model="filtro.tipo" :items="tipos" item-value="id" item-text="nombre" label="Tipo" clearable dense outlined hide-details @change="filtro.sub_estado = null" />
            </v-col> -->
              <v-col cols="12" sm="2" class="py-1">
                <v-autocomplete v-model="filtro.prioridad" :items="prioridades" item-value="id" item-text="nombre"
                  label="Prioridad" clearable dense outlined hide-details />
              </v-col>
              <!-- <v-col cols="12" sm="3" class="py-1">
              <v-autocomplete v-model="filtro.empresa" :items="empresas" item-value="Id" item-text="Nombre" label="Empresa" clearable dense outlined hide-details @change="filtro.sucursal = null" />
            </v-col> -->
              <v-col cols="12" sm="3" class="py-1">
                <v-autocomplete v-model="filtro.sucursal" :items="sucursalesFiltradas" item-value="Id"
                  item-text="Provincia" label="Sucursal" clearable dense outlined hide-details />
              </v-col>
              <v-col cols="12" sm="3" class="d-flex align-end ticket-finalizados-switch-col">
                <v-switch v-model="incluirFinalizados" label="Incluir finalizados" dense hide-details class="mt-0 ml-2 mb-4 pt-0 ticket-finalizados-switch" @change="buscar" />
              </v-col>

              <!-- Fechas -->
              <v-col cols="12">
                <v-switch v-model="usarRangoFechas" label="Filtrar por fechas" dense hide-details />
              </v-col>
              <template v-if="usarRangoFechas">
                <v-col cols="12" sm="3">
                  <FechaPicker v-model="filtro.fecha_creacion_desde" label="Creación desde" clearable hide-details />
                </v-col>
                <v-col cols="12" sm="3">
                  <FechaPicker v-model="filtro.fecha_creacion_hasta" label="Creación hasta" clearable hide-details />
                </v-col>
                <v-col cols="12" sm="3">
                  <FechaPicker v-model="filtro.fecha_finalizacion_desde" label="Finalización desde" clearable
                    hide-details />
                </v-col>
                <v-col cols="12" sm="3">
                  <FechaPicker v-model="filtro.fecha_finalizacion_hasta" label="Finalización hasta" clearable
                    hide-details />
                </v-col>
              </template>

              <BtnFiltro :loading="cargando" @clear="limpiarFiltros" />
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-expand-transition>

    <!-- Tabla con menú contextual -->
    <v-card v-if="!esModoReparacion0km" outlined class="mb-2">
      <v-tabs
        v-model="tabTipoIndex"
        show-arrows
        center-active
        @change="onChangeTabTipo"
      >
        <v-tab
          v-for="tipo in tiposTabs"
          :key="tipo.id"
        >
          {{ tipo.nombre }}
        </v-tab>
      </v-tabs>
    </v-card>

    <div @contextmenu.prevent="() => { }">
      <v-data-table v-model="selected" :single-select="true" :headers="headersTabla" :items="ticketsOrdenadosDesc" :search="search" :loading="cargando"
        item-key="id" class="elevation-1" dense :footer-props="{ 'items-per-page-options': [15, 30, 50] }"
        @click:row="rowClick" @contextmenu:row="abrirContextMenu">
        <template v-slot:top>
          <v-row class="d-flex justify-end pa-2" no-gutters>
            <v-col cols="6" sm="3" xl="3">
              <SearchDataTable v-model="search" />
            </v-col>
          </v-row>
        </template>
        <template #[`item.estado_nombre`]="{ item }">
          <v-chip small :color="colorEstado(item.estado_id)" dark>{{ item.estado_nombre }}</v-chip>
        </template>
        <template #[`item.prioridad_nombre`]="{ item }">
          <v-chip small :color="colorPrioridad(item.prioridad_id)" dark>{{ item.prioridad_nombre || '—' }}</v-chip>
        </template>
        <template #[`item.unidad_vin`]="{ item }">
          <v-tooltip v-if="vinTablaNecesitaTooltip(item)" bottom>
            <template #activator="{ on, attrs }">
              <span v-bind="attrs" class="vin-celda-tabla" v-on="on">{{ vinTablaCorto(item) }}</span>
            </template>
            <span>{{ vinTablaCompleto(item) }}</span>
          </v-tooltip>
          <span v-else class="vin-celda-tabla">{{ vinTablaCorto(item) }}</span>
        </template>
        <template #[`item.unidad_patente`]="{ item }">
          {{ item.unidad_patente || '—' }}
        </template>
        <template #[`item.nombre_cliente`]="{ item }">
          <v-tooltip v-if="nombreClienteNecesitaTooltip(item)" bottom>
            <template #activator="{ on, attrs }">
              <span v-bind="attrs" class="nombre-cliente-celda" v-on="on">{{ nombreClienteTruncado(item) }}</span>
            </template>
            <span>{{ nombreClienteCompleto(item) }}</span>
          </v-tooltip>
          <span v-else class="nombre-cliente-celda">{{ nombreClienteTruncado(item) }}</span>
        </template>
        <template #[`item.reparacion_realizada_primera_visita`]="{ item }">
          <div v-if="esTabReclamoGarantia" class="reparacion-1visita-group">
            <v-btn
              x-small
              rounded
              height="22"
              class="reparacion-1visita-btn"
              :class="{ 'reparacion-1visita-btn--active': valorReparacionActual(item) === 1 }"
              color="success"
              :outlined="valorReparacionActual(item) !== 1"
              :depressed="valorReparacionActual(item) === 1"
              :loading="guardandoReparacionPrimeraVisitaId === item.id"
              :disabled="esTicketFinalizado(item)"
              @click.stop="solicitarConfirmacionReparacionPrimeraVisita(item, 1)"
            >
              Sí
            </v-btn>
            <v-btn
              x-small
              rounded
              height="22"
              class="reparacion-1visita-btn"
              :class="{ 'reparacion-1visita-btn--active': valorReparacionActual(item) === 0 }"
              color="error"
              :outlined="valorReparacionActual(item) !== 0"
              :depressed="valorReparacionActual(item) === 0"
              :loading="guardandoReparacionPrimeraVisitaId === item.id"
              :disabled="esTicketFinalizado(item)"
              @click.stop="solicitarConfirmacionReparacionPrimeraVisita(item, 0)"
            >
              No
            </v-btn>
          </div>
          <span v-else>—</span>
        </template>
        <template #[`item.unidad_modelo_descripcion`]="{ item }">
          {{ item.unidad_modelo_descripcion || item.unidad_modelo_codigo || '—' }}
        </template>
        <template #[`item.unidad_color_descripcion`]="{ item }">
          {{ item.unidad_color_descripcion || '—' }}
        </template>
        <template #[`item.dias_desde_recepcion`]="{ item }">
          <v-tooltip v-if="item.fecha_de_recepcion" bottom>
            <template #activator="{ on, attrs }">
              <span v-bind="attrs" class="font-weight-medium" v-on="on">
                {{ antiguedadRecepcionTexto(item) }}
              </span>
            </template>
            <span>Recepción: {{ formatFecha(item.fecha_de_recepcion).split(' a las')[0] }}</span>
          </v-tooltip>
          <span v-else>—</span>
        </template>
        <template #[`item.memo_dano`]="{ item }">
          <v-btn icon small color="info" @click.stop="verMemoDano(item)">
            <v-icon small>fas fa-eye</v-icon>
          </v-btn>
        </template>
        <template #[`item.tiene_imagenes_por_vin`]="{ item }">
          <v-tooltip v-if="item.tiene_imagenes_por_vin" bottom>
            <template #activator="{ on, attrs }">
              <span v-bind="attrs" class="d-inline-flex align-center justify-center" v-on="on">
                <v-icon small color="success">fas fa-images</v-icon>
              </span>
            </template>
            <span>{{ tooltipTextoImagenesPorVin }}</span>
          </v-tooltip>
        </template>
        <template #[`item.fecha_creacion`]="{ item }">{{ formatFecha(item.fecha_creacion) }}</template>
        <template #[`item.fecha_finalizacion`]="{ item }">{{ item.fecha_finalizacion ?
          formatFecha(item.fecha_finalizacion) : '—' }}</template>
      </v-data-table>
    </div>

    <!-- DETALLE (igual lógica que ResolucionTickets.vue, sin expandible dentro de la fila) -->
    <v-expand-transition>
      <section id="detalle">
        <v-card v-if="selected.length > 0" class="ticket-detail-card my-3"
          :class="{ 'ticket-detail-card--dark': $vuetify.theme.dark }">
          <div class="ticket-detail-header">
            <div class="ticket-title-wrap">
              <div class="ticket-title-line">
                <span class="ticket-kicker">Ticket</span>
                <span class="ticket-number">#{{ selected[0].id }}</span>
                <v-chip x-small :color="colorEstado(ticketSeleccionado.estado_id)" dark class="ml-2">
                  {{ ticketSeleccionado.estado_nombre || 'Sin estado' }}
                </v-chip>
                <v-chip x-small :color="colorPrioridad(ticketSeleccionado.prioridad_id)" dark class="ml-1">
                  {{ ticketSeleccionado.prioridad_nombre || 'Sin prioridad' }}
                </v-chip>
              </div>
              <div class="ticket-subject">{{ selected[0].asunto || 'Sin asunto' }}</div>
            </div>
            <v-btn title="Cerrar detalle" icon class="detail-close-btn" @click="cerrarDetalle">
              <v-icon small>fas fa-times</v-icon>
            </v-btn>
          </div>

          <div class="ticket-meta-grid mb-4">
            <!-- <div class="meta-item">
              <div class="meta-label">Empresa</div>
              <div class="meta-value">{{ ticketSeleccionado.empresa_nombre || '—' }}</div>
            </div> -->
            <div class="meta-item">
              <div class="meta-label">Sucursal</div>
              <div class="meta-value">{{ sucursalNombreDetalleTicket || '—' }}</div>
            </div>
            <div class="meta-item" v-if="!esModoReparacion0km">
              <div class="meta-label">Tipo</div>
              <div class="meta-value">{{ ticketSeleccionado.tipo_nombre || '—' }}</div>
            </div>
            <div class="meta-item">
              <div class="meta-label">Subestado</div>
              <div class="meta-value">{{ ticketSeleccionado.sub_estado_nombre || '—' }}</div>
            </div>
            <div class="meta-item" v-if="esModoReparacion0km">
              <div class="meta-label">Estado</div>
              <div class="meta-value">{{ ticketSeleccionado.estado_nombre || '—' }}</div>
            </div>
            <div class="meta-item">
              <div class="meta-label">Modelo</div>
              <div class="meta-value">{{ ticketSeleccionado.unidad_modelo_descripcion ||
                ticketSeleccionado.unidad_modelo_codigo || '—' }}</div>
            </div>
            <div class="meta-item" v-if="esModoReparacion0km">
              <div class="meta-label">Color</div>
              <div class="meta-value">{{ ticketSeleccionado.unidad_color_descripcion || '—' }}</div>
            </div>
            <div class="meta-item">
              <div class="meta-label">VIN</div>
              <div class="meta-value">{{ ticketSeleccionado.unidad_vin || '—' }}</div>
            </div>
            <div class="meta-item" v-if="!esModoReparacion0km">
              <div class="meta-label">Titular</div>
              <div class="meta-value">{{ ticketSeleccionado.unidad_titular_nombre || '—' }}</div>
            </div>
            <div class="meta-item" v-if="esTicketDetalleReclamoGarantia && !esModoReparacion0km">
              <div class="meta-label">Mecánico</div>
              <div class="meta-value">{{ garantiasDetalleForm.mecanico_nombre || '—' }}</div>
            </div>
            <!-- <div class="meta-item"> -->
            <!-- <div class="meta-label">Solicitante</div>
              <div class="meta-value">{{ ticketSeleccionado.solicitante_nombre || '—' }}</div>
            </div> -->
            <!-- <div class="meta-item">
              <div class="meta-label">Asignado</div>
              <div class="meta-value">{{ ticketSeleccionado.usuario_asignado_nombre || '—' }}</div>
            </div> -->
          </div>

          <div v-if="!esTabReclamoGarantia" class="section-card mb-2">
            <div class="galeria-header">
              <div class="section-title mb-0">Imágenes recepcionadas (VIN)</div>
              <div class="d-flex align-center">
                <v-btn
                  small
                  outlined
                  color="warning"
                  class="mr-2"
                  :disabled="!puedeEditarGaleriaActual"
                  @click="abrirEditarGaleria('vin')"
                >
                  <v-icon left x-small>fas fa-edit</v-icon>
                  Editar imagenes
                </v-btn>
                <v-btn
                  small
                  outlined
                  color="primary"
                  class="galeria-download-all-btn"
                  :disabled="galeriaUnidadImagenes.length === 0"
                  @click="descargarTodasImagenesGaleria"
                >
                  <v-icon left x-small>fas fa-download</v-icon>
                  Descargar todas las imagenes
                </v-btn>
              </div>
            </div>
            <v-progress-linear v-if="galeriaUnidadCargando" indeterminate class="mb-2" />
            <div v-else-if="galeriaUnidadImagenes.length === 0" class="caption grey--text">
              Sin imágenes vinculadas por VIN.
            </div>
            <v-carousel
              v-else
              hide-delimiters
              height="180"
              show-arrows-on-hover
              class="mt-2 galeria-vin-carousel"
            >
              <v-carousel-item v-for="(grupo, idx) in galeriaUnidadChunks" :key="`grp-${idx}`">
                <div class="galeria-vin-grid">
                  <img
                    v-for="imgItem in grupo"
                    :key="imgItem.id"
                    :src="imgItem.url"
                    class="galeria-vin-img"
                    @click="openUnidadGaleriaImage(imgItem)"
                  >
                </div>
              </v-carousel-item>
            </v-carousel>
          </div>

          <v-row v-if="esModoReparacion0km" class="mb-2 memos-y-acciones-row" dense align="stretch">
            <v-col cols="12" md="7" class="pa-2 d-flex">
              <div class="section-card memos-panel flex-grow-1">
                <div class="section-title">Memos</div>
                <div v-if="memosFormateadosDetalle.length === 0" class="meta-value">—</div>
                <div v-else class="memos-list">
                  <div v-for="m in memosFormateadosDetalle" :key="m.id" class="memo-item">
                    <div class="memo-head">
                      <span class="memo-fecha">{{ m.fecha }}</span>
                    </div>
                    <div class="memo-body">{{ m.comentario }}</div>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="5" class="pa-2 d-flex">
              <AccionesRapidasPostventa
                v-if="ticketSeleccionado"
                class="flex-grow-1"
                :ticket="ticketSeleccionado"
                :estado-seleccionado="estadoSeleccionado"
                :prioridad-seleccionada.sync="prioridadSeleccionada"
                :sub-estado-seleccionado.sync="subEstadoSeleccionado"
                :estados="estados"
                :prioridades="prioridades"
                :sub-estados-disponibles="subEstadosFiltradosPorEstado(estadoSeleccionado || ticketSeleccionado.estado_id, ticketSeleccionado.tipo_ticket_id)"
                :hay-cambios="hayCambiosAccionesRapidas"
                :guardando="accionCargando"
                :mostrar-boton-guardar="false"
                @update:estadoSeleccionado="onEstadoSeleccionadoCambio"
                @guardar-cambios="guardarCambiosAccionesRapidas(ticketSeleccionado)"
              />
            </v-col>
          </v-row>

          <div v-if="esTabReclamoGarantia && !esModoReparacion0km" class="section-card mb-2">
            <div class="galeria-header">
              <div class="section-title mb-0">Evidencias de garantía (orden de servicio)</div>
              <div class="d-flex align-center">
                <v-btn
                  small
                  outlined
                  color="warning"
                  class="mr-2"
                  :disabled="!puedeEditarGaleriaActual"
                  @click="abrirEditarGaleria('garantia')"
                >
                  <v-icon left x-small>fas fa-edit</v-icon>
                  Editar imagenes
                </v-btn>
                <v-btn
                  small
                  outlined
                  color="primary"
                  class="galeria-download-all-btn"
                  :disabled="galeriaUnidadImagenesParaCarouselGarantia.length === 0"
                  @click="descargarTodasImagenesGaleria"
                >
                  <v-icon left x-small>fas fa-download</v-icon>
                  Descargar todas las imagenes
                </v-btn>
              </div>
            </div>
            <div class="caption mb-2"><strong>Orden de servicio:</strong> {{ galeriaGarantiasOrdenServicio || '—' }}</div>
            <v-progress-linear v-if="galeriaUnidadCargando" indeterminate class="mb-2" />
            <div v-else-if="galeriaUnidadImagenesParaCarouselGarantia.length === 0" class="caption grey--text">
              Sin imágenes en la galería principal (odómetro, VIN, fallas, etc.).
            </div>
            <v-carousel
              v-else
              hide-delimiters
              height="180"
              show-arrows-on-hover
              class="mt-2 galeria-vin-carousel"
            >
              <v-carousel-item v-for="(grupo, idx) in galeriaUnidadChunksGarantia" :key="`grg-${idx}`">
                <div class="galeria-vin-grid">
                  <img
                    v-for="imgItem in grupo"
                    :key="imgItem.id"
                    :src="imgItem.url"
                    class="galeria-vin-img"
                    @click="openUnidadGaleriaImage(imgItem)"
                  >
                </div>
              </v-carousel-item>
            </v-carousel>
            <v-divider class="my-3" />
            <div class="section-title mb-2">Repuestos</div>
            <div v-if="galeriaGarantiasRepuestos.length === 0" class="caption grey--text">Sin repuestos cargados.</div>
            <v-simple-table v-else dense>
              <template #default>
                <thead>
                  <tr>
                    <th>Número de parte</th>
                    <th class="text-right">Cantidad</th>
                    <th>Descripción</th>
                    <th class="text-right">Precio estimado (unit.)</th>
                    <th class="text-right">Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="rep in galeriaGarantiasRepuestos" :key="`rep-${rep.id}`">
                    <td>{{ rep.numero_parte || '—' }}</td>
                    <td class="text-right">{{ cantidadRepuestoGarantia(rep) }}</td>
                    <td>{{ rep.descripcion_repuesto || '—' }}</td>
                    <td class="text-right align-middle">
                      <v-text-field
                        v-model.number="rep.precio_estimado"
                        dense
                        outlined
                        hide-details
                        type="number"
                        min="0"
                        step="0.01"
                        class="repuesto-precio-input"
                        :disabled="guardandoRepuestosGarantiaBatch"
                      />
                    </td>
                    <td class="text-right">{{ formatCurrencyARS(subtotalRepuestoGarantia(rep)) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="mt-2 costo-final-garantias font-weight-bold info--text text-right">
              Costo final estimado: {{ formatCurrencyARS(costoFinalGarantias) }}
            </div>
          </div>

          <div v-if="esTabReclamoGarantia && !esModoReparacion0km" class="section-card mb-2">
            <div class="galeria-seccion-titulo-texto mb-2">
              Información de vehículo - histórico de transacción (GWM)
            </div>
            <div class="galeria-header">
              <v-spacer />
              <v-btn
                small
                outlined
                color="warning"
                class="flex-shrink-0"
                :disabled="!puedeEditarGaleriaActual"
                @click="abrirEditarGaleria('garantia', { soloHistoricoGwm: true })"
              >
                <v-icon left x-small>fas fa-edit</v-icon>
                Editar imágenes
              </v-btn>
            </div>
            <div
              v-if="galeriaHistoricoGwmItems.length === 0 && !puedeEditarGaleriaActual && historicoGwmDetallePendienteArchivos.length === 0"
              class="caption grey--text"
            >
              Sin prints cargados.
            </div>
            <div
              v-else-if="puedeEditarGaleriaActual || galeriaHistoricoGwmItems.length > 0 || historicoGwmDetallePendienteArchivos.length > 0"
              class="thumb-grid hist-gwm-detalle-thumb-grid"
            >
              <div v-for="imgItem in galeriaHistoricoGwmItems" :key="`hgwm-det-${imgItem.id}`" class="thumb-cell">
                <img
                  :src="imgItem.url || imgItem.archivo_url"
                  alt=""
                  @click="openUnidadGaleriaImage(imgItem)"
                >
                <v-btn
                  v-if="puedeEditarGaleriaActual"
                  icon
                  x-small
                  dark
                  class="thumb-remove"
                  aria-label="Quitar"
                  :disabled="guardandoHistoricoGwmDetalle"
                  @click.stop="eliminarHistoricoGwmDetalle(imgItem)"
                >
                  <v-icon x-small>fas fa-times</v-icon>
                </v-btn>
              </div>
              <div
                v-for="(previewUrl, pi) in historicoGwmDetallePendientePreviews"
                :key="`hgwm-pend-${pi}`"
                class="thumb-cell"
              >
                <img
                  :src="previewUrl"
                  alt=""
                  @click="openUnidadGaleriaImage({ url: previewUrl, tipo_archivo: 'HISTORICO_GWM', orden: pi + 1 })"
                >
                <div class="thumb-kind">Pendiente</div>
                <v-btn
                  v-if="puedeEditarGaleriaActual"
                  icon
                  x-small
                  dark
                  class="thumb-remove"
                  aria-label="Quitar de la selección"
                  :disabled="guardandoHistoricoGwmDetalle"
                  @click.stop="removeHistoricoGwmDetallePendiente(pi)"
                >
                  <v-icon x-small>fas fa-times</v-icon>
                </v-btn>
              </div>
              <button
                v-if="puedeEditarGaleriaActual"
                type="button"
                class="upload-placeholder upload-placeholder--hist-gwm"
                :disabled="guardandoHistoricoGwmDetalle"
                @click="$refs.inHistoricoGwmDetalle.click()"
              >
                <v-icon color="primary" size="64">fas fa-plus</v-icon>
                <span class="upload-hint">Tocá para agregar</span>
              </button>
            </div>
            <input
              ref="inHistoricoGwmDetalle"
              type="file"
              accept="image/*"
              multiple
              class="d-none"
              @change="onPickHistoricoGwmDetalle"
            >
            <div
              v-if="puedeEditarGaleriaActual && historicoGwmDetallePendienteArchivos.length > 0"
              class="d-flex flex-wrap align-center mt-2"
            >
              <v-btn
                small
                text
                :disabled="guardandoDetalleGarantia || guardandoHistoricoGwmDetalle"
                @click="limpiarHistoricoGwmDetallePendiente"
              >
                Descartar selección
              </v-btn>
              <span class="caption grey--text ml-2">Los prints pendientes se suben con «Guardar cambios» al final del ticket.</span>
            </div>
            <v-progress-linear v-if="guardandoHistoricoGwmDetalle" indeterminate class="mt-2" />

            <v-divider class="my-4" />
            <div class="galeria-seccion-titulo-texto mb-2">
              Información del caso – consulta CAT/diagnostico o sugerencia (En caso que aplique)
            </div>
            <div class="galeria-header">
              <v-spacer />
              <v-btn
                small
                outlined
                color="warning"
                class="flex-shrink-0"
                :disabled="!puedeEditarGaleriaActual"
                @click="abrirEditarGaleria('garantia', { soloCatConsulta: true })"
              >
                <v-icon left x-small>fas fa-edit</v-icon>
                Editar imágenes
              </v-btn>
            </div>
            <div
              v-if="galeriaCatItems.length === 0 && !puedeEditarGaleriaActual && catDetallePendienteArchivos.length === 0"
              class="caption grey--text"
            >
              Sin imágenes cargadas.
            </div>
            <div
              v-else-if="puedeEditarGaleriaActual || galeriaCatItems.length > 0 || catDetallePendienteArchivos.length > 0"
              class="thumb-grid hist-gwm-detalle-thumb-grid"
            >
              <div v-for="imgItem in galeriaCatItems" :key="`cat-det-${imgItem.id}`" class="thumb-cell">
                <img
                  :src="imgItem.url || imgItem.archivo_url"
                  alt=""
                  @click="openUnidadGaleriaImage(imgItem)"
                >
                <v-btn
                  v-if="puedeEditarGaleriaActual"
                  icon
                  x-small
                  dark
                  class="thumb-remove"
                  aria-label="Quitar"
                  :disabled="guardandoCatDetalle"
                  @click.stop="eliminarCatDetalle(imgItem)"
                >
                  <v-icon x-small>fas fa-times</v-icon>
                </v-btn>
              </div>
              <div
                v-for="(previewUrl, pi) in catDetallePendientePreviews"
                :key="`cat-pend-${pi}`"
                class="thumb-cell"
              >
                <img
                  :src="previewUrl"
                  alt=""
                  @click="openUnidadGaleriaImage({ url: previewUrl, tipo_archivo: 'CONSULTA_CAT', orden: pi + 1 })"
                >
                <div class="thumb-kind">Pendiente</div>
                <v-btn
                  v-if="puedeEditarGaleriaActual"
                  icon
                  x-small
                  dark
                  class="thumb-remove"
                  aria-label="Quitar de la selección"
                  :disabled="guardandoCatDetalle"
                  @click.stop="removeCatDetallePendiente(pi)"
                >
                  <v-icon x-small>fas fa-times</v-icon>
                </v-btn>
              </div>
              <button
                v-if="puedeEditarGaleriaActual"
                type="button"
                class="upload-placeholder upload-placeholder--hist-gwm"
                :disabled="guardandoCatDetalle"
                @click="$refs.inCatDetalle.click()"
              >
                <v-icon color="primary" size="64">fas fa-plus</v-icon>
                <span class="upload-hint">Tocá para agregar</span>
              </button>
            </div>
            <input
              ref="inCatDetalle"
              type="file"
              accept="image/*"
              multiple
              class="d-none"
              @change="onPickCatDetalle"
            >
            <div
              v-if="puedeEditarGaleriaActual && catDetallePendienteArchivos.length > 0"
              class="d-flex flex-wrap align-center mt-2"
            >
              <v-btn
                small
                text
                :disabled="guardandoDetalleGarantia || guardandoCatDetalle"
                @click="limpiarCatDetallePendiente"
              >
                Descartar selección
              </v-btn>
              <span class="caption grey--text ml-2">Las imágenes pendientes se suben con «Guardar cambios» al final del ticket.</span>
            </div>
            <v-progress-linear v-if="guardandoCatDetalle" indeterminate class="mt-2" />
          </div>

          <div v-if="esTabReclamoGarantia && !esModoReparacion0km" class="section-card mb-2">
            <div class="section-title d-flex align-center">
              Detalle técnico de garantía
            </div>
            <v-row dense>
              <v-col cols="12" md="6">
                <v-textarea
                  :value="garantiasDetalleForm.encabezado_incidente_cliente || ''"
                  label="Incidente cliente"
                  outlined
                  dense
                  readonly
                  hide-details
                  rows="3"
                  auto-grow
                  no-resize
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-textarea
                  :value="garantiasDetalleForm.encabezado_resultado_tecnico || ''"
                  label="Resultado técnico"
                  outlined
                  dense
                  readonly
                  hide-details
                  rows="3"
                  auto-grow
                  no-resize
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="garantiasDetalleForm.resumen_diagnostico"
                  label="Resumen del diagnóstico / descripción del caso"
                  outlined
                  rows="3"
                  auto-grow
                  autocomplete="off"
                  @input="resumenDiagnosticoTocado = true"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="garantiasDetalleForm.horas_mo"
                  label="HORAS MO"
                  outlined
                  dense
                  hide-details
                  type="number"
                  step="0.1"
                  min="0"
                  autocomplete="off"
                  placeholder="Ej. 1.5"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="garantiasDetalleForm.codigo_mo"
                  label="CODIGO MO"
                  outlined
                  dense
                  hide-details
                  maxlength="50"
                  counter="50"
                  autocomplete="off"
                />
              </v-col>
            </v-row>
          </div>

          <v-row class="ticket-sections" dense>
            <!-- Descripción + info -->
            <v-col v-if="!esModoReparacion0km" cols="12" md="4" class="pa-2">
              <div class="section-card">
                <div class="section-title">Descripción</div>
                <div class="section-description">{{ descripcionFormateada(ticketSeleccionado.descripcion) }}
                </div>
                <div class="finalizado-por mt-3">
                  <span class="meta-label">Finalizado por:</span>
                  <span class="meta-value">{{ ticketSeleccionado.usuario_finalizacion_nombre || '—' }}</span>
                </div>
              </div>
            </v-col>

            <v-col v-if="!esModoReparacion0km" cols="12" md="3" class="pa-2 d-flex">
              <AccionesRapidasPostventa
                v-if="ticketSeleccionado"
                class="flex-grow-1"
                style="width: 100%;"
                :ticket="ticketSeleccionado"
                :estado-seleccionado="estadoSeleccionado"
                :prioridad-seleccionada.sync="prioridadSeleccionada"
                :sub-estado-seleccionado.sync="subEstadoSeleccionado"
                :estados="estados"
                :prioridades="prioridades"
                :sub-estados-disponibles="subEstadosFiltradosPorEstado(estadoSeleccionado || ticketSeleccionado.estado_id, ticketSeleccionado.tipo_ticket_id)"
                :hay-cambios="hayCambiosAccionesRapidas"
                :guardando="accionCargando"
                :mostrar-boton-guardar="false"
                @update:estadoSeleccionado="onEstadoSeleccionadoCambio"
                @guardar-cambios="guardarCambiosAccionesRapidas(ticketSeleccionado)"
              />
            </v-col>

            <!-- Comentarios (siempre al final) -->
            <v-col cols="12" :md="esModoReparacion0km ? 12 : 5" class="pa-2">
              <div class="section-card">
                <div class="section-title">Comentarios</div>
                <v-progress-linear v-if="comentariosCargando" indeterminate />
                <div v-else-if="comentariosDelTicket.length === 0" class="caption grey--text">Sin comentarios.</div>
                <div v-else class="comentarios-container">
                  <div v-for="c in comentariosDelTicket" :key="c.id" class="comment-item">
                    <div class="comment-header">
                      <v-chip x-small color="blue-grey" dark class="mr-1">{{ c.usuario_nombre }}</v-chip>
                      <span class="caption grey--text">{{ formatFecha(c.fecha_creacion) }}</span>
                      <v-chip v-if="c.es_comentario_interno" x-small color="orange" dark class="ml-1">Interno</v-chip>
                    </div>
                    <div class="body-2 mt-1 comment-body-html" v-html="comentarioHtmlConMenciones(c.comentario)" />
                    <div v-if="archivosPorComentario(c.id).length > 0" class="mt-1">
                      <v-chip v-for="arch in archivosPorComentario(c.id)" :key="arch.id" x-small outlined
                        @click="verArchivoComentario(arch)" class="mr-1 mt-1">
                        <v-icon x-small left>fas fa-paperclip</v-icon>{{ arch.extension_archivo }}
                      </v-chip>
                    </div>
                  </div>
                </div>

                <!-- Nuevo comentario -->
                <div class="mt-3 comment-composer">
                  <CommentComposerMentions
                    ref="composerMenciones"
                    v-model="nuevoComentarioTexto"
                    :roles="rolesMencionesComentario"
                    :smtp-profile="smtpProfileMencionesComentario"
                    :disabled="ticketSeleccionadoFinalizado"
                  />
                  <v-row dense class="mt-1" align="center">
                    <v-col cols="12" sm="4">
                      <v-switch v-if="esRol56" v-model="esComentarioInterno" label="Interno" dense hide-details class="mt-0" :disabled="ticketSeleccionadoFinalizado" />
                    </v-col>
                    <v-col cols="12" sm="8">
                      <v-file-input v-model="archivosSeleccionados" multiple prepend-icon="fas fa-paperclip" dense
                        outlined hide-details label="Adjuntar" :disabled="ticketSeleccionadoFinalizado" />
                    </v-col>
                  </v-row>
                  <div class="caption grey--text mt-1">
                    El comentario y los adjuntos se envían con «Guardar cambios» al final del ticket.
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>

          <div v-if="ticketSeleccionado" class="ticket-guardar-cambios-bar text-right pt-4 pb-2 px-2 d-flex flex-wrap justify-end align-center">
            <v-btn
              v-if="puedeMostrarBotonProformaGarantia"
              outlined
              color="primary"
              class="action-btn action-btn--icon-label mr-2 mb-1"
              :disabled="!puedeGenerarProformaGarantia"
              @click="abrirDialogProformaGarantia"
            >
              <span class="action-btn__icon-label">
                <v-icon small class="action-btn__leading-icon">fas fa-file-pdf</v-icon>
                <span>Generar Pro forma – Archivo único</span>
              </span>
            </v-btn>
            <v-btn
              v-if="puedeVerProformaPdfGenerado"
              outlined
              color="primary"
              class="action-btn action-btn--icon-label mr-2 mb-1"
              @click="verProformaPdfGenerado"
            >
              <span class="action-btn__icon-label">
                <v-icon small class="action-btn__leading-icon">fas fa-eye</v-icon>
                <span>Ver PDF generado</span>
              </span>
            </v-btn>
            <v-btn
              color="primary"
              depressed
              class="action-btn mb-1"
              :loading="guardandoDetalleGarantia || guardandoRepuestosGarantiaBatch || guardandoHistoricoGwmDetalle || guardandoCatDetalle || accionCargando || enviandoComentario"
              :disabled="deshabilitarGuardarCambiosInferior"
              @click="guardarCambiosInferior"
            >
              Guardar cambios
            </v-btn>
          </div>
        </v-card>
      </section>
    </v-expand-transition>

    <!-- Menú contextual -->
    <v-menu v-model="contextMenu.show" :position-x="contextMenu.x" :position-y="contextMenu.y" absolute offset-y>
      <v-list dense>
        <!-- <v-list-item @click="abrirAsignar(contextMenu.item)" v-if="contextMenu.item && contextMenu.item.estado_id !== 3">
          <v-list-item-icon><v-icon small>fas fa-user-plus</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Asignar</v-list-item-title></v-list-item-content>
        </v-list-item> -->
        <v-list-item
          @click="confirmarFinalizar(contextMenu.item)"
          v-if="contextMenu.item && contextMenu.item.estado_id !== 3 && puedeFinalizarTicket(contextMenu.item)"
        >
          <v-list-item-icon><v-icon small>fas fa-check-circle</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Finalizar</v-list-item-title></v-list-item-content>
        </v-list-item>
        <v-list-item @click="abrirDialogPrioridad(contextMenu.item)" v-if="contextMenu.item && contextMenu.item.estado_id !== 3">
          <v-list-item-icon><v-icon small>fas fa-flag</v-icon></v-list-item-icon>
          <v-list-item-content><v-list-item-title>Cambiar prioridad</v-list-item-title></v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Dialog Asignar -->
    <v-dialog v-model="dialogAsignar" max-width="480" persistent>
      <v-card>
        <v-card-title>Asignar Ticket #{{ ticketSeleccionado && ticketSeleccionado.id }}</v-card-title>
        <v-card-text>
          <v-autocomplete v-model="asignarForm.usuario_asignado" :items="usuariosAsignables" item-value="Usuario_id"
            :item-text="u => `${u.Apellido}, ${u.Nombre}`" label="Usuario asignado *" outlined dense />
          <v-autocomplete v-model="asignarForm.estado_id" :items="estados" item-value="id" item-text="nombre"
            label="Estado *" outlined dense hide-no-data />
          <v-autocomplete v-model="asignarForm.sub_estado_id"
            :items="subEstadosFiltradosPorEstado(asignarForm.estado_id, ticketSeleccionado?.tipo_ticket_id)"
            item-value="id" item-text="nombre" label="Sub-estado" clearable outlined dense hide-no-data />
          <v-autocomplete v-model="asignarForm.prioridad_id" :items="prioridades" item-value="id" item-text="nombre"
            label="Prioridad *" outlined dense hide-no-data />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogAsignar = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="accionCargando" @click="ejecutarAsignar">Asignar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Nuevo Ticket -->
    <v-dialog v-model="dialogNuevoTicket" max-width="700" persistent>
      <v-card>
        <v-card-title class="pb-2">
          <v-icon left>fas fa-ticket-alt</v-icon>{{ tituloDialogNuevoTicket }}
          <v-spacer />
          <v-btn icon @click="dialogNuevoTicket = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-6">
          <v-form ref="formNuevo" v-model="formValido">
            <v-row dense>
              <v-col v-if="esTabReclamoGarantia || esTabReclamoTransporte || esModoReparacion0km" cols="12">
                <v-text-field
                  :value="tipoNuevoTicketLabel"
                  label="Tipo"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="nuevoTicketForm.numero_orden"
                  label="Numero de Orden *"
                  :rules="[v => !!v || 'Campo requerido', v => Number(v) > 0 || 'Debe ser mayor a 0']"
                  :loading="cargandoContextoNuevoTicket"
                  type="number"
                  min="1"
                  outlined
                  dense
                  @change="autocompletarNuevoTicketDesdeOrden"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="nuevoTicketForm.asunto" label="Asunto *" :rules="[v => !!v || 'Campo requerido']"
                  :loading="cargandoContextoNuevoTicket" outlined dense />
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="nuevoTicketForm.descripcion" label="Descripción" :loading="cargandoContextoNuevoTicket"
                  outlined dense rows="3" />
              </v-col>
              <v-col v-if="mostrarSelectorUsuarioAsignadoNuevoTicket" cols="12" sm="12">
                <v-autocomplete v-model="nuevoTicketForm.usuario_asignado" :items="usuariosAsignablesNuevoTicket"
                  item-value="Usuario_id" :item-text="u => `${u.Apellido}, ${u.Nombre}`" label="Usuario asignado"
                  :rules="[reglaUsuarioAsignadoRequerido]"
                  :loading="cargandoUsuariosAsignablesGarantias"
                  clearable outlined dense />
              </v-col>
              <v-col cols="12" sm="6">
                <v-autocomplete v-model="nuevoTicketForm.empresa" :items="empresas" item-value="Id" item-text="Nombre"
                  label="Empresa *" :rules="[v => !!v || 'Campo requerido']" outlined dense hide-no-data
                  @change="nuevoTicketForm.sucursal = null" />
              </v-col>
              <v-col cols="12" sm="6">
                <v-autocomplete v-model="nuevoTicketForm.sucursal" :items="sucursalesNuevoTicket" item-value="Id"
                  item-text="Provincia" label="Sucursal *" :rules="[v => !!v || 'Campo requerido']" outlined dense
                  hide-no-data />
              </v-col>
              <v-col cols="12" sm="4">
                <v-autocomplete v-model="nuevoTicketForm.prioridad_id" :items="prioridades" item-value="id"
                  item-text="nombre" label="Prioridad *" :rules="[v => !!v || 'Campo requerido']" outlined dense
                  hide-no-data />
              </v-col>
              <v-col cols="12">
                <v-file-input v-model="archivosNuevoTicket" label="Adjuntar archivos" multiple
                  prepend-icon="fas fa-paperclip" outlined dense />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text :disabled="creandoTicket" @click="dialogNuevoTicket = false">Cerrar</v-btn>
          <v-btn color="primary" :loading="creandoTicket" :disabled="!formValido" @click="crearTicket">Crear
            ticket</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Alertas Daños -->
    <v-dialog v-model="dialogAlertas" max-width="700">
      <v-card>
        <v-card-title>Alertas de Unidades Dañadas</v-card-title>
        <v-card-text>
          <v-data-table :headers="headersAlertas" :items="alertasDanos" dense hide-default-footer :items-per-page="-1">
            <template #[`item.fecha_alta`]="{ item }">{{ formatFecha(item.fecha_alta) }}</template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer /><v-btn text @click="dialogAlertas = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Gestión de Sub-estados -->
    <v-dialog v-model="dialogGestionSubEstados" max-width="840" v-if="esRol56">
      <v-card>
        <v-card-title class="pb-2">
          Gestionar sub-estados
          <v-spacer />
          <v-btn icon @click="dialogGestionSubEstados = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-6">
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-autocomplete v-model="subEstadoNuevo.estado_id_padre" :items="estados" item-value="id"
                item-text="nombre" label="Estado *" dense outlined hide-details />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete v-model="subEstadoNuevo.tipo_ticket_id" :items="tipos" item-value="id" item-text="nombre"
                label="Tipo *" dense outlined hide-details />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model.trim="subEstadoNuevo.nombre" label="Nuevo sub-estado *" dense outlined
                hide-details />
            </v-col>
            <v-col cols="12" sm="2" class="d-flex align-center justify-end">
              <v-btn color="success" small block @click="crearSubEstado" :loading="guardandoSubEstado">
                Alta
              </v-btn>
            </v-col>

            <v-col cols="12" class="py-0 mt-5"></v-col>
            <v-col cols="12" sm="6" class="mt-2">
              <v-autocomplete v-model="filtroEstadoGestion" :items="estados" item-value="id" item-text="nombre"
                label="Filtrar por estado" clearable dense outlined hide-details />
            </v-col>
            <v-col cols="12" sm="6" class="mt-2">
              <v-autocomplete v-model="filtroTipoGestion" :items="tipos" item-value="id" item-text="nombre"
                label="Filtrar por tipo" clearable dense outlined hide-details />
            </v-col>
            <v-col cols="12">
              <v-data-table :headers="headersSubEstadosGestion" :items="subEstadosGestionFiltrados" dense
                :items-per-page="8">
                <template #[`item.estado_id_padre`]="{ item }">
                  {{ nombreEstado(item.estado_id_padre) }}
                </template>
                <template #[`item.tipo_ticket_id`]="{ item }">
                  {{ nombreTipo(item.tipo_ticket_id) }}
                </template>
                <template #[`item.activo`]="{ item }">
                  <v-chip x-small :color="Number(item.activo) === 0 ? 'warning' : 'success'" dark>
                    {{ Number(item.activo) === 0 ? 'INACTIVO' : 'ACTIVO' }}
                  </v-chip>
                </template>
                <template #[`item.acciones`]="{ item }">
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn x-small icon color="info" v-bind="attrs" v-on="on" @click="abrirEditarSubEstado(item)">
                        <v-icon small>fas fa-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>

                  <v-tooltip v-if="Number(item.activo) !== 0" bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn x-small icon color="warning" v-bind="attrs" v-on="on"
                        :loading="subEstadoBajandoId === item.id" @click="darBajaSubEstado(item)">
                        <v-icon small>fas fa-ban</v-icon>
                      </v-btn>
                    </template>
                    <span>Dar de baja</span>
                  </v-tooltip>

                  <v-tooltip v-else bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn x-small icon color="success" v-bind="attrs" v-on="on"
                        :loading="subEstadoAltaId === item.id" @click="darAltaSubEstado(item)">
                        <v-icon small>fas fa-check</v-icon>
                      </v-btn>
                    </template>
                    <span>Dar de alta</span>
                  </v-tooltip>
<!-- 
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn x-small icon color="error" v-bind="attrs" v-on="on"
                        :loading="subEstadoEliminandoId === item.id" @click="confirmarEliminarSubEstado(item)">
                        <v-icon small>fas fa-trash</v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar definitivamente</span>
                  </v-tooltip> -->
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogGestionDestinatariosReparacion" max-width="840" v-if="puedeGestionarDestinatariosReparacion && esModoReparacion0km">
      <v-card>
        <v-card-title class="dialog-title-closable pb-2">
          <span class="dialog-title-text">Destinatarios de alertas de reparación</span>
          <v-spacer />
          <v-btn icon class="ml-2" aria-label="Cerrar" @click="dialogGestionDestinatariosReparacion = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-6">
          <v-alert dense outlined type="info" class="mb-4">
            Gestioná listas separadas por tipo de alerta. Cada destinatario recibe solo el aviso del tipo seleccionado.
          </v-alert>
          <v-row dense>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="destinatarioEmpresaId"
                :items="empresas"
                item-value="Id"
                item-text="Nombre"
                label="Empresa *"
                dense
                outlined
                hide-details
                @change="cargarDestinatariosReparacion"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="destinatarioTipoAlerta"
                :items="tiposDestinatarioAlertaOptions"
                item-value="value"
                item-text="text"
                label="Tipo de alerta *"
                dense
                outlined
                hide-details
                @change="cargarDestinatariosReparacion"
              />
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model.trim="destinatarioNuevoEmail"
                label="Email *"
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="2" class="d-flex align-center justify-end">
              <v-btn color="success" small block :loading="guardandoDestinatarioReparacion" @click="crearDestinatarioReparacion">
                Alta
              </v-btn>
            </v-col>

            <v-col cols="12" class="mt-4">
              <v-data-table
                :headers="headersDestinatariosReparacion"
                :items="destinatariosReparacionFiltrados"
                dense
                :items-per-page="8"
                :loading="cargandoDestinatariosReparacion"
              >
                <template #[`item.activo`]="{ item }">
                  <v-chip x-small :color="Number(item.activo) === 0 ? 'warning' : 'success'" dark>
                    {{ Number(item.activo) === 0 ? 'INACTIVO' : 'ACTIVO' }}
                  </v-chip>
                </template>
                <template #[`item.tipo_alerta`]="{ item }">
                  {{ tipoAlertaDestinatarioTexto(item.tipo_alerta) }}
                </template>
                <template #[`item.acciones`]="{ item }">
                  <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn x-small icon color="info" v-bind="attrs" v-on="on" @click="abrirEditarDestinatarioReparacion(item)">
                        <v-icon small>fas fa-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>

                  <v-tooltip v-if="Number(item.activo) !== 0" bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn
                        x-small
                        icon
                        color="warning"
                        v-bind="attrs"
                        v-on="on"
                        :loading="destinatarioReparacionBajandoId === item.id"
                        @click="darBajaDestinatarioReparacion(item)"
                      >
                        <v-icon small>fas fa-ban</v-icon>
                      </v-btn>
                    </template>
                    <span>Dar de baja</span>
                  </v-tooltip>

                  <v-tooltip v-else bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn
                        x-small
                        icon
                        color="success"
                        v-bind="attrs"
                        v-on="on"
                        :loading="destinatarioReparacionAltaId === item.id"
                        @click="darAltaDestinatarioReparacion(item)"
                      >
                        <v-icon small>fas fa-check</v-icon>
                      </v-btn>
                    </template>
                    <span>Dar de alta</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Confirm Finalizar -->
    <v-dialog v-model="dialogConfirm.show" max-width="360">
      <v-card>
        <v-card-title>{{ dialogConfirm.titulo }}</v-card-title>
        <v-card-text>{{ dialogConfirm.texto }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogConfirm.show = false">Cancelar</v-btn>
          <v-btn :color="dialogConfirm.color || 'primary'" :loading="accionCargando"
            @click="dialogConfirm.accion">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPrioridad" max-width="430">
      <v-card>
        <v-card-title>Cambiar prioridad</v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="prioridadSeleccionadaDialog"
            :items="prioridades"
            item-value="id"
            item-text="nombre"
            label="Prioridad"
            clearable
            outlined
            dense
            hide-no-data
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogPrioridad = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="accionCargando" :disabled="!prioridadSeleccionadaDialog" @click="guardarPrioridadDesdeDialog">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditarSubEstado" max-width="560">
      <v-card>
        <v-card-title class="pb-2">
          Editar sub-estado
          <v-spacer />
          <v-btn icon @click="cerrarEditarSubEstado">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-5">
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-autocomplete v-model="subEstadoEditar.estado_id_padre" :items="estados" item-value="id" item-text="nombre"
                label="Estado *" dense outlined hide-details />
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete v-model="subEstadoEditar.tipo_ticket_id" :items="tipos" item-value="id" item-text="nombre"
                label="Tipo *" dense outlined hide-details />
            </v-col>
            <v-col cols="12">
              <v-text-field v-model.trim="subEstadoEditar.nombre" label="Nombre sub-estado *" dense outlined hide-details />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarEditarSubEstado">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardandoEdicionSubEstado" @click="guardarEdicionSubEstado">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditarDestinatarioReparacion" max-width="560">
      <v-card>
        <v-card-title class="dialog-title-closable pb-2">
          <span class="dialog-title-text">Editar destinatario de alertas de reparación</span>
          <v-spacer />
          <v-btn icon class="ml-2" aria-label="Cerrar" @click="cerrarEditarDestinatarioReparacion">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-5">
          <v-row dense>
            <v-col cols="12">
              <v-autocomplete
                v-model="destinatarioReparacionEditar.empresa_id"
                :items="empresas"
                item-value="Id"
                item-text="Nombre"
                label="Empresa *"
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="destinatarioReparacionEditar.tipo_alerta"
                :items="tiposDestinatarioAlertaOptions"
                item-value="value"
                item-text="text"
                label="Tipo de alerta *"
                dense
                outlined
                hide-details
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model.trim="destinatarioReparacionEditar.email"
                label="Email *"
                dense
                outlined
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarEditarDestinatarioReparacion">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardandoEdicionDestinatarioReparacion" @click="guardarEdicionDestinatarioReparacion">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.value" :color="snackbar.color" bottom :timeout="3500">
      {{ snackbar.text }}
      <template #action><v-btn text @click="snackbar.value = false">Cerrar</v-btn></template>
    </v-snackbar>
    <v-dialog v-model="dialog_galeria_img" max-width="980">
      <v-card>
        <v-card-title class="d-flex align-center">
          <span class="text-truncate">{{ nombre_ver || 'Imagen' }}</span>
          <v-spacer />
          <v-btn
            small
            outlined
            color="primary"
            class="mr-2"
            :disabled="!galeriaImagenActualUrl"
            @click="descargarImagenActualGaleria"
          >
            <v-icon left x-small>fas fa-download</v-icon>
            Descargar
          </v-btn>
          <v-btn icon @click="dialog_galeria_img = false">
            <v-icon small>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-3">
          <img v-if="galeriaImagenActualUrl" :src="galeriaImagenActualUrl" class="galeria-dialog-img">
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEditarGaleria" max-width="1040">
      <v-card>
        <v-card-title class="pb-2">
          {{ tituloDialogEditarGaleria }}
          <v-spacer />
          <v-btn icon @click="cerrarEditarGaleria">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-5">
          <div class="caption mb-3">
            <strong>Contexto:</strong> {{ editGaleriaContextoLabel }}
          </div>
          <v-text-field
            v-if="editGaleriaTipo === 'transporte'"
            v-model="editGaleriaForm.vin_ultimos_6"
            label="Últimos 6 caracteres del VIN"
            maxlength="6"
            outlined
            dense
            class="mb-3"
            @input="editGaleriaForm.vin_ultimos_6 = String(editGaleriaForm.vin_ultimos_6 || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 6)"
          />
          <template v-if="editGaleriaTipo === 'garantia'">
          <template v-if="!editGaleriaSoloHistoricoGwm && !editGaleriaSoloCatConsulta">
          <div class="field-label">Foto parte implicada en la falla</div>
          <div class="thumb-grid mb-3">
            <div v-for="a in getEditGaleriaFallasActivas()" :key="`egf-${a.id}`" class="thumb-cell">
              <img :src="a.archivo_url" alt="" @click="openUnidadGaleriaImage(a)">
              <div class="thumb-kind">{{ tipoArchivoLabel(a.tipo_archivo, a.orden) }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="eliminarArchivoExistenteGaleria(a.id)">
                ELIMINAR
              </v-btn>
            </div>
            <div v-for="(url, i) in editGaleriaForm.previewNuevosFalla" :key="`newf-${i}`" class="thumb-cell">
              <img :src="url" alt="">
              <div class="thumb-kind">Falla nueva #{{ i + 1 }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="removeEditFallaNuevo(i)">
                ELIMINAR
              </v-btn>
            </div>
            <button type="button" class="thumb-add" @click="$refs.inEditFallasGaleria.click()">
              <span>+</span>
            </button>
          </div>
          <input ref="inEditFallasGaleria" type="file" accept="image/*" multiple class="d-none" @change="onPickEditFallasGaleria">

          <v-row dense class="mb-1">
            <v-col cols="12" md="6">
              <img
                class="galeria-banner-titulo mb-2"
                :src="postventaPublicAsset('odometro.png')"
                alt="Odómetro"
              >
              <div class="thumb-grid mb-3">
                <div v-if="editPreviewSingleUrl('ODOMETRO')" class="thumb-cell">
                  <img :src="editPreviewSingleUrl('ODOMETRO')" alt="">
                  <div class="thumb-kind">{{ editGaleriaForm.previewNuevoOdometro ? 'Odómetro nuevo' : 'Odómetro' }}</div>
                  <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingleGaleria('ODOMETRO')">
                    ELIMINAR
                  </v-btn>
                </div>
                <button v-else type="button" class="thumb-add" @click="$refs.inEditOdometroGaleria.click()">
                  <span>+</span>
                </button>
              </div>
              <input ref="inEditOdometroGaleria" type="file" accept="image/*" class="d-none" @change="onPickEditSingleGaleria($event, 'ODOMETRO')">
            </v-col>
            <v-col cols="12" md="6">
              <img
                class="galeria-banner-titulo mb-2"
                :src="postventaPublicAsset('imagen_de_vin.png')"
                alt="Imagen de VIN"
              >
              <div class="thumb-grid mb-3">
                <div v-if="editPreviewSingleUrl('VIN')" class="thumb-cell">
                  <img :src="editPreviewSingleUrl('VIN')" alt="">
                  <div class="thumb-kind">{{ editGaleriaForm.previewNuevoVin ? 'VIN nuevo' : 'VIN' }}</div>
                  <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingleGaleria('VIN')">
                    ELIMINAR
                  </v-btn>
                </div>
                <button v-else type="button" class="thumb-add" @click="$refs.inEditVinGaleria.click()">
                  <span>+</span>
                </button>
              </div>
              <input ref="inEditVinGaleria" type="file" accept="image/*" class="d-none" @change="onPickEditSingleGaleria($event, 'VIN')">
            </v-col>
          </v-row>

          <div class="galeria-seccion-titulo-texto mb-2">
            Información del caso – consulta CAT/diagnostico o sugerencia (En caso que aplique)
          </div>
          <div class="thumb-grid mb-3">
            <div v-for="a in getEditGaleriaCatsActivos()" :key="`egc-${a.id}`" class="thumb-cell">
              <img :src="a.archivo_url" alt="" @click="openUnidadGaleriaImage(a)">
              <div class="thumb-kind">{{ tipoArchivoLabel(a.tipo_archivo, a.orden) }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="eliminarArchivoExistenteGaleria(a.id)">
                ELIMINAR
              </v-btn>
            </div>
            <div v-for="(url, i) in editGaleriaForm.previewNuevosCat" :key="`newc-${i}`" class="thumb-cell">
              <img :src="url" alt="">
              <div class="thumb-kind">CAT nuevo #{{ i + 1 }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="removeEditCatNuevo(i)">
                ELIMINAR
              </v-btn>
            </div>
            <button type="button" class="thumb-add" @click="$refs.inEditCatGaleria.click()">
              <span>+</span>
            </button>
          </div>
          <input ref="inEditCatGaleria" type="file" accept="image/*" multiple class="d-none" @change="onPickEditCatGaleria">
          </template>

          <template v-if="editGaleriaSoloHistoricoGwm">
          <div class="galeria-seccion-titulo-texto mb-2">
            Información de vehículo - histórico de transacción (GWM)
          </div>
          <div class="thumb-grid mb-3">
            <div v-for="a in getEditGaleriaHistoricoGwmActivos()" :key="`eghg-${a.id}`" class="thumb-cell">
              <img :src="a.archivo_url" alt="" @click="openUnidadGaleriaImage(a)">
              <div class="thumb-kind">{{ tipoArchivoLabel(a.tipo_archivo, a.orden) }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="eliminarArchivoExistenteGaleria(a.id)">
                ELIMINAR
              </v-btn>
            </div>
            <div v-for="(url, i) in editGaleriaForm.previewNuevosHistoricoGwm" :key="`newhg-${i}`" class="thumb-cell">
              <img :src="url" alt="">
              <div class="thumb-kind">Historico GWM nuevo #{{ i + 1 }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="removeEditHistoricoGwmNuevo(i)">
                ELIMINAR
              </v-btn>
            </div>
            <button type="button" class="upload-placeholder upload-placeholder--hist-gwm" @click="$refs.inEditHistoricoGwmGaleria.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
              <span class="upload-hint">Tocá para agregar</span>
            </button>
          </div>
          <input ref="inEditHistoricoGwmGaleria" type="file" accept="image/*" multiple class="d-none" @change="onPickEditHistoricoGwmGaleria">
          </template>

          <template v-if="editGaleriaSoloCatConsulta">
          <div class="galeria-seccion-titulo-texto mb-2">
            Información del caso – consulta CAT/diagnostico o sugerencia (En caso que aplique)
          </div>
          <div class="thumb-grid mb-3">
            <div v-for="a in getEditGaleriaCatsActivos()" :key="`egc-solo-${a.id}`" class="thumb-cell">
              <img :src="a.archivo_url" alt="" @click="openUnidadGaleriaImage(a)">
              <div class="thumb-kind">{{ tipoArchivoLabel(a.tipo_archivo, a.orden) }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="eliminarArchivoExistenteGaleria(a.id)">
                ELIMINAR
              </v-btn>
            </div>
            <div v-for="(url, i) in editGaleriaForm.previewNuevosCat" :key="`newc-solo-${i}`" class="thumb-cell">
              <img :src="url" alt="">
              <div class="thumb-kind">CAT nuevo #{{ i + 1 }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="removeEditCatNuevo(i)">
                ELIMINAR
              </v-btn>
            </div>
            <button type="button" class="upload-placeholder upload-placeholder--hist-gwm" @click="$refs.inEditCatGaleriaSolo.click()">
              <v-icon color="primary" size="64">fas fa-plus</v-icon>
              <span class="upload-hint">Tocá para agregar</span>
            </button>
          </div>
          <input ref="inEditCatGaleriaSolo" type="file" accept="image/*" multiple class="d-none" @change="onPickEditCatGaleria">
          </template>

          <template v-if="!editGaleriaSoloHistoricoGwm && !editGaleriaSoloCatConsulta">
          <img
            class="galeria-banner-titulo mb-2"
            :src="postventaPublicAsset('dominio_patente.png')"
            alt="Dominio / patente / matrícula del vehículo (opcional)"
          >
          <div class="thumb-grid mb-1">
            <div v-if="editPreviewSingleUrl('PATENTE')" class="thumb-cell">
              <img :src="editPreviewSingleUrl('PATENTE')" alt="">
              <div class="thumb-kind">{{ editGaleriaForm.previewNuevoPatente ? 'Patente nueva' : 'Patente' }}</div>
              <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingleGaleria('PATENTE')">
                ELIMINAR
              </v-btn>
            </div>
            <button v-else type="button" class="thumb-add" @click="$refs.inEditPatenteGaleria.click()">
              <span>+</span>
            </button>
          </div>
          <input ref="inEditPatenteGaleria" type="file" accept="image/*" class="d-none" @change="onPickEditSingleGaleria($event, 'PATENTE')">
          </template>
          </template>

          <template v-else>
            <div class="field-label">Fotos de los daños</div>
            <div class="thumb-grid mb-3">
              <div v-for="a in getEditGaleriaDanosActivos()" :key="`egd-${a.id}`" class="thumb-cell">
                <img :src="a.archivo_url" alt="" @click="openUnidadGaleriaImage(a)">
                <div class="thumb-kind">{{ tipoArchivoLabel(a.tipo_archivo, a.orden) }}</div>
                <v-btn small color="error" class="edit-delete-btn" @click="eliminarArchivoExistenteGaleria(a.id)">
                  ELIMINAR
                </v-btn>
              </div>
              <div v-for="(url, i) in editGaleriaForm.previewNuevosDano" :key="`newd-${i}`" class="thumb-cell">
                <img :src="url" alt="">
                <div class="thumb-kind">Daño nuevo #{{ i + 1 }}</div>
                <v-btn small color="error" class="edit-delete-btn" @click="removeEditDanoNuevo(i)">
                  ELIMINAR
                </v-btn>
              </div>
              <button type="button" class="thumb-add" @click="$refs.inEditDanosGaleria.click()">
                <span>+</span>
              </button>
            </div>
            <input ref="inEditDanosGaleria" type="file" accept="image/*" multiple class="d-none" @change="onPickEditDanosGaleria">

            <v-row dense>
              <v-col cols="12" sm="6">
                <img
                  class="galeria-banner-titulo mb-2"
                  :src="postventaPublicAsset('imagen_de_vin.png')"
                  alt="Imagen de VIN"
                >
                <div class="thumb-grid mb-3">
                  <div v-if="editPreviewSingleUrl('VIN')" class="thumb-cell">
                    <img :src="editPreviewSingleUrl('VIN')" alt="">
                    <div class="thumb-kind">{{ editGaleriaForm.previewNuevoVin ? 'VIN nuevo' : 'VIN' }}</div>
                    <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingleGaleria('VIN')">
                      ELIMINAR
                    </v-btn>
                  </div>
                  <button v-else type="button" class="thumb-add" @click="$refs.inEditVinGaleria.click()">
                    <span>+</span>
                  </button>
                </div>
                <input ref="inEditVinGaleria" type="file" accept="image/*" class="d-none" @change="onPickEditSingleGaleria($event, 'VIN')">
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-label">Frente del remito del vehículo</div>
                <div class="thumb-grid mb-3">
                  <div v-if="editPreviewSingleUrl('REMITO_FRENTE')" class="thumb-cell">
                    <img :src="editPreviewSingleUrl('REMITO_FRENTE')" alt="">
                    <div class="thumb-kind">{{ editGaleriaForm.previewNuevoRemitoFrente ? 'Remito frente nuevo' : 'Remito frente' }}</div>
                    <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingleGaleria('REMITO_FRENTE')">
                      ELIMINAR
                    </v-btn>
                  </div>
                  <button v-else type="button" class="thumb-add" @click="$refs.inEditRfGaleria.click()">
                    <span>+</span>
                  </button>
                </div>
                <input ref="inEditRfGaleria" type="file" accept="image/*" class="d-none" @change="onPickEditSingleGaleria($event, 'REMITO_FRENTE')">
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-label">Dorso del remito del vehículo</div>
                <div class="thumb-grid mb-3">
                  <div v-if="editPreviewSingleUrl('REMITO_DORSO')" class="thumb-cell">
                    <img :src="editPreviewSingleUrl('REMITO_DORSO')" alt="">
                    <div class="thumb-kind">{{ editGaleriaForm.previewNuevoRemitoDorso ? 'Remito dorso nuevo' : 'Remito dorso' }}</div>
                    <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingleGaleria('REMITO_DORSO')">
                      ELIMINAR
                    </v-btn>
                  </div>
                  <button v-else type="button" class="thumb-add" @click="$refs.inEditRdGaleria.click()">
                    <span>+</span>
                  </button>
                </div>
                <input ref="inEditRdGaleria" type="file" accept="image/*" class="d-none" @change="onPickEditSingleGaleria($event, 'REMITO_DORSO')">
              </v-col>
              <v-col cols="12" sm="6">
                <div class="field-label">Remito del camión / carta de porte</div>
                <div class="thumb-grid mb-3">
                  <div v-if="editPreviewSingleUrl('REMITO_CAMION')" class="thumb-cell">
                    <img :src="editPreviewSingleUrl('REMITO_CAMION')" alt="">
                    <div class="thumb-kind">{{ editGaleriaForm.previewNuevoRemitoCamion ? 'Remito camión nuevo' : 'Remito camión' }}</div>
                    <v-btn small color="error" class="edit-delete-btn" @click="clearEditSingleGaleria('REMITO_CAMION')">
                      ELIMINAR
                    </v-btn>
                  </div>
                  <button v-else type="button" class="thumb-add" @click="$refs.inEditRcGaleria.click()">
                    <span>+</span>
                  </button>
                </div>
                <input ref="inEditRcGaleria" type="file" accept="image/*" class="d-none" @change="onPickEditSingleGaleria($event, 'REMITO_CAMION')">
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarEditarGaleria">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardandoEdicionGaleria" @click="guardarEdicionGaleria">Guardar cambios</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ImgViewer v-model="dialog_img" :img="img" :nombre="nombre_ver" />
    <PDFViewer v-model="dialog_pdf" :pdf="pdf" :nombre="nombre_ver" :titulo="nombre_ver" />
    <v-dialog v-model="dialogProformaGarantia" max-width="720" scrollable>
      <v-card>
        <v-card-title class="pb-2">
          Pro forma – Archivo único
          <v-spacer />
          <v-btn icon @click="dialogProformaGarantia = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <div class="caption grey--text mb-3">
            Revisá los datos y elegí qué secciones con imágenes incluir en el PDF. La primera hoja siempre incluye datos de la orden, repuestos y resumen del diagnóstico.
          </div>
          <v-simple-table dense class="proforma-preview-table mb-3">
            <template #default>
              <tbody>
                <tr><td class="font-weight-bold">BAC</td><td>279744</td></tr>
                <tr><td class="font-weight-bold">Concesionario</td><td>BORIGEN BETZEL SRL</td></tr>
                <tr><td class="font-weight-bold">Cliente</td><td>{{ ticketSeleccionado.nombre_cliente || '—' }}</td></tr>
                <tr>
                  <td class="font-weight-bold align-top pt-2">Modelo</td>
                  <td class="py-1">
                    <v-text-field v-model="proformaEdicion.modelo" dense hide-details outlined />
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold align-top pt-2">Año</td>
                  <td class="py-1">
                    <v-text-field v-model="proformaEdicion.anio" dense hide-details outlined />
                  </td>
                </tr>
                <tr><td class="font-weight-bold">VIN</td><td>{{ ticketSeleccionado.unidad_vin || '—' }}</td></tr>
                <tr><td class="font-weight-bold">Patente/Matrícula</td><td>{{ ticketSeleccionado.unidad_patente || '—' }}</td></tr>
                <tr><td class="font-weight-bold">Fecha (documento)</td><td>{{ fechaActualProforma }}</td></tr>
                <tr><td class="font-weight-bold">Fecha apertura OR</td><td>{{ proformaFechaAperturaOrTexto }}</td></tr>
                <tr><td class="font-weight-bold">OR/OT N°</td><td>{{ galeriaGarantiasOrdenServicio || '—' }}</td></tr>
                <tr>
                  <td class="font-weight-bold align-top pt-2">KM</td>
                  <td class="py-1">
                    <v-text-field v-model="proformaEdicion.kmTexto" dense hide-details outlined />
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold align-top pt-2">Hs MO</td>
                  <td class="py-1">
                    <v-text-field v-model="proformaEdicion.horasMoLinea" dense hide-details outlined hint="Ej.: horas y código MO" persistent-hint />
                  </td>
                </tr>
                <tr><td class="font-weight-bold">Repuestos (líneas)</td><td>{{ (galeriaGarantiasRepuestos || []).length }} — Total {{ formatCurrencyARS(costoFinalGarantias) }}</td></tr>
              </tbody>
            </template>
          </v-simple-table>
          <div class="subtitle-2 mb-2">Resumen del diagnóstico</div>
          <v-textarea
            v-model="proformaEdicion.resumenDiagnostico"
            outlined
            auto-grow
            rows="4"
            hide-details
            class="mb-4"
          />
          <div class="subtitle-2 mb-2">Incluir en el PDF</div>
          <v-checkbox v-model="proformaIncluir.odometer" hide-details dense label="Fotos de odómetro" class="mt-0" />
          <v-checkbox v-model="proformaIncluir.vin" hide-details dense label="Fotos de VIN" class="mt-0" />
          <v-checkbox v-model="proformaIncluir.patente" hide-details dense label="Fotos de patente / dominio" class="mt-0" />
          <v-checkbox v-model="proformaIncluir.historicoGwm" hide-details dense label="Información de vehículo - histórico de transacción (GWM)" class="mt-0" />
          <v-checkbox v-model="proformaIncluir.cat" hide-details dense label="Fotos caso / consulta CAT" class="mt-0" />
          <v-checkbox v-model="proformaIncluir.falla" hide-details dense label="Fotos falla / daño / reparación" class="mt-0" />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogProformaGarantia = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardandoProformaGarantia" :disabled="!puedeGenerarProformaGarantia" @click="ejecutarGuardarProformaGarantia">
            Guardar y generar PDF
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogMemoDano" max-width="700">
      <v-card>
        <v-card-title>Memo del daño</v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <div style="white-space: pre-wrap;">{{ memoDanoTexto || '—' }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogMemoDano = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import BtnFiltro from '../../../components/util/BtnFiltro.vue'
import FechaPicker from '../../../components/util/FechaPicker.vue'
import ImgViewer from '../../../components/util/ImgViewer.vue'
import PDFViewer from '../../../util/plantillas/PDFViewer.vue'
import SearchDataTable from '../../../components/util/SearchDataTable.vue'
import AccionesRapidasPostventa from './AccionesRapidasPostventa.vue'
import CommentComposerMentions from '../../../components/postventa/CommentComposerMentions.vue'
import { pdfProformaGarantiaUnico } from '../../../util/plantillas/pdfProformaGarantia'

export default {
  name: 'GestionTicketsPostventa',
  props: {
    modoTicketera: {
      type: String,
      default: 'garantias',
    },
  },

  data() {
    return {
      panelFiltros: true,
      usarRangoFechas: false,
      incluirFinalizados: false,
      search: '',
      headers: [
        { text: 'N°', value: 'id', width: '70px' },
        // { text: 'Solicitante', value: 'solicitante_nombre', width: '170px' },
        { text: 'Img VIN', value: 'tiene_imagenes_por_vin', width: '78px', align: 'center', sortable: false },
        { text: 'Estado', value: 'estado_nombre', width: '130px' },
        { text: 'Sub-estado', value: 'sub_estado_nombre', width: '140px' },
        { text: 'Prioridad', value: 'prioridad_nombre', width: '110px' },
        // { text: 'Tipo', value: 'tipo_nombre', width: '130px' },
        { text: 'VIN', value: 'unidad_vin', width: '170px' },
        { text: 'Fecha de carga', value: 'fecha_creacion', width: '155px' },
      ],
      headersAlertas: [
        { text: 'ID', value: 'id', width: '60px' },
        { text: 'Empresa', value: 'empresa_nombre' },
        { text: 'Unidad SAI', value: 'unidad_sai_id' },
        { text: 'Estado', value: 'estado' },
        { text: 'Fecha alta', value: 'fecha_alta', width: '160px' },
      ],
      headersSubEstadosGestion: [
        { text: 'ID', value: 'id', width: '90px' },
        { text: 'Estado', value: 'estado_id_padre' },
        { text: 'Tipo', value: 'tipo_ticket_id' },
        { text: 'Sub-estado', value: 'nombre' },
        { text: 'Estado actual', value: 'activo', width: '140px' },
        { text: 'Acciones', value: 'acciones', align: 'end', sortable: false, width: '280px' },
      ],
      headersDestinatariosReparacion: [
        { text: 'ID', value: 'id', width: '90px' },
        { text: 'Empresa', value: 'empresa_nombre' },
        { text: 'Tipo de alerta', value: 'tipo_alerta', width: '220px' },
        { text: 'Email', value: 'email' },
        { text: 'Estado actual', value: 'activo', width: '140px' },
        { text: 'Acciones', value: 'acciones', align: 'end', sortable: false, width: '220px' },
      ],
      filtro: {
        ticket_id: null, asunto: null, solicitante: null,
        usuario_asignado: null, usuario_finalizacion: null,
        estado: null, sub_estado: null, tipo: null, prioridad: null,
        empresa: null, sucursal: null,
        fecha_creacion_desde: null, fecha_creacion_hasta: null,
        fecha_finalizacion_desde: null, fecha_finalizacion_hasta: null,
      },
      selected: [],
      detalleTicketId: null,
      comentariosDelTicket: [],
      archivosDelTicket: [],
      galeriaUnidadImagenes: [],
      galeriaUnidadCargando: false,
      galeriaGarantiasRepuestos: [],
      galeriaGarantiasOrdenServicio: null,
      ordenAperturaSai: null,
      ordenOdometroValor: null,
      /** Nombre según SAI.ServiciosOrdenes.SucursalContable (1 Salta, 2 Jujuy); prioridad en el detalle. */
      sucursalNombreDesdeOrdenServicio: null,
      guardandoDetalleGarantia: false,
      guardandoRepuestosGarantiaBatch: false,
      resumenDiagnosticoOriginal: '',
      resumenDiagnosticoTocado: false,
      horasMoOriginal: '',
      codigoMoOriginal: '',
      garantiasDetalleForm: {
        evidencia_id: null,
        encabezado_incidente_cliente: '',
        encabezado_resultado_tecnico: '',
        mecanico_nombre: '',
        resumen_diagnostico: '',
        horas_mo: '',
        codigo_mo: '',
      },
      comentariosCargando: false,
      nuevoComentarioTexto: '',
      esComentarioInterno: false,
      archivosSeleccionados: [],
      enviandoComentario: false,
      subEstadoSeleccionado: null,
      prioridadSeleccionada: null,
      estadoSeleccionado: null,
      ticketOriginalAccionesRapidas: { prioridad_id: null, sub_estado_id: null, estado_id: null },
      accionCargando: false,
      ticketSeleccionado: null,
      contextMenu: { show: false, x: 0, y: 0, item: null },
      dialogAsignar: false,
      asignarForm: { usuario_asignado: null, estado_id: null, sub_estado_id: null, prioridad_id: null },
      dialogNuevoTicket: false,
      formValido: false,
      creandoTicket: false,
      cargandoUsuariosAsignablesGarantias: false,
      cargandoContextoNuevoTicket: false,
      usuariosAsignablesGarantias: [],
      archivosNuevoTicket: [],
      nuevoTicketForm: {
        asunto: '', descripcion: '', usuario_asignado: null,
        empresa: null, sucursal: null, tipo_ticket_id: null, prioridad_id: null,
        numero_orden: null, unidad_id: null,
      },
      dialogAlertas: false,
      dialogGestionSubEstados: false,
      guardandoSubEstado: false,
      subEstadoBajandoId: null,
      subEstadoAltaId: null,
      subEstadoEliminandoId: null,
      subEstadoAEliminar: null,
      dialogEditarSubEstado: false,
      guardandoEdicionSubEstado: false,
      dialogGestionDestinatariosReparacion: false,
      destinatarioEmpresaId: null,
      destinatarioTipoAlerta: 'reparacion_realizada',
      destinatarioNuevoEmail: '',
      destinatariosReparacion: [],
      cargandoDestinatariosReparacion: false,
      guardandoDestinatarioReparacion: false,
      destinatarioReparacionBajandoId: null,
      destinatarioReparacionAltaId: null,
      dialogEditarDestinatarioReparacion: false,
      guardandoEdicionDestinatarioReparacion: false,
      destinatarioReparacionEditar: {
        id: null,
        empresa_id: null,
        tipo_alerta: 'reparacion_realizada',
        email: '',
      },
      subEstadoEditar: {
        id: null,
        estado_id_padre: null,
        tipo_ticket_id: null,
        nombre: '',
      },
      filtroEstadoGestion: null,
      filtroTipoGestion: null,
      subEstadoNuevo: {
        estado_id_padre: null,
        tipo_ticket_id: null,
        nombre: '',
      },
      dialogConfirm: { show: false, titulo: '', texto: '', accion: () => { }, color: 'primary' },
      dialogPrioridad: false,
      prioridadSeleccionadaDialog: null,
      ticketPrioridadContexto: null,
      reparacionPrimeraVisitaContext: { ticket: null, valor: null },
      guardandoReparacionPrimeraVisitaId: null,
      snackbar: { value: false, text: '', color: '' },
      dialog_pdf: false,
      dialog_img: false,
      dialog_galeria_img: false,
      dialogEditarGaleria: false,
      dialogMemoDano: false,
      guardandoEdicionGaleria: false,
      guardandoHistoricoGwmDetalle: false,
      historicoGwmDetallePendienteArchivos: [],
      historicoGwmDetallePendientePreviews: [],
      guardandoCatDetalle: false,
      catDetallePendienteArchivos: [],
      catDetallePendientePreviews: [],
      editGaleriaContexto: '',
      editGaleriaTipo: 'garantia',
      editGaleriaSoloHistoricoGwm: false,
      editGaleriaSoloCatConsulta: false,
      editGaleriaForm: {
        evidencia_id: null,
        recepcion_id: null,
        vin_ultimos_6: '',
        archivos: [],
        archivosEliminarIds: [],
        autoDeleteArchivoIds: [],
        nuevosArchivosDano: [],
        previewNuevosDano: [],
        nuevosArchivosFalla: [],
        previewNuevosFalla: [],
        nuevosArchivosCat: [],
        previewNuevosCat: [],
        nuevoArchivoRemitoFrente: null,
        previewNuevoRemitoFrente: '',
        nuevoArchivoRemitoDorso: null,
        previewNuevoRemitoDorso: '',
        nuevoArchivoRemitoCamion: null,
        previewNuevoRemitoCamion: '',
        nuevoArchivoOdometro: null,
        previewNuevoOdometro: '',
        nuevoArchivoVin: null,
        previewNuevoVin: '',
        nuevoArchivoPatente: null,
        previewNuevoPatente: '',
      },
      memoDanoTexto: '',
      pdf: null,
      img: null,
      nombre_ver: '',
      galeriaImagenActualUrl: '',
      galeriaImagenActualItem: null,
      tabTipoId: 1,
      tabTipoIndex: 0,
      rolesIdsUsuario: [],
      dialogProformaGarantia: false,
      guardandoProformaGarantia: false,
      proformaEdicion: {
        modelo: '',
        anio: '',
        kmTexto: '',
        horasMoLinea: '',
        resumenDiagnostico: '',
      },
      proformaUltima: null,
      proformaIncluir: {
        odometer: true,
        vin: true,
        patente: true,
        historicoGwm: true,
        cat: true,
        falla: true,
      },
    }
  },

  computed: {
    esModoReparacion0km() {
      return this.modoTicketera === 'reparacion0km'
    },
    headersTabla() {
      if (this.esModoReparacion0km) {
        return [
          { text: 'N°', value: 'id', width: '70px' },
          { text: 'Img VIN', value: 'tiene_imagenes_por_vin', width: '78px', align: 'center', sortable: false },
          { text: 'Modelo', value: 'unidad_modelo_descripcion', width: '220px' },
          { text: 'Color', value: 'unidad_color_descripcion', width: '170px' },
          { text: 'VIN', value: 'unidad_vin', width: '170px' },
          { text: 'Recepción', value: 'dias_desde_recepcion', width: '120px' },
          { text: 'Memo del daño', value: 'memo_dano', width: '140px', sortable: false },
          { text: 'Sucursal', value: 'sucursal_nombre', width: '170px' },
        ]
      }
      if (this.esTabReclamoGarantia) {
        return [
          { text: 'N°', value: 'id', width: '70px' },
          { text: 'Img VIN', value: 'tiene_imagenes_por_vin', width: '78px', align: 'center', sortable: false },
          { text: 'Estado', value: 'estado_nombre', width: '130px' },
          { text: 'Sub-estado', value: 'sub_estado_nombre', width: '140px' },
          { text: 'Prioridad', value: 'prioridad_nombre', width: '110px' },
          { text: 'VIN', value: 'unidad_vin', width: '170px' },
          { text: 'Patente', value: 'unidad_patente', width: '120px' },
          { text: 'Nombre cliente', value: 'nombre_cliente', width: '140px' },
          { text: 'Rep. realizada en 1° visita', value: 'reparacion_realizada_primera_visita', width: '168px', sortable: false },
          { text: 'Fecha de carga', value: 'fecha_creacion', width: '155px' },
        ]
      }
      return this.headers
    },
    ...mapState('postventaTickets', [
      'tickets', 'cargando', 'estados', 'subEstados', 'tipos',
      'prioridades', 'empresas', 'sucursales',
      'usuariosAsignables', 'usuariosMenciones', 'alertasDanos',
    ]),

    /** Más recientes arriba (id descendente). Copia para no mutar el store. */
    ticketsOrdenadosDesc() {
      const list = Array.isArray(this.tickets) ? [...this.tickets] : []
      return list.sort((a, b) => Number(b.id) - Number(a.id))
    },

    subEstadosFiltrados() {
      const activos = this.subEstados.filter((s) => Number(s.activo) !== 0)
      return activos.filter((s) => {
        const coincideEstado = !this.filtro.estado || s.estado_id_padre === this.filtro.estado
        const coincideTipo = !this.filtro.tipo || s.tipo_ticket_id === this.filtro.tipo
        return coincideEstado && coincideTipo
      })
    },

    sucursalesFiltradas() {
      if (!this.filtro.empresa) return this.sucursales
      return this.sucursales.filter((s) => s.Familia_id === this.filtro.empresa)
    },

    sucursalesNuevoTicket() {
      if (!this.nuevoTicketForm.empresa) return this.sucursales
      return this.sucursales.filter((s) => s.Familia_id === this.nuevoTicketForm.empresa)
    },
    usuariosAsignablesNuevoTicket() {
      if (!this.esTabReclamoGarantia && !this.esTabReclamoTransporte && !this.esModoReparacion0km) return this.usuariosAsignables
      return this.usuariosAsignablesGarantias
    },
    mostrarSelectorUsuarioAsignadoNuevoTicket() {
      if (!this.esTabReclamoGarantia && !this.esTabReclamoTransporte && !this.esModoReparacion0km) return true
      return (this.usuariosAsignablesNuevoTicket || []).length > 1
    },
    tituloDialogNuevoTicket() {
      if (this.esModoReparacion0km) return 'Nuevo Ticket Reparación de Vehículos 0km'
      if (this.esTabReclamoGarantia) return 'Nuevo Ticket Reclamo de Garantias'
      if (this.esTabReclamoTransporte) return 'Nuevo Ticket Reclamo de transporte'
      return 'Nuevo Ticket de Postventa'
    },
    tipoNuevoTicketLabel() {
      if (this.esModoReparacion0km) return 'Reparación de Vehículos 0km'
      if (this.esTabReclamoGarantia) return 'Reclamo de Garantias'
      if (this.esTabReclamoTransporte) return 'Reclamo de transporte'
      return 'Postventa'
    },

    /**
     * Roles para menciones (@): en garantía o reparación 0km → ticketera (58) + mismos roles que Reclamo de transporte.
     */
    rolesMencionesComentario() {
      if (this.esTabReclamoGarantia || this.esModoReparacion0km) return [58, 1, 50, 54, 56]
      return [1, 50, 54, 56]
    },

    /** Perfil SMTP en servidor (SMTP_PROFILE_* / default). Cambiar aquí si otra pantalla usa otro buzón. */
    smtpProfileMencionesComentario() {
      return 'default'
    },
    subEstadosGestionFiltrados() {
      return this.subEstados.filter((s) => {
        const coincideEstado = !this.filtroEstadoGestion || s.estado_id_padre === this.filtroEstadoGestion
        const coincideTipo = !this.filtroTipoGestion || s.tipo_ticket_id === this.filtroTipoGestion
        return coincideEstado && coincideTipo
      })
    },
    destinatariosReparacionFiltrados() {
      const empresaId = Number(this.destinatarioEmpresaId)
      return this.destinatariosReparacion.filter((d) => {
        const coincideEmpresa = !Number.isInteger(empresaId) || empresaId <= 0 || Number(d.empresa_id) === empresaId
        const coincideTipo = !this.destinatarioTipoAlerta || d.tipo_alerta === this.destinatarioTipoAlerta
        return coincideEmpresa && coincideTipo
      })
    },
    tiposDestinatarioAlertaOptions() {
      return [
        { value: 'reparacion_realizada', text: 'Reparación realizada' },
        { value: 'danios_15_dias', text: 'Vehículos > 15 días sin reparar' },
      ]
    },
    tiposTabs() {
      if (this.esModoReparacion0km) return []
      const base = (this.tipos || []).filter((t) => [1, 2].includes(Number(t.id)))
      if (base.length > 0) return base.sort((a, b) => Number(a.id) - Number(b.id))
      return (this.tipos || []).slice(0, 2)
    },
    esRol56() {
      return this.rolesIdsUsuario.includes(56)
    },
    puedeGestionarDestinatariosReparacion() {
      return this.rolesIdsUsuario.includes(56) || this.rolesIdsUsuario.includes(1) || this.rolesIdsUsuario.includes(50)
    },
    esTabReclamoGarantia() {
      return Number(this.tabTipoId) === 2
    },
    esTabReclamoTransporte() {
      return Number(this.tabTipoId) === 1
    },
    /** Texto del tooltip de la columna Img VIN según pestaña activa. */
    tooltipTextoImagenesPorVin() {
      if (this.esTabReclamoGarantia && !this.esModoReparacion0km) {
        return 'Hay fotos de archivo unico relacionadas a este VIN'
      }
      return 'Hay fotos de recepción 0 km para los últimos 6 del VIN'
    },
    esTicketDetalleReclamoGarantia() {
      const tipoId = Number(this.ticketSeleccionado?.tipo_ticket_id)
      if (tipoId === 2) return true
      const tipoNombre = this.normalizarTexto(this.ticketSeleccionado?.tipo_nombre || '')
      return tipoNombre === this.normalizarTexto('Reclamo de Garantias')
    },
    galeriaVinPorPagina() {
      if (this.$vuetify.breakpoint.xs) return 1
      if (this.$vuetify.breakpoint.mdAndDown) return 2
      return 3
    },
    galeriaUnidadChunks() {
      const size = this.galeriaVinPorPagina
      const imgs = this.galeriaUnidadImagenes || []
      const chunks = []
      for (let i = 0; i < imgs.length; i += size) {
        chunks.push(imgs.slice(i, i + size))
      }
      return chunks
    },
    /** Imágenes de orden de servicio sin Histórico GWM ni CAT (van en tarjetas propias). */
    galeriaUnidadImagenesParaCarouselGarantia() {
      return (this.galeriaUnidadImagenes || []).filter((img) => {
        const t = String(img?.tipo_archivo || '').trim().toUpperCase()
        return t !== 'HISTORICO_GWM' && t !== 'CAT' && t !== 'CONSULTA_CAT'
      })
    },
    galeriaUnidadChunksGarantia() {
      const size = this.galeriaVinPorPagina
      const imgs = this.galeriaUnidadImagenesParaCarouselGarantia || []
      const chunks = []
      for (let i = 0; i < imgs.length; i += size) {
        chunks.push(imgs.slice(i, i + size))
      }
      return chunks
    },
    galeriaHistoricoGwmItems() {
      return (this.galeriaUnidadImagenes || []).filter(
        (img) => String(img?.tipo_archivo || '').trim().toUpperCase() === 'HISTORICO_GWM'
      )
    },
    galeriaCatItems() {
      return (this.galeriaUnidadImagenes || []).filter((img) => {
        const t = String(img?.tipo_archivo || '').trim().toUpperCase()
        return t === 'CONSULTA_CAT' || t === 'CAT'
      })
    },
    costoFinalGarantias() {
      return (this.galeriaGarantiasRepuestos || []).reduce((acc, r) => {
        return acc + this.subtotalRepuestoGarantia(r)
      }, 0)
    },
    puedeMostrarBotonProformaGarantia() {
      return this.esTabReclamoGarantia && !this.esModoReparacion0km && !!this.ticketSeleccionado
    },
    puedeGenerarProformaGarantia() {
      return (
        this.puedeMostrarBotonProformaGarantia &&
        !!this.galeriaGarantiasOrdenServicio &&
        !this.galeriaUnidadCargando
      )
    },
    puedeVerProformaPdfGenerado() {
      return this.puedeMostrarBotonProformaGarantia && !!this.proformaUltima?.archivo_url
    },
    proformaFechaAperturaOrTexto() {
      const raw = this.ordenAperturaSai
      if (raw == null || raw === '') return '—'
      const m = moment(raw)
      return m.isValid() ? m.format('DD/MM/YY') : String(raw)
    },
    proformaKmTexto() {
      if (this.ordenOdometroValor != null && Number.isFinite(this.ordenOdometroValor)) {
        return String(this.ordenOdometroValor)
      }
      return '—'
    },
    proformaHorasMoLinea() {
      const raw = String(this.garantiasDetalleForm?.horas_mo ?? '')
        .replace('.', ',')
        .trim()
      const cod = String(this.garantiasDetalleForm?.codigo_mo || '').trim()
      if (raw && cod) return `${raw} ${cod}`
      if (raw) return raw
      if (cod) return cod
      return '—'
    },
    fechaActualProforma() {
      return moment().format('DD/MM/YY')
    },
    memosFormateadosDetalle() {
      if (!this.esModoReparacion0km || !this.ticketSeleccionado) return []
      const memos = Array.isArray(this.ticketSeleccionado.memos_unidad) ? this.ticketSeleccionado.memos_unidad : []
      return memos.map((m) => {
        const fechaRaw = m.memo_fecha || m.memo_hora || null
        const fecha = fechaRaw ? this.formatFecha(fechaRaw) : 'Sin fecha'
        return {
          id: m.memo_id || '—',
          tipo: m.memo_tipo || '',
          comentario: m.memo_comentario || '—',
          fecha,
        }
      })
    },
    hayCambiosAccionesRapidas() {
      const original = this.ticketOriginalAccionesRapidas || {}
      const estadoActual = this.normalizarId(this.estadoSeleccionado)
      const prioridadActual = this.normalizarId(this.prioridadSeleccionada)
      const subEstadoActual = this.normalizarId(this.subEstadoSeleccionado)
      const estadoOriginal = this.normalizarId(original.estado_id)
      const prioridadOriginal = this.normalizarId(original.prioridad_id)
      const subEstadoOriginal = this.normalizarId(original.sub_estado_id)
      return estadoActual !== estadoOriginal ||
        prioridadActual !== prioridadOriginal ||
        subEstadoActual !== subEstadoOriginal
    },
    hayCambioMoVsOriginal() {
      const a = this.garantiasDetalleForm?.horas_mo
      const b = this.horasMoOriginal
      const sa = String(a ?? '').replace(',', '.').trim()
      const sb = String(b ?? '').replace(',', '.').trim()
      let horasDistintas = false
      if (sa === '' && sb === '') {
        horasDistintas = false
      } else {
        const na = Number(sa)
        const nb = Number(sb)
        if (Number.isFinite(na) && Number.isFinite(nb)) horasDistintas = na !== nb
        else horasDistintas = sa !== sb
      }
      const cA = String(this.garantiasDetalleForm?.codigo_mo || '').trim()
      const cO = String(this.codigoMoOriginal || '').trim()
      return horasDistintas || cA !== cO
    },
    hayCambiosResumenOAccionesGarantia() {
      const resumenActual = String(this.garantiasDetalleForm?.resumen_diagnostico || '')
      const resumenPersistido = String(this.resumenDiagnosticoOriginal || '')
      const hayCambioResumen = this.resumenDiagnosticoTocado && resumenActual !== resumenPersistido
      return this.hayCambiosAccionesRapidas || hayCambioResumen || this.hayCambioMoVsOriginal
    },
    hayCambiosPreciosRepuestosGarantia() {
      const list = this.galeriaGarantiasRepuestos || []
      return list.some((rep) => {
        const id = Number(rep?.id)
        if (!id) return false
        const raw = rep.precio_estimado
        const parsed = raw === '' || raw === null ? NaN : Number(raw)
        if (Number.isNaN(parsed) || parsed < 0) return false
        const nuevo = this.truncarPrecioEstimadoRepuesto(parsed)
        const guardadoTrunc = this.truncarPrecioEstimadoRepuesto(rep._precioGuardado)
        return nuevo !== guardadoTrunc
      })
    },
    hayHistoricoGwmPendienteSubir() {
      return (this.historicoGwmDetallePendienteArchivos || []).length > 0
    },
    hayCatDetallePendienteSubir() {
      return (this.catDetallePendienteArchivos || []).length > 0
    },
    hayCambiosDetalleUnificado() {
      return (
        this.hayCambiosResumenOAccionesGarantia ||
        this.hayCambiosPreciosRepuestosGarantia ||
        this.hayHistoricoGwmPendienteSubir ||
        this.hayCatDetallePendienteSubir
      )
    },
    hayComentarioPendiente() {
      return (this.nuevoComentarioTexto || '').trim().length > 0
    },
    hayCambioDetalleSinEvidencia() {
      if (!this.esTabReclamoGarantia || this.esModoReparacion0km) return false
      const evidenciaId = Number(this.garantiasDetalleForm.evidencia_id)
      if (evidenciaId) return false
      const hayResumen =
        this.resumenDiagnosticoTocado &&
        String(this.garantiasDetalleForm?.resumen_diagnostico || '') !==
          String(this.resumenDiagnosticoOriginal || '')
      return hayResumen || this.hayCambioMoVsOriginal
    },
    deshabilitarGuardarCambiosInferior() {
      if (!this.ticketSeleccionado) return true
      if (this.ticketSeleccionadoFinalizado) return true
      if (this.hayComentarioPendiente) return false
      if (this.esTabReclamoGarantia && !this.esModoReparacion0km) {
        const evidenciaId = Number(this.garantiasDetalleForm.evidencia_id)
        if (evidenciaId) return !this.hayCambiosDetalleUnificado
        return !this.hayCambiosAccionesRapidas &&
          !this.hayCambioDetalleSinEvidencia &&
          !this.hayCambiosPreciosRepuestosGarantia &&
          !this.hayHistoricoGwmPendienteSubir &&
          !this.hayCatDetallePendienteSubir
      }
      return !this.hayCambiosAccionesRapidas
    },
    puedeEditarGaleriaActual() {
      if (!this.ticketSeleccionado || this.galeriaUnidadCargando) return false
      if (this.esTabReclamoGarantia) {
        if (this.resolverEvidenciaIdGaleria()) return true
        const ord = Number(this.galeriaGarantiasOrdenServicio || 0)
        return Number.isFinite(ord) && ord > 0
      }
      if (this.esTabReclamoTransporte) return !!this.resolverRecepcionIdGaleria()
      return !!this.resolverRecepcionIdGaleria() || !!this.resolverEvidenciaIdGaleria()
    },
    tituloDialogEditarGaleria() {
      if (this.editGaleriaSoloHistoricoGwm) {
        return `Editar Histórico GWM #${this.editGaleriaForm.evidencia_id || '—'}`
      }
      if (this.editGaleriaSoloCatConsulta) {
        return `Editar consulta CAT #${this.editGaleriaForm.evidencia_id || '—'}`
      }
      return `Editar imágenes #${this.editGaleriaForm.evidencia_id || '—'}`
    },
    editGaleriaContextoLabel() {
      if (this.editGaleriaSoloHistoricoGwm) {
        return 'Solo archivos tipo Histórico GWM (no se editan fotos del carrusel principal).'
      }
      if (this.editGaleriaSoloCatConsulta) {
        return 'Solo archivos tipo CAT — consulta / diagnóstico (no se editan otras fotos de la galería).'
      }
      if (this.editGaleriaContexto === 'vin') return 'Imágenes recepcionadas (VIN)'
      if (this.editGaleriaContexto === 'garantia') return 'Evidencias de garantía (orden de servicio)'
      return 'Galería del ticket'
    },
    ticketSeleccionadoFinalizado() {
      return this.esTicketFinalizado(this.ticketSeleccionado)
    },
    /** En reclamo con orden de servicio, la sucursal se toma de ServiciosOrdenes (SucursalContable). */
    sucursalNombreDetalleTicket() {
      const desdeOrden = String(this.sucursalNombreDesdeOrdenServicio || '').trim()
      if (desdeOrden) return desdeOrden
      return this.ticketSeleccionado?.sucursal_nombre || null
    },
  },
  components: {
    BtnFiltro,
    FechaPicker,
    ImgViewer,
    PDFViewer,
    SearchDataTable,
    AccionesRapidasPostventa,
    CommentComposerMentions,
  },

  async mounted() {
    await this.cargarRolesUsuario()
    if (!this.esRol56) {
      this.esComentarioInterno = false
    }
    await Promise.all([
      this.$store.dispatch('postventaTickets/getEstados'),
      this.$store.dispatch('postventaTickets/getSubEstados'),
      this.$store.dispatch('postventaTickets/getTipos'),
      this.$store.dispatch('postventaTickets/getPrioridades'),
      this.$store.dispatch('postventaTickets/getSolicitantes'),
      this.$store.dispatch('postventaTickets/getEmpresas'),
      this.$store.dispatch('postventaTickets/getSucursales'),
      this.$store.dispatch('postventaTickets/getUsuariosAsignables'),
      this.$store.dispatch('postventaTickets/getAlertasDanos'),
      this.$store.dispatch('postventaTickets/getAlertasGarantias'),
    ])

    // Si quedaron alertas "colgadas" sin procesar (por ejemplo, por falla del cron),
    // intentamos procesarlas al entrar a la página.
    if (!this.esModoReparacion0km) {
      try {
        await this.$store.dispatch('postventaTickets/procesarAlertasUnidadesDaniadas').then((res) => {
          console.log(res);

        }

        )
        await this.$store.dispatch('postventaTickets/getAlertasDanos')
      } catch (e) {
        // No bloqueamos la carga de la grilla si falla el endpoint.
      }

      try {
        await this.$store.dispatch('postventaTickets/procesarAlertasOrdenesGarantias')
        await this.$store.dispatch('postventaTickets/getAlertasGarantias')
      } catch (e) {
        // No bloqueamos la carga de la grilla si falla el endpoint.
      }
    }

    if (this.esModoReparacion0km) {
      const tipo = this.obtenerTipoReparacion0kmId()
      this.tabTipoIndex = 0
      this.tabTipoId = tipo
      this.filtro.tipo = tipo
    } else {
      const tipoInicial = Number(this.tiposTabs[0]?.id || 1)
      this.tabTipoIndex = 0
      this.tabTipoId = tipoInicial
      this.filtro.tipo = tipoInicial
    }
    await this.buscar()
  },

  methods: {
    postventaPublicAsset(nombreArchivo) {
      const n = String(nombreArchivo || '').replace(/^\/+/, '')
      if (typeof window === 'undefined' || !window.location?.origin) return `/postventa/${n}`
      return `${window.location.origin}/postventa/${n}`
    },
    validarEmail(valor) {
      const email = String(valor || '').trim().toLowerCase()
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    },
    normalizarId(valor) {
      const n = Number(valor)
      return Number.isFinite(n) && n > 0 ? n : null
    },
    /**
     * Galería por orden de servicio (evidencias) vs recepción VIN.
     * En la pestaña Reclamo de Garantías siempre usamos evidencias/orden: ahí viven las fotos del caso
     * (incl. HISTORICO_GWM en Garantias_evidencias_archivos). Si mezcláramos con getGaleriaUnidadGarantias
     * solo por un tipo_ticket_id distinto de 2, la lista vendría vacía aunque el archivo esté guardado.
     */
    usarGaleriaEvidenciasOrdenServicio(ticket) {
      if (this.esTabReclamoGarantia && !this.esModoReparacion0km) return true
      const t = ticket || this.ticketSeleccionado
      const tipoId = Number(t?.tipo_ticket_id)
      const nombreTipo = this.normalizarTexto(t?.tipo_nombre || '')
      if (tipoId === 2 || nombreTipo === this.normalizarTexto('Reclamo de Garantias')) return true
      if (Number.isFinite(tipoId) && tipoId > 0) return false
      return this.esTabReclamoGarantia
    },
    esTicketFinalizado(ticket) {
      return Number(ticket?.estado_id) === 3
    },
    snapshotAccionesRapidas(ticket) {
      this.ticketOriginalAccionesRapidas = {
        prioridad_id: this.normalizarId(ticket?.prioridad_id),
        sub_estado_id: this.normalizarId(ticket?.sub_estado_id),
        estado_id: this.normalizarId(ticket?.estado_id),
      }
      this.estadoSeleccionado = this.normalizarId(ticket?.estado_id)
    },
    onEstadoSeleccionadoCambio(valor) {
      const estadoAnterior = this.normalizarId(this.estadoSeleccionado)
      this.estadoSeleccionado = this.normalizarId(valor)
      if (this.estadoSeleccionado !== estadoAnterior) {
        this.subEstadoSeleccionado = null
      }
    },
    async refrescarTicketSeleccionado(ticketId) {
      await this.buscar()
      const updated = this.tickets?.find((t) => t.id === ticketId)
      if (updated) {
        this.selected = [updated]
        this.ticketSeleccionado = updated
        this.subEstadoSeleccionado = updated.sub_estado_id
        this.prioridadSeleccionada = updated.prioridad_id
        this.detalleTicketId = updated.id
        this.snapshotAccionesRapidas(updated)
      }
    },
    async guardarCambiosInferior() {
      const ticket = this.ticketSeleccionado
      if (!ticket) return
      if (this.esTicketFinalizado(ticket)) {
        this.mostrarSnackbar('El ticket está finalizado y no permite más acciones.', 'info')
        return
      }
      const hayComentario = this.hayComentarioPendiente
      let ticketOk = true

      if (this.esTabReclamoGarantia && !this.esModoReparacion0km) {
        let evidenciaId = Number(this.garantiasDetalleForm.evidencia_id)
        if (evidenciaId) {
          const needPrecios = this.hayCambiosPreciosRepuestosGarantia
          const needDetalle = this.hayCambiosResumenOAccionesGarantia
          if (needPrecios) {
            ticketOk = await this.guardarPreciosRepuestosGarantiaPendientes()
          }
          // Subir prints Histórico GWM antes del detalle unificado: si ese guardado falla, las fotos ya quedaron.
          if (ticketOk && this.hayHistoricoGwmPendienteSubir) {
            ticketOk = await this.subirHistoricoGwmDetalleArchivos([...this.historicoGwmDetallePendienteArchivos])
          }
          if (ticketOk && this.hayCatDetallePendienteSubir) {
            ticketOk = await this.subirCatDetalleArchivos([...this.catDetallePendienteArchivos])
          }
          if (ticketOk && needDetalle) {
            ticketOk = await this.guardarDetalleGarantia()
          }
        } else {
          if (this.hayCambiosPreciosRepuestosGarantia) {
            ticketOk = await this.guardarPreciosRepuestosGarantiaPendientes()
            if (!ticketOk) return
          }
          const hayCambioResumen = this.resumenDiagnosticoTocado &&
            String(this.garantiasDetalleForm?.resumen_diagnostico || '') !==
            String(this.resumenDiagnosticoOriginal || '')
          const hayCambioMo = this.hayCambioMoVsOriginal
          if (ticketOk && this.hayHistoricoGwmPendienteSubir) {
            ticketOk = await this.subirHistoricoGwmDetalleArchivos([...this.historicoGwmDetallePendienteArchivos])
            if (!ticketOk) return
          }
          if (ticketOk && this.hayCatDetallePendienteSubir) {
            ticketOk = await this.subirCatDetalleArchivos([...this.catDetallePendienteArchivos])
            if (!ticketOk) return
          }
          evidenciaId = Number(this.garantiasDetalleForm.evidencia_id)
          if (evidenciaId && ticketOk && this.hayCambiosResumenOAccionesGarantia) {
            ticketOk = await this.guardarDetalleGarantia()
          } else if (!evidenciaId && (hayCambioResumen || hayCambioMo) && !this.hayCambiosAccionesRapidas) {
            this.mostrarSnackbar(
              'Para guardar el resumen del diagnóstico u horas/código MO debe existir evidencia de garantía vinculada (orden de servicio).',
              'warning'
            )
            if (hayComentario) await this.enviarComentario(this.ticketSeleccionado)
            return
          } else if (!evidenciaId && (hayCambioResumen || hayCambioMo) && this.hayCambiosAccionesRapidas) {
            this.mostrarSnackbar(
              'Se guardarán estado, prioridad y sub-estado. El detalle técnico (resumen, MO) no se guarda hasta que exista evidencia de garantía.',
              'warning'
            )
          }
          if (!evidenciaId && this.hayCambiosAccionesRapidas) {
            ticketOk = await this.guardarCambiosAccionesRapidas(ticket)
          }
        }
      } else if (this.hayCambiosAccionesRapidas) {
        ticketOk = await this.guardarCambiosAccionesRapidas(ticket)
      }

      if (!ticketOk) return
      if (hayComentario) await this.enviarComentario(this.ticketSeleccionado)
    },
    async guardarCambiosAccionesRapidas(ticket) {
      const ticketId = Number(ticket?.id)
      if (!ticketId) return false
      const original = this.ticketOriginalAccionesRapidas || {}
      const estadoActual = this.normalizarId(this.estadoSeleccionado)
      const prioridadActual = this.normalizarId(this.prioridadSeleccionada)
      const subEstadoActual = this.normalizarId(this.subEstadoSeleccionado)
      const estadoOriginal = this.normalizarId(original.estado_id)
      const prioridadOriginal = this.normalizarId(original.prioridad_id)
      const subEstadoOriginal = this.normalizarId(original.sub_estado_id)
      const estadoFinalizadoId = 3
      const cambioEstado = estadoActual !== estadoOriginal
      const cambioPrioridad = prioridadActual !== prioridadOriginal
      const cambioSubEstado = subEstadoActual !== subEstadoOriginal
      if (!cambioPrioridad && !cambioSubEstado && !cambioEstado) {
        this.mostrarSnackbar('No hay cambios para guardar.', 'info')
        return false
      }
      if (!estadoActual) {
        this.mostrarSnackbar('Seleccione un estado válido.', 'warning')
        return false
      }
      if (cambioPrioridad && !prioridadActual) {
        this.mostrarSnackbar('Seleccione una prioridad válida.', 'warning')
        return false
      }
      if (cambioSubEstado && !subEstadoActual && estadoActual !== estadoFinalizadoId) {
        this.mostrarSnackbar('Seleccione un sub-estado válido.', 'warning')
        return false
      }
      this.accionCargando = true
      try {
        if (cambioPrioridad) {
          const resPrioridad = await this.$store.dispatch('postventaTickets/cambiarPrioridad', {
            ticket_id: ticketId,
            prioridad_id: prioridadActual,
          })
          if (!resPrioridad.exito) {
            this.mostrarSnackbar(resPrioridad.message || 'Error al actualizar prioridad.', 'error')
            return false
          }
        }
        if (cambioSubEstado && estadoActual !== estadoFinalizadoId) {
          const resSubEstado = await this.$store.dispatch('postventaTickets/cambiarSubEstado', {
            ticket_id: ticketId,
            sub_estado_id: subEstadoActual,
          })
          if (!resSubEstado.exito) {
            this.mostrarSnackbar(resSubEstado.message || 'Error al actualizar sub-estado.', 'error')
            return false
          }
        }
        if (cambioEstado && estadoActual === estadoFinalizadoId) {
          if (!this.puedeFinalizarTicketConCambios(ticket)) {
            const aviso = this.esModoReparacion0km
              ? 'Solo se puede finalizar tickets en estado ASIGNADO.'
              : 'Solo se puede finalizar en estado ASIGNADO y sub-estado FACTURADO o NO FACTURADO - RECLAMO NO ACEPTADO.'
            this.mostrarSnackbar(aviso, 'warning')
            return false
          }
          const resFinalizar = await this.$store.dispatch('postventaTickets/finalizarTicket', { ticket_id: ticketId })
          if (!resFinalizar.exito) {
            this.mostrarSnackbar(resFinalizar.message || 'No se pudo finalizar el ticket.', 'error')
            return false
          }
        }
        await this.refrescarTicketSeleccionado(ticketId)
        this.mostrarSnackbar('Cambios guardados.', 'success')
        return true
      } finally {
        this.accionCargando = false
      }
    },
    normalizarTexto(v) {
      return String(v || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
    },
    antiguedadRecepcionTexto(item) {
      const dias = Math.floor(Number(item?.dias_desde_recepcion))
      if (!Number.isFinite(dias) || dias < 0) return '—'
      if (dias < 30) return `Hace ${dias}d`

      const meses = Math.floor(dias / 30)
      if (meses <= 2) return `Hace ${meses}m`
      if (meses < 12) return `Hace más de ${meses}m`

      const anios = Math.floor(meses / 12)
      const mesesRestantes = meses % 12
      if (mesesRestantes > 0) return `Hace más de ${anios}a ${mesesRestantes}m`
      return `Hace más de ${anios}a`
    },
    obtenerTipoReparacion0kmId() {
      const target = this.normalizarTexto('Reparación de Vehículos 0km')
      const encontrado = (this.tipos || []).find((t) => this.normalizarTexto(t.nombre) === target)
      return Number(encontrado?.id || 0) || null
    },
    obtenerPrioridadNormalId() {
      const encontrada = (this.prioridades || []).find((p) => this.normalizarTexto(p.nombre) === 'normal')
      return Number(encontrada?.id || 0) || null
    },
    memoDanoTicket(ticket) {
      return ticket?.memo_falla || ticket?.memo_dano || ticket?.descripcion || '—'
    },
    async cargarRolesUsuario() {
      try {
        const res = await this.$store.dispatch('roles/getRolesDelUsuario')
        if (res?.exito && Array.isArray(res.data)) {
          this.rolesIdsUsuario = res.data.map((r) => Number(r.Rol_id)).filter((id) => !Number.isNaN(id))
        } else {
          this.rolesIdsUsuario = []
        }
      } catch (e) {
        this.rolesIdsUsuario = []
      }
    },
    puedeFinalizarTicket(ticket) {
      if (!ticket) return false
      const estadoOk = Number(ticket.estado_id) === 2
      if (this.esModoReparacion0km) {
        return estadoOk
      }
      const sub = String(ticket.sub_estado_nombre || '').trim().toUpperCase()
      const subOk = sub === 'FACTURADO' || sub === 'NO FACTURADO - RECLAMO NO ACEPTADO'
      return estadoOk && subOk
    },
    puedeFinalizarTicketConCambios(ticket) {
      if (!ticket) return false
      const estadoOk = Number(ticket.estado_id) === 2
      if (this.esModoReparacion0km) return estadoOk
      const subIdSeleccionado = this.normalizarId(this.subEstadoSeleccionado)
      const subNombreSeleccionado = (this.subEstados || []).find((s) => Number(s.id) === subIdSeleccionado)?.nombre
      const sub = String(subNombreSeleccionado || ticket.sub_estado_nombre || '').trim().toUpperCase()
      const subOk = sub === 'FACTURADO' || sub === 'NO FACTURADO - RECLAMO NO ACEPTADO'
      return estadoOk && subOk
    },
    async onChangeTabTipo(tabIndex) {
      const idx = Number(tabIndex)
      const tipo = Number(this.tiposTabs[idx]?.id || this.tiposTabs[0]?.id || 1)
      this.tabTipoIndex = idx
      this.tabTipoId = tipo
      this.filtro.tipo = tipo
      this.cerrarDetalle()
      await this.buscar()
    },

    async buscar() {
      const f = {}
      Object.entries(this.filtro).forEach(([k, v]) => { if (v !== null && v !== '') f[k] = v })
      if (this.esModoReparacion0km) {
        const tipoReparacion0kmId = this.obtenerTipoReparacion0kmId()
        if (tipoReparacion0kmId) {
          f.tipo = tipoReparacion0kmId
          this.filtro.tipo = tipoReparacion0kmId
        }
      }
      if (!this.usarRangoFechas) {
        delete f.fecha_creacion_desde; delete f.fecha_creacion_hasta
        delete f.fecha_finalizacion_desde; delete f.fecha_finalizacion_hasta
      }
      f.incluir_finalizados = this.incluirFinalizados
      await this.$store.dispatch('postventaTickets/getTickets', f)
    },
    vinTablaCompleto(item) {
      const v = String(item?.unidad_vin || '').trim()
      return v || '—'
    },
    vinTablaCorto(item) {
      const v = String(item?.unidad_vin || '').trim()
      if (!v) return '—'
      if (v.length <= 8) return v
      return `...${v.slice(-8)}`
    },
    vinTablaNecesitaTooltip(item) {
      const v = String(item?.unidad_vin || '').trim()
      return v.length > 8
    },
    nombreClienteCompleto(item) {
      const full = String(item?.nombre_cliente || item?.unidad_titular_nombre || '').trim()
      return full || '—'
    },
    nombreClienteTruncado(item) {
      const full = String(item?.nombre_cliente || item?.unidad_titular_nombre || '').trim()
      if (!full) return '—'
      if (full.length <= 14) return full
      return `${full.slice(0, 14)}...`
    },
    nombreClienteNecesitaTooltip(item) {
      const full = String(item?.nombre_cliente || item?.unidad_titular_nombre || '').trim()
      return full.length > 14
    },
    valorReparacionActual(ticket) {
      const v = ticket?.reparacion_realizada_primera_visita
      if (v == null) return null
      return Number(v) === 1 ? 1 : 0
    },
    solicitarConfirmacionReparacionPrimeraVisita(ticket, valor) {
      if (!ticket?.id || this.guardandoReparacionPrimeraVisitaId) return
      const normalizado = Number(valor) === 1 ? 1 : 0
      if (this.valorReparacionActual(ticket) === normalizado) {
        this.mostrarSnackbar(
          normalizado === 1 ? 'Ya está registrado como SI.' : 'Ya está registrado como NO.',
          'info'
        )
        return
      }
      this.reparacionPrimeraVisitaContext = { ticket, valor: normalizado }
      this.dialogConfirm = {
        show: true,
        titulo: `Reparación 1ª visita · Ticket #${ticket.id}`,
        texto:
          normalizado === 1
            ? '¿Confirma que la reparación se realizó en la primera visita (SI)?'
            : '¿Confirma que la reparación NO se realizó en la primera visita (NO)?',
        color: normalizado === 1 ? 'success' : 'error',
        accion: this.ejecutarCambioReparacionPrimeraVisita,
      }
    },
    async ejecutarCambioReparacionPrimeraVisita() {
      const { ticket, valor } = this.reparacionPrimeraVisitaContext || {}
      if (!ticket?.id) {
        this.dialogConfirm.show = false
        return
      }
      this.accionCargando = true
      this.guardandoReparacionPrimeraVisitaId = ticket.id
      try {
        const res = await this.$store.dispatch('postventaTickets/cambiarReparacionPrimeraVisita', {
          ticket_id: ticket.id,
          reparacion_realizada_primera_visita: valor,
        })
        if (res.exito) {
          this.dialogConfirm.show = false
          this.mostrarSnackbar('Reparación primera visita actualizada.', 'success')
          await this.buscar()
          const updated = this.tickets?.find((t) => t.id === ticket.id)
          if (updated) {
            this.selected = [updated]
            this.ticketSeleccionado = updated
            this.subEstadoSeleccionado = updated.sub_estado_id
            this.prioridadSeleccionada = updated.prioridad_id
            this.detalleTicketId = updated.id
          }
        } else {
          this.mostrarSnackbar(res.message || 'Error al actualizar reparación primera visita.', 'error')
        }
      } finally {
        this.accionCargando = false
        this.guardandoReparacionPrimeraVisitaId = null
      }
    },
    descripcionFormateada(descripcionRaw) {
      const descripcion = String(descripcionRaw || '').trim()
      if (!descripcion) return 'Sin descripción cargada.'
      if (!/Generado por alerta automática/i.test(descripcion)) return descripcion

      let txt = descripcion
      txt = txt.replace(/\.\s*(Orden de Servicio:)/gi, '\n$1')
      txt = txt.replace(/\.\s*(VIN:)/gi, '\n$1')
      txt = txt.replace(/\.\s*(Patente:)/gi, '\n$1')
      txt = txt.replace(/\.\s*(Modelo:)/gi, '\n$1')
      txt = txt.replace(/\.\s*(Nombre de Cliente:)/gi, '\n\n$1')
      txt = txt.replace(/\.\s*(Codigo Cliente:)/gi, '\n$1')
      txt = txt.replace(/\.\s*(Código Cliente:)/gi, '\n$1')
      txt = txt.replace(/Generado por alerta automática\./i, 'Generado por alerta automática')
      txt = txt.replace(/^\s+|\s+$/g, '')
      return txt
    },

    limpiarFiltros() {
      Object.keys(this.filtro).forEach((k) => (this.filtro[k] = null))
      this.usarRangoFechas = false
      this.incluirFinalizados = false
      this.buscar()
    },

    archivosPorComentario(comentario_id) {
      return this.archivosDelTicket.filter((a) => a.comentario_id === comentario_id)
    },

    subEstadosFiltradosPorEstado(estado_id, tipo_ticket_id = null) {
      const activos = this.subEstados.filter((s) => Number(s.activo) !== 0)
      return activos.filter((s) => {
        const coincideEstado = !estado_id || s.estado_id_padre === estado_id
        const coincideTipo = !tipo_ticket_id || s.tipo_ticket_id === tipo_ticket_id
        return coincideEstado && coincideTipo
      })
    },

    nombreEstado(estadoId) {
      return this.estados.find((e) => e.id === estadoId)?.nombre || '—'
    },
    nombreTipo(tipoId) {
      return this.tipos.find((t) => t.id === tipoId)?.nombre || '—'
    },

    async abrirGestionSubEstados() {
      if (!this.esRol56) return
      await this.$store.dispatch('postventaTickets/getSubEstadosAdmin')
      this.dialogGestionSubEstados = true
    },
    async abrirGestionDestinatariosReparacion() {
      if (!this.puedeGestionarDestinatariosReparacion || !this.esModoReparacion0km) return
      if (!this.destinatarioEmpresaId && Array.isArray(this.empresas) && this.empresas.length > 0) {
        this.destinatarioEmpresaId = this.empresas[0].Id
      }
      this.dialogGestionDestinatariosReparacion = true
      await this.cargarDestinatariosReparacion()
    },
    async cargarDestinatariosReparacion() {
      this.cargandoDestinatariosReparacion = true
      try {
        const payload = {
          tipo_alerta: this.destinatarioTipoAlerta,
        }
        if (this.destinatarioEmpresaId) payload.empresa_id = this.destinatarioEmpresaId
        const res = await this.$store.dispatch('postventaTickets/getDestinatariosReparacion', payload)
        if (res.exito) {
          this.destinatariosReparacion = Array.isArray(res.data) ? res.data : []
        } else {
          this.mostrarSnackbar(res.message || 'No se pudieron cargar los destinatarios.', 'error')
        }
      } finally {
        this.cargandoDestinatariosReparacion = false
      }
    },
    async crearDestinatarioReparacion() {
      if (!this.destinatarioEmpresaId || !this.destinatarioTipoAlerta || !this.validarEmail(this.destinatarioNuevoEmail)) {
        this.mostrarSnackbar('Debe indicar empresa, tipo de alerta y un email válido.', 'warning')
        return
      }
      this.guardandoDestinatarioReparacion = true
      try {
        const res = await this.$store.dispatch('postventaTickets/altaDestinatarioReparacion', {
          empresa_id: this.destinatarioEmpresaId,
          tipo_alerta: this.destinatarioTipoAlerta,
          email: this.destinatarioNuevoEmail,
        })
        if (res.exito) {
          this.destinatarioNuevoEmail = ''
          await this.cargarDestinatariosReparacion()
          this.mostrarSnackbar(res.message || 'Destinatario dado de alta.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo crear el destinatario.', 'error')
        }
      } finally {
        this.guardandoDestinatarioReparacion = false
      }
    },
    abrirEditarDestinatarioReparacion(item) {
      this.destinatarioReparacionEditar = {
        id: item.id,
        empresa_id: item.empresa_id,
        tipo_alerta: item.tipo_alerta || 'reparacion_realizada',
        email: item.email || '',
      }
      this.dialogEditarDestinatarioReparacion = true
    },
    cerrarEditarDestinatarioReparacion() {
      this.dialogEditarDestinatarioReparacion = false
      this.destinatarioReparacionEditar = {
        id: null,
        empresa_id: null,
        tipo_alerta: this.destinatarioTipoAlerta || 'reparacion_realizada',
        email: '',
      }
    },
    tipoAlertaDestinatarioTexto(tipo) {
      const hit = this.tiposDestinatarioAlertaOptions.find((item) => item.value === tipo)
      return hit ? hit.text : (tipo || '—')
    },
    async guardarEdicionDestinatarioReparacion() {
      if (!this.destinatarioReparacionEditar.id || !this.destinatarioReparacionEditar.empresa_id || !this.destinatarioReparacionEditar.tipo_alerta || !this.validarEmail(this.destinatarioReparacionEditar.email)) {
        this.mostrarSnackbar('Debe indicar empresa, tipo de alerta y un email válido.', 'warning')
        return
      }
      this.guardandoEdicionDestinatarioReparacion = true
      try {
        const res = await this.$store.dispatch('postventaTickets/editarDestinatarioReparacion', this.destinatarioReparacionEditar)
        if (res.exito) {
          this.cerrarEditarDestinatarioReparacion()
          await this.cargarDestinatariosReparacion()
          this.mostrarSnackbar(res.message || 'Destinatario actualizado con éxito.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo actualizar el destinatario.', 'error')
        }
      } finally {
        this.guardandoEdicionDestinatarioReparacion = false
      }
    },
    async darBajaDestinatarioReparacion(item) {
      this.destinatarioReparacionBajandoId = item.id
      try {
        const res = await this.$store.dispatch('postventaTickets/bajaDestinatarioReparacion', { id: item.id })
        if (res.exito) {
          await this.cargarDestinatariosReparacion()
          this.mostrarSnackbar(res.message || 'Destinatario dado de baja.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo dar de baja el destinatario.', 'error')
        }
      } finally {
        this.destinatarioReparacionBajandoId = null
      }
    },
    async darAltaDestinatarioReparacion(item) {
      this.destinatarioReparacionAltaId = item.id
      try {
        const res = await this.$store.dispatch('postventaTickets/reactivarDestinatarioReparacion', { id: item.id })
        if (res.exito) {
          await this.cargarDestinatariosReparacion()
          this.mostrarSnackbar(res.message || 'Destinatario dado de alta.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo dar de alta el destinatario.', 'error')
        }
      } finally {
        this.destinatarioReparacionAltaId = null
      }
    },

    async crearSubEstado() {
      if (!this.subEstadoNuevo.estado_id_padre || !this.subEstadoNuevo.tipo_ticket_id || !this.subEstadoNuevo.nombre) {
        this.mostrarSnackbar('Debe indicar estado, tipo y nombre del sub-estado.', 'warning')
        return
      }
      this.guardandoSubEstado = true
      try {
        const res = await this.$store.dispatch('postventaTickets/altaSubEstado', this.subEstadoNuevo)
        if (res.exito) {
          this.subEstadoNuevo.nombre = ''
          this.subEstadoNuevo.estado_id_padre = null
          this.subEstadoNuevo.tipo_ticket_id = null
          await this.$store.dispatch('postventaTickets/getSubEstadosAdmin')
          this.mostrarSnackbar(res.message || 'Sub-estado dado de alta.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo crear el sub-estado.', 'error')
        }
      } finally {
        this.guardandoSubEstado = false
      }
    },

    abrirEditarSubEstado(subEstado) {
      this.subEstadoEditar = {
        id: subEstado.id,
        estado_id_padre: subEstado.estado_id_padre,
        tipo_ticket_id: subEstado.tipo_ticket_id,
        nombre: subEstado.nombre || '',
      }
      this.dialogEditarSubEstado = true
    },

    cerrarEditarSubEstado() {
      this.dialogEditarSubEstado = false
      this.subEstadoEditar = {
        id: null,
        estado_id_padre: null,
        tipo_ticket_id: null,
        nombre: '',
      }
    },

    async guardarEdicionSubEstado() {
      if (!this.subEstadoEditar.id || !this.subEstadoEditar.estado_id_padre || !this.subEstadoEditar.tipo_ticket_id || !this.subEstadoEditar.nombre) {
        this.mostrarSnackbar('Debe indicar estado, tipo y nombre del sub-estado.', 'warning')
        return
      }

      this.guardandoEdicionSubEstado = true
      try {
        const payload = {
          sub_estado_id: this.subEstadoEditar.id,
          estado_id_padre: this.subEstadoEditar.estado_id_padre,
          tipo_ticket_id: this.subEstadoEditar.tipo_ticket_id,
          nombre: this.subEstadoEditar.nombre,
        }
        const res = await this.$store.dispatch('postventaTickets/editarSubEstado', payload)
        if (res.exito) {
          await this.$store.dispatch('postventaTickets/getSubEstadosAdmin')
          this.mostrarSnackbar(res.message || 'Sub-estado actualizado con éxito.', 'success')
          this.cerrarEditarSubEstado()
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo actualizar el sub-estado.', 'error')
        }
      } finally {
        this.guardandoEdicionSubEstado = false
      }
    },

    async darBajaSubEstado(subEstado) {
      this.subEstadoBajandoId = subEstado.id
      try {
        const res = await this.$store.dispatch('postventaTickets/bajaSubEstado', { sub_estado_id: subEstado.id })
        if (res.exito) {
          const idx = this.subEstados.findIndex((s) => s.id === subEstado.id)
          if (idx !== -1) this.subEstados[idx].activo = 0
          await this.$store.dispatch('postventaTickets/getSubEstadosAdmin')
          this.mostrarSnackbar(res.message || 'Sub-estado dado de baja.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo dar de baja el sub-estado.', 'error')
        }
      } finally {
        this.subEstadoBajandoId = null
      }
    },

    async darAltaSubEstado(subEstado) {
      this.subEstadoAltaId = subEstado.id
      try {
        const res = await this.$store.dispatch('postventaTickets/reactivarSubEstado', { sub_estado_id: subEstado.id })
        if (res.exito) {
          const idx = this.subEstados.findIndex((s) => s.id === subEstado.id)
          if (idx !== -1) this.subEstados[idx].activo = 1
          await this.$store.dispatch('postventaTickets/getSubEstadosAdmin')
          this.mostrarSnackbar(res.message || 'Sub-estado dado de alta.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo dar de alta el sub-estado.', 'error')
        }
      } finally {
        this.subEstadoAltaId = null
      }
    },

    confirmarEliminarSubEstado(subEstado) {
      this.subEstadoAEliminar = subEstado
      this.dialogConfirm = {
        show: true,
        titulo: 'Eliminar sub-estado',
        texto: `¿Está seguro de eliminar definitivamente "${subEstado.nombre}"? Esta acción no se puede deshacer.`,
        color: 'error',
        accion: this.eliminarSubEstadoConfirmado,
      }
    },

    async eliminarSubEstadoConfirmado() {
      if (!this.subEstadoAEliminar) return
      this.subEstadoEliminandoId = this.subEstadoAEliminar.id
      this.accionCargando = true
      try {
        const res = await this.$store.dispatch('postventaTickets/eliminarSubEstadoDefinitivo', { sub_estado_id: this.subEstadoAEliminar.id })
        if (res.exito) {
          this.dialogConfirm.show = false
          await this.$store.dispatch('postventaTickets/getSubEstadosAdmin')
          this.mostrarSnackbar(res.message || 'Sub-estado eliminado.', 'success')
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo eliminar el sub-estado.', 'error')
        }
      } finally {
        this.subEstadoAEliminar = null
        this.subEstadoEliminandoId = null
        this.accionCargando = false
      }
    },

    async guardarSubEstado(ticket) {
      if (this.esTicketFinalizado(ticket)) {
        this.mostrarSnackbar('El ticket está finalizado y no permite más acciones.', 'info')
        return
      }
      const res = await this.$store.dispatch('postventaTickets/cambiarSubEstado', {
        ticket_id: ticket.id,
        sub_estado_id: this.subEstadoSeleccionado,
      })
      if (res.exito) {
        this.mostrarSnackbar('Sub-estado actualizado.', 'success')
        await this.buscar()
        const updated = this.tickets?.find((t) => t.id === ticket.id)
        if (updated) {
          this.selected = [updated]
          this.ticketSeleccionado = updated
          this.subEstadoSeleccionado = updated.sub_estado_id
          this.detalleTicketId = updated.id
          this.snapshotAccionesRapidas(updated)
        }
      } else {
        this.mostrarSnackbar(res.message || 'Error al actualizar.', 'error')
      }
    },
    async guardarPrioridad(ticket) {
      const prioridad = Number(this.prioridadSeleccionada)
      if (!ticket?.id || !prioridad) return
      if (this.esTicketFinalizado(ticket)) {
        this.mostrarSnackbar('El ticket está finalizado y no permite más acciones.', 'info')
        return
      }
      const res = await this.$store.dispatch('postventaTickets/cambiarPrioridad', {
        ticket_id: ticket.id,
        prioridad_id: prioridad,
      })
      if (res.exito) {
        this.mostrarSnackbar('Prioridad actualizada.', 'success')
        await this.buscar()
        const updated = this.tickets?.find((t) => t.id === ticket.id)
        if (updated) {
          this.selected = [updated]
          this.ticketSeleccionado = updated
          this.subEstadoSeleccionado = updated.sub_estado_id
          this.prioridadSeleccionada = updated.prioridad_id
          this.detalleTicketId = updated.id
          this.snapshotAccionesRapidas(updated)
        }
      } else {
        this.mostrarSnackbar(res.message || 'Error al actualizar prioridad.', 'error')
      }
    },
    abrirDialogPrioridad(item) {
      if (!item?.id) return
      if (this.esTicketFinalizado(item)) {
        this.mostrarSnackbar('El ticket está finalizado y no permite más acciones.', 'info')
        this.contextMenu.show = false
        return
      }
      this.ticketPrioridadContexto = item
      this.prioridadSeleccionadaDialog = item.prioridad_id || null
      this.dialogPrioridad = true
      this.contextMenu.show = false
    },
    async guardarPrioridadDesdeDialog() {
      if (!this.ticketPrioridadContexto?.id || !this.prioridadSeleccionadaDialog) return
      if (this.esTicketFinalizado(this.ticketPrioridadContexto)) {
        this.dialogPrioridad = false
        this.mostrarSnackbar('El ticket está finalizado y no permite más acciones.', 'info')
        return
      }
      const res = await this.$store.dispatch('postventaTickets/cambiarPrioridad', {
        ticket_id: this.ticketPrioridadContexto.id,
        prioridad_id: this.prioridadSeleccionadaDialog,
      })
      if (res.exito) {
        this.dialogPrioridad = false
        this.mostrarSnackbar('Prioridad actualizada.', 'success')
        await this.buscar()
      } else {
        this.mostrarSnackbar(res.message || 'Error al actualizar prioridad.', 'error')
      }
    },

    escapeHtml(s) {
      return String(s ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
    },

    comentarioHtmlConMenciones(texto) {
      const s = this.escapeHtml(texto || '')
      const usernames = (this.usuariosMenciones || [])
        .map((u) => u.Username)
        .filter(Boolean)
        .sort((a, b) => b.length - a.length)
      const set = new Set(usernames)
      return s.replace(/@([^\s@]+)/g, (full, uname) =>
        set.has(uname) ? `<span class="accent--text">${this.escapeHtml('@' + uname)}</span>` : full
      )
    },

    async enviarComentario(ticket) {
      if (this.esTicketFinalizado(ticket)) {
        this.mostrarSnackbar('El ticket está finalizado y no permite más acciones.', 'info')
        return
      }
      const texto = (this.nuevoComentarioTexto || '').trim()
      if (!texto) return
      if (!this.esRol56) this.esComentarioInterno = false
      const comp = this.$refs.composerMenciones
      const menciones_emails = comp && comp.getMencionesEmails ? comp.getMencionesEmails() : []
      this.enviandoComentario = true
      try {
        const res = await this.$store.dispatch('postventaTickets/nuevoComentario', {
          ticket_id: ticket.id,
          comentario: texto,
          estado_ticket_id: ticket.estado_id,
          es_comentario_interno: this.esComentarioInterno,
          menciones_emails,
          smtp_profile: this.smtpProfileMencionesComentario,
        })
        if (res.exito) {
          if (this.archivosSeleccionados.length > 0) {
            await this.subirArchivos(ticket.id, res.data.id, ticket.estado_id)
          }
          this.nuevoComentarioTexto = ''
          if (comp && comp.clear) comp.clear()
          this.archivosSeleccionados = []
          await this.cargarDetalleTicket(ticket, { force: true })
          let msg = 'Comentario enviado.'
          if (res.email_skipped && menciones_emails.length > 0) {
            msg += ' No se enviaron avisos por correo (SMTP no configurado).'
            this.mostrarSnackbar(msg, 'warning')
          } else {
            if (menciones_emails.length > 0 && Number(res.email_avisos_fallidos) > 0) {
              msg += ' Algunos correos de aviso no se pudieron enviar.'
              this.mostrarSnackbar(msg, 'warning')
            } else {
              this.mostrarSnackbar(msg, 'success')
            }
          }
        } else {
          this.mostrarSnackbar(res.message, 'error')
        }
      } finally {
        this.enviandoComentario = false
      }
    },

    async subirArchivos(ticket_id, comentario_id, estado_id) {
      const archivos = [], nombres = []
      for (const file of this.archivosSeleccionados) {
        archivos.push(await this.fileToBase64(file))
        nombres.push(file.name)
      }
      await this.$store.dispatch('postventaTickets/cargarArchivos', { ticket_id, comentario_id, estado_id, archivos, nombreArchivos: nombres })
    },

    fileToBase64(file) {
      return new Promise((resolve) => {
        const r = new FileReader()
        r.onload = (e) => resolve(e.target.result)
        r.readAsDataURL(file)
      })
    },

    abrirContextMenu(e, { item }) {
      e.preventDefault()
      this.contextMenu.show = false
      this.$nextTick(() => {
        this.contextMenu = { show: true, x: e.clientX, y: e.clientY, item }
      })
    },

    abrirAsignar(item) {
      this.ticketSeleccionado = item
      this.asignarForm = {
        usuario_asignado: item.usuario_asignado,
        estado_id: item.estado_id,
        sub_estado_id: item.sub_estado_id,
        prioridad_id: item.prioridad_id,
      }
      this.dialogAsignar = true
    },

    async ejecutarAsignar() {
      if (!this.asignarForm.usuario_asignado || !this.asignarForm.estado_id || !this.asignarForm.prioridad_id) {
        this.mostrarSnackbar('Complete los campos obligatorios.', 'warning')
        return
      }
      this.accionCargando = true
      try {
        const res = await this.$store.dispatch('postventaTickets/asignarTicket', {
          ticket_id: this.ticketSeleccionado.id,
          ...this.asignarForm,
        })
        if (res.exito) {
          this.dialogAsignar = false
          this.mostrarSnackbar(res.message, 'success')
          await this.buscar()
        } else {
          this.mostrarSnackbar(res.message, 'error')
        }
      } finally {
        this.accionCargando = false
      }
    },

    confirmarFinalizar(item) {
      if (this.esTicketFinalizado(item)) {
        this.mostrarSnackbar('El ticket ya está finalizado.', 'info')
        return
      }
      if (!this.puedeFinalizarTicket(item)) {
        const aviso = this.esModoReparacion0km
          ? 'Solo se puede finalizar tickets en estado ASIGNADO.'
          : 'Solo se puede finalizar en estado ASIGNADO y sub-estado FACTURADO o NO FACTURADO - RECLAMO NO ACEPTADO.'
        this.mostrarSnackbar(aviso, 'warning')
        return
      }
      this.ticketSeleccionado = item
      const textoFinalizar0km = 'Certifico que la reparación fue realizada en su totalidad, quedando el vehículo disponible para la venta.'
      this.dialogConfirm = {
        show: true,
        titulo: `Finalizar Ticket #${item.id}`,
        texto: this.esModoReparacion0km
          ? textoFinalizar0km
          : `¿Está seguro de que desea finalizar el ticket "${item.asunto}"?`,
        color: 'success',
        accion: this.ejecutarFinalizar,
      }
    },

    async ejecutarFinalizar() {
      this.accionCargando = true
      try {
        const res = await this.$store.dispatch('postventaTickets/finalizarTicket', {
          ticket_id: this.ticketSeleccionado.id,
        })
        if (res.exito) {
          this.dialogConfirm.show = false
          let mensaje = res.message || 'Ticket finalizado.'
          if (this.esModoReparacion0km && Number(res.mail_avisos_fallidos) > 0) {
            mensaje += ' Algunos avisos de reparación no se pudieron enviar.'
          }
          if (this.esModoReparacion0km && res.mail_skipped) {
            mensaje += ' No se enviaron avisos por correo (SMTP no configurado).'
          }
          this.mostrarSnackbar(mensaje, 'success')
          await this.buscar()
        } else {
          this.mostrarSnackbar(res.message, 'error')
        }
      } finally {
        this.accionCargando = false
      }
    },

    confirmarReabrir(item) {
      this.contextMenu.show = false
      this.mostrarSnackbar('El ticket está finalizado y no permite más acciones.', 'info')
    },

    async ejecutarReabrir() {
      this.accionCargando = true
      try {
        const res = await this.$store.dispatch('postventaTickets/reabrirTicket', { ticket_id: this.ticketSeleccionado.id })
        if (res.exito) {
          this.dialogConfirm.show = false
          this.mostrarSnackbar(res.message, 'success')
          await this.buscar()
        } else {
          this.mostrarSnackbar(res.message, 'error')
        }
      } finally {
        this.accionCargando = false
      }
    },

    getUsuarioLogueadoId() {
      const u = this.$store.state.usuario || {}
      return Number(
        u.id ||
        u.usuario_id ||
        u.Usuario_id ||
        u.user_id ||
        u.User_id ||
        0
      ) || null
    },

    getEmpresaIdDelSolicitanteDesdeStore() {
      const familias = this.$store.state.familias || []
      if (!Array.isArray(familias) || familias.length === 0) return null
      const f = familias[0]
      return Number(f.Familia_id || f.Id || f.id || f.empresa_id || 0) || null
    },

    async inferirEmpresaDeSolicitante(solicitanteId) {
      const id = Number(solicitanteId)
      if (!id) return null
      try {
        const res = await this.$store.dispatch('usuarios/get_empresas_usuario', id)
        const data = Array.isArray(res?.data) ? res.data : []
        if (data.length === 0) return null
        const e = data[0]
        return Number(
          e.Familia_id ||
          e.empresa_id ||
          e.Empresa_id ||
          e.Id ||
          e.id ||
          0
        ) || null
      } catch (e) {
        return null
      }
    },

    async cargarUsuariosAsignablesGarantias() {
      this.cargandoUsuariosAsignablesGarantias = true
      try {
        const res = await this.$store.dispatch('postventaTickets/getUsuariosAsignablesGarantias')
        this.usuariosAsignablesGarantias = Array.isArray(res?.data) ? res.data : []
      } catch (e) {
        this.usuariosAsignablesGarantias = []
      } finally {
        this.cargandoUsuariosAsignablesGarantias = false
      }
    },

    async abrirNuevoTicket() {
      const tipoReparacion0kmId = this.obtenerTipoReparacion0kmId()
      const prioridadNormalId = this.obtenerPrioridadNormalId()
      this.nuevoTicketForm = {
        asunto: '',
        descripcion: '',
        usuario_asignado: null,
        empresa: null,
        sucursal: null,
        tipo_ticket_id: this.esTabReclamoGarantia ? 2 : (this.esTabReclamoTransporte ? 1 : (this.esModoReparacion0km ? tipoReparacion0kmId : null)),
        prioridad_id: prioridadNormalId,
        numero_orden: null,
        unidad_id: null,
      }
      if (this.esTabReclamoGarantia || this.esTabReclamoTransporte || this.esModoReparacion0km) {
        this.usuariosAsignablesGarantias = []
        this.nuevoTicketForm.sucursal = null
      }
      this.archivosNuevoTicket = []
      this.dialogNuevoTicket = true
      this.$nextTick(() => this.$refs.formNuevo && this.$refs.formNuevo.resetValidation())
    },

    reglaUsuarioAsignadoRequerido(v) {
      if (!this.mostrarSelectorUsuarioAsignadoNuevoTicket) return true
      return !!v || 'Seleccione un usuario asignado'
    },

    async autocompletarNuevoTicketDesdeOrden() {
      if (!this.esTabReclamoGarantia && !this.esTabReclamoTransporte && !this.esModoReparacion0km) return true
      const ordenNum = Number(this.nuevoTicketForm.numero_orden)
      if (!ordenNum || Number.isNaN(ordenNum) || ordenNum <= 0) return false
      this.cargandoContextoNuevoTicket = true
      try {
        const payload = {
          orden_servicio_id: ordenNum,
          tipo_ticket_id: this.nuevoTicketForm.tipo_ticket_id,
        }
        const res = await this.$store.dispatch('postventaTickets/getContextoNuevoTicketOrden', payload)
        if (!res?.exito) {
          this.mostrarSnackbar(res?.message || 'No se pudo autocompletar con NumeroOrden.', 'error')
          this.usuariosAsignablesGarantias = []
          this.nuevoTicketForm.usuario_asignado = null
          return false
        }
        const data = res.data || {}
        this.nuevoTicketForm.empresa = Number(data.empresa_id) || null
        this.nuevoTicketForm.sucursal = Number(data.sucursal_id) || null
        this.nuevoTicketForm.unidad_id = Number(data.unidad_id) || null
        this.nuevoTicketForm.asunto = data.asunto || this.nuevoTicketForm.asunto
        this.nuevoTicketForm.descripcion = data.descripcion || this.nuevoTicketForm.descripcion
        this.nuevoTicketForm.numero_orden = Number(data.numero_orden || ordenNum)
        this.usuariosAsignablesGarantias = Array.isArray(data.usuarios_asignables) ? data.usuarios_asignables : []
        if (this.usuariosAsignablesGarantias.length === 1) {
          this.nuevoTicketForm.usuario_asignado = this.usuariosAsignablesGarantias[0].Usuario_id
        } else {
          this.nuevoTicketForm.usuario_asignado = null
          if (this.usuariosAsignablesGarantias.length === 0) {
            this.mostrarSnackbar('No hay usuarios configurados para el rol de gestión de este tipo de ticket.', 'warning')
          }
        }
        return true
      } catch (e) {
        this.usuariosAsignablesGarantias = []
        this.nuevoTicketForm.usuario_asignado = null
        this.mostrarSnackbar('Error al consultar contexto por NumeroOrden.', 'error')
        return false
      } finally {
        this.cargandoContextoNuevoTicket = false
      }
    },

    async crearTicket() {
      if ((this.esTabReclamoGarantia || this.esTabReclamoTransporte || this.esModoReparacion0km) && !this.cargandoContextoNuevoTicket) {
        const ok = await this.autocompletarNuevoTicketDesdeOrden()
        if (!ok) return
      }
      if (!this.$refs.formNuevo.validate()) return
      this.creandoTicket = true
      try {
        const payload = { ...this.nuevoTicketForm }
        if (this.esTabReclamoGarantia) {
          payload.solicitante = this.getUsuarioLogueadoId()
          payload.tipo_ticket_id = 2
        } else if (this.esModoReparacion0km) {
          const tipo = this.obtenerTipoReparacion0kmId()
          if (!tipo) {
            this.mostrarSnackbar('No se encontró el tipo "Reparación de Vehículos 0km".', 'warning')
            return
          }
          payload.tipo_ticket_id = tipo
        }
        const res = await this.$store.dispatch('postventaTickets/nuevoTicket', payload)
        if (res.exito) {
          if (this.archivosNuevoTicket.length > 0) {
            const archivos = [], nombres = []
            for (const f of this.archivosNuevoTicket) { archivos.push(await this.fileToBase64(f)); nombres.push(f.name) }
            await this.$store.dispatch('postventaTickets/cargarArchivos', { ticket_id: res.data.id, comentario_id: null, estado_id: 1, archivos, nombreArchivos: nombres })
          }
          this.dialogNuevoTicket = false
          this.mostrarSnackbar('Ticket creado con éxito.', 'success')
          await this.buscar()
        } else {
          this.mostrarSnackbar(res.message, 'error')
        }
      } finally {
        this.creandoTicket = false
      }
    },

    colorEstado(estado_id) {
      const m = { 1: 'warning', 2: 'info', 3: 'success', 4: 'red' }
      return m[estado_id] || 'grey'
    },

    colorPrioridad(prioridad_id) {
      const m = { 1: 'red', 2: 'orange', 3: 'red' }
      return m[prioridad_id] || 'grey'
    },

    formatFecha(fecha) {
      if (!fecha) return '—'
      return moment.utc(fecha).format('DD/MM/YY [a las] HH:mm')
    },

    mostrarSnackbar(text, color) {
      this.snackbar = { value: true, text, color }
    },
    tipoArchivoLabel(tipo, orden) {
      const map = {
        DANO: 'Daño',
        FALLA: 'Falla',
        ODOMETRO: 'Odómetro',
        VIN: 'VIN',
        PATENTE: 'Patente',
        CAT: 'CAT',
        CONSULTA_CAT: 'Consulta CAT',
        HISTORICO_GWM: 'Historico GWM',
        REMITO_FRENTE: 'Remito frente',
        REMITO_DORSO: 'Remito dorso',
        REMITO_CAMION: 'Remito camión',
      }
      const t = String(tipo || '').toUpperCase()
      const base = map[t] || 'Foto'
      if (
        (t === 'FALLA' || t === 'CAT' || t === 'CONSULTA_CAT' || t === 'DANO' || t === 'HISTORICO_GWM') &&
        Number(orden) > 0
      ) {
        return `${base} #${orden}`
      }
      return base
    },
    extFromFile(file) {
      const n = String(file?.name || '')
      const dot = n.lastIndexOf('.')
      return dot >= 0 ? n.slice(dot).toLowerCase() : '.jpg'
    },
    resolverEvidenciaIdGaleria() {
      const fromDetalle = Number(this.garantiasDetalleForm?.evidencia_id || 0)
      if (fromDetalle > 0) return fromDetalle
      const fromGaleria = this.galeriaUnidadImagenes.find((img) => Number(img?.evidencia_id || 0) > 0)
      return Number(fromGaleria?.evidencia_id || 0) || null
    },
    resolverRecepcionIdGaleria() {
      const fromGaleria = this.galeriaUnidadImagenes.find((img) => Number(img?.recepcion_id || 0) > 0)
      return Number(fromGaleria?.recepcion_id || 0) || null
    },
    resolverVinUltimos6Galeria() {
      const fromGaleria = String(this.galeriaUnidadImagenes.find((img) => String(img?.vin_ultimos_6 || '').trim())?.vin_ultimos_6 || '').trim()
      if (fromGaleria) return fromGaleria.toUpperCase().slice(0, 6)
      const vin = String(this.ticketSeleccionado?.unidad_vin || '').trim().toUpperCase()
      return vin ? vin.slice(-6) : ''
    },
    normalizarArchivoGaleriaEditable(item) {
      return {
        id: Number(item?.id || item?.archivo_id || 0) || null,
        evidencia_id: Number(item?.evidencia_id || 0) || null,
        recepcion_id: Number(item?.recepcion_id || 0) || null,
        vin_ultimos_6: String(item?.vin_ultimos_6 || '').trim().toUpperCase(),
        tipo_archivo: String(item?.tipo_archivo || '').trim().toUpperCase() || 'FALLA',
        orden: Number(item?.orden || 0) || 0,
        archivo_url: item?.archivo_url || item?.url || '',
        extension_archivo: item?.extension_archivo || item?.extension || '',
      }
    },
    async abrirEditarGaleria(contexto, opts = {}) {
      const esTransporte = this.esTabReclamoTransporte
      let evidenciaId = this.resolverEvidenciaIdGaleria()
      const recepcionId = this.resolverRecepcionIdGaleria()
      if (!esTransporte && !evidenciaId && this.esTabReclamoGarantia) {
        const orden = Number(this.galeriaGarantiasOrdenServicio || 0)
        if (Number.isFinite(orden) && orden > 0) {
          const ok = await this.asegurarEvidenciaGarantiaSiFalta()
          if (ok) evidenciaId = this.resolverEvidenciaIdGaleria()
        }
      }
      if (!esTransporte && !evidenciaId) {
        this.mostrarSnackbar('No hay evidencia de garantía vinculada para editar imágenes.', 'warning')
        return
      }
      if (esTransporte && !recepcionId) {
        this.mostrarSnackbar('No hay recepción vinculada para editar imágenes de transporte.', 'warning')
        return
      }
      this.editGaleriaContexto = String(contexto || '')
      this.editGaleriaTipo = esTransporte ? 'transporte' : 'garantia'
      const soloCat = !esTransporte && !!opts.soloCatConsulta
      this.editGaleriaSoloCatConsulta = soloCat
      this.editGaleriaSoloHistoricoGwm = !esTransporte && !!opts.soloHistoricoGwm && !soloCat
      const archivosTodos = (this.galeriaUnidadImagenes || []).map((a) => this.normalizarArchivoGaleriaEditable(a))
      const esHist = (a) => String(a.tipo_archivo || '').trim().toUpperCase() === 'HISTORICO_GWM'
      const esCatTipo = (a) => {
        const t = String(a.tipo_archivo || '').trim().toUpperCase()
        return t === 'CONSULTA_CAT' || t === 'CAT'
      }
      let archivosInicial
      if (this.editGaleriaSoloHistoricoGwm) {
        archivosInicial = archivosTodos.filter(esHist)
      } else if (this.editGaleriaSoloCatConsulta) {
        archivosInicial = archivosTodos.filter(esCatTipo)
      } else {
        archivosInicial = archivosTodos.filter((a) => !esHist(a))
      }
      this.editGaleriaForm = {
        evidencia_id: evidenciaId || null,
        recepcion_id: recepcionId || null,
        vin_ultimos_6: this.resolverVinUltimos6Galeria(),
        archivos: archivosInicial,
        archivosEliminarIds: [],
        autoDeleteArchivoIds: [],
        nuevosArchivosDano: [],
        previewNuevosDano: [],
        nuevosArchivosFalla: [],
        previewNuevosFalla: [],
        nuevosArchivosCat: [],
        previewNuevosCat: [],
        nuevosArchivosHistoricoGwm: [],
        previewNuevosHistoricoGwm: [],
        nuevoArchivoRemitoFrente: null,
        previewNuevoRemitoFrente: '',
        nuevoArchivoRemitoDorso: null,
        previewNuevoRemitoDorso: '',
        nuevoArchivoRemitoCamion: null,
        previewNuevoRemitoCamion: '',
        nuevoArchivoOdometro: null,
        previewNuevoOdometro: '',
        nuevoArchivoVin: null,
        previewNuevoVin: '',
        nuevoArchivoPatente: null,
        previewNuevoPatente: '',
      }
      this.dialogEditarGaleria = true
    },
    cerrarEditarGaleria() {
      this.revokeEditGaleriaObjectUrls()
      this.editGaleriaSoloHistoricoGwm = false
      this.editGaleriaSoloCatConsulta = false
      this.dialogEditarGaleria = false
    },
    revokeEditGaleriaObjectUrls() {
      ;(this.editGaleriaForm.previewNuevosDano || []).forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
      ;(this.editGaleriaForm.previewNuevosFalla || []).forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
      ;(this.editGaleriaForm.previewNuevosCat || []).forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
      ;(this.editGaleriaForm.previewNuevosHistoricoGwm || []).forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
      ;[
        this.editGaleriaForm.previewNuevoOdometro,
        this.editGaleriaForm.previewNuevoVin,
        this.editGaleriaForm.previewNuevoPatente,
        this.editGaleriaForm.previewNuevoRemitoFrente,
        this.editGaleriaForm.previewNuevoRemitoDorso,
        this.editGaleriaForm.previewNuevoRemitoCamion,
      ].forEach((u) => {
        if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      })
    },
    marcarArchivoEliminarGaleria(id) {
      if (!id) return
      if (!this.editGaleriaForm.archivosEliminarIds.includes(id)) {
        this.editGaleriaForm.archivosEliminarIds.push(id)
      }
    },
    desmarcarArchivoEliminarGaleria(id) {
      const idx = this.editGaleriaForm.archivosEliminarIds.indexOf(id)
      if (idx >= 0) this.editGaleriaForm.archivosEliminarIds.splice(idx, 1)
    },
    eliminarArchivoExistenteGaleria(id) {
      this.marcarArchivoEliminarGaleria(id)
      const autoIdx = this.editGaleriaForm.autoDeleteArchivoIds.indexOf(id)
      if (autoIdx >= 0) this.editGaleriaForm.autoDeleteArchivoIds.splice(autoIdx, 1)
    },
    getEditGaleriaFallasActivas() {
      return (this.editGaleriaForm.archivos || []).filter(
        (a) => String(a.tipo_archivo || '').toUpperCase() === 'FALLA' && !this.editGaleriaForm.archivosEliminarIds.includes(a.id)
      )
    },
    getEditGaleriaDanosActivos() {
      return (this.editGaleriaForm.archivos || []).filter(
        (a) => String(a.tipo_archivo || '').toUpperCase() === 'DANO' && !this.editGaleriaForm.archivosEliminarIds.includes(a.id)
      )
    },
    getEditGaleriaCatsActivos() {
      return (this.editGaleriaForm.archivos || []).filter((a) => {
        const t = String(a.tipo_archivo || '').toUpperCase()
        return (t === 'CONSULTA_CAT' || t === 'CAT') && !this.editGaleriaForm.archivosEliminarIds.includes(a.id)
      })
    },
    getEditGaleriaHistoricoGwmActivos() {
      return (this.editGaleriaForm.archivos || []).filter(
        (a) => String(a.tipo_archivo || '').toUpperCase() === 'HISTORICO_GWM' && !this.editGaleriaForm.archivosEliminarIds.includes(a.id)
      )
    },
    getEditSingleActivoGaleria(tipo) {
      const t = String(tipo || '').toUpperCase()
      return (this.editGaleriaForm.archivos || []).find(
        (a) => String(a.tipo_archivo || '').toUpperCase() === t && !this.editGaleriaForm.archivosEliminarIds.includes(a.id)
      )
    },
    getEditSingleOriginalGaleria(tipo) {
      const t = String(tipo || '').toUpperCase()
      return (this.editGaleriaForm.archivos || []).find((a) => String(a.tipo_archivo || '').toUpperCase() === t)
    },
    editPreviewSingleUrl(tipo) {
      const t = String(tipo || '').toUpperCase()
      const map = {
        ODOMETRO: 'previewNuevoOdometro',
        VIN: 'previewNuevoVin',
        PATENTE: 'previewNuevoPatente',
        REMITO_FRENTE: 'previewNuevoRemitoFrente',
        REMITO_DORSO: 'previewNuevoRemitoDorso',
        REMITO_CAMION: 'previewNuevoRemitoCamion',
      }
      const previewKey = map[t]
      if (previewKey && this.editGaleriaForm[previewKey]) return this.editGaleriaForm[previewKey]
      const a = this.getEditSingleActivoGaleria(t)
      return (a && a.archivo_url) || ''
    },
    onPickEditFallasGaleria(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type && f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.editGaleriaForm.nuevosArchivosFalla.push(f)
        this.editGaleriaForm.previewNuevosFalla.push(URL.createObjectURL(f))
      }
    },
    onPickEditDanosGaleria(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type && f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.editGaleriaForm.nuevosArchivosDano.push(f)
        this.editGaleriaForm.previewNuevosDano.push(URL.createObjectURL(f))
      }
    },
    removeEditDanoNuevo(i) {
      const u = this.editGaleriaForm.previewNuevosDano[i]
      if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      this.editGaleriaForm.previewNuevosDano.splice(i, 1)
      this.editGaleriaForm.nuevosArchivosDano.splice(i, 1)
    },
    removeEditFallaNuevo(i) {
      const u = this.editGaleriaForm.previewNuevosFalla[i]
      if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      this.editGaleriaForm.previewNuevosFalla.splice(i, 1)
      this.editGaleriaForm.nuevosArchivosFalla.splice(i, 1)
    },
    onPickEditCatGaleria(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type && f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.editGaleriaForm.nuevosArchivosCat.push(f)
        this.editGaleriaForm.previewNuevosCat.push(URL.createObjectURL(f))
      }
    },
    removeEditCatNuevo(i) {
      const u = this.editGaleriaForm.previewNuevosCat[i]
      if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      this.editGaleriaForm.previewNuevosCat.splice(i, 1)
      this.editGaleriaForm.nuevosArchivosCat.splice(i, 1)
    },
    onPickEditHistoricoGwmGaleria(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type && f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.editGaleriaForm.nuevosArchivosHistoricoGwm.push(f)
        this.editGaleriaForm.previewNuevosHistoricoGwm.push(URL.createObjectURL(f))
      }
    },
    removeEditHistoricoGwmNuevo(i) {
      const u = this.editGaleriaForm.previewNuevosHistoricoGwm[i]
      if (u && u.startsWith('blob:')) URL.revokeObjectURL(u)
      this.editGaleriaForm.previewNuevosHistoricoGwm.splice(i, 1)
      this.editGaleriaForm.nuevosArchivosHistoricoGwm.splice(i, 1)
    },
    payloadCamposTextoGarantiaEvidencia() {
      return {
        resumen_diagnostico: String(this.garantiasDetalleForm?.resumen_diagnostico || ''),
        horas_mo: this.garantiasDetalleForm?.horas_mo,
        codigo_mo: this.garantiasDetalleForm?.codigo_mo,
      }
    },
    async asegurarEvidenciaGarantiaSiFalta() {
      if (this.resolverEvidenciaIdGaleria()) return true
      if (!this.ticketSeleccionado?.id) {
        this.mostrarSnackbar('No hay ticket seleccionado.', 'warning')
        return false
      }
      try {
        const res = await this.$store.dispatch('postventaTickets/asegurarGarantiasEvidenciasPorTicket', {
          ticket_id: this.ticketSeleccionado.id,
        })
        if (!res.exito) {
          this.mostrarSnackbar(res.message || 'No se pudo preparar la evidencia de garantía.', 'error')
          return false
        }
        await this.cargarDetalleTicket(this.ticketSeleccionado, { force: true })
        return !!this.resolverEvidenciaIdGaleria()
      } catch (e) {
        this.mostrarSnackbar('No se pudo preparar la evidencia de garantía.', 'error')
        return false
      }
    },
    onPickHistoricoGwmDetalle(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type && f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.historicoGwmDetallePendienteArchivos.push(f)
        this.historicoGwmDetallePendientePreviews.push(URL.createObjectURL(f))
      }
    },
    limpiarHistoricoGwmDetallePendiente() {
      (this.historicoGwmDetallePendientePreviews || []).forEach((u) => {
        if (u && String(u).startsWith('blob:')) URL.revokeObjectURL(u)
      })
      this.historicoGwmDetallePendienteArchivos = []
      this.historicoGwmDetallePendientePreviews = []
    },
    removeHistoricoGwmDetallePendiente(i) {
      const u = this.historicoGwmDetallePendientePreviews[i]
      if (u && String(u).startsWith('blob:')) URL.revokeObjectURL(u)
      this.historicoGwmDetallePendientePreviews.splice(i, 1)
      this.historicoGwmDetallePendienteArchivos.splice(i, 1)
    },
    /**
     * Incorpora filas devueltas por garantías-evidencias/actualizar cuando falla la recarga de galería.
     * @returns {boolean} true si se agregó al menos una miniatura HISTORICO_GWM.
     */
    mergeHistoricoGwmArchivosRespuestaActualizar(archivosNuevos) {
      if (!Array.isArray(archivosNuevos) || !archivosNuevos.length) return false
      const existing = this.galeriaUnidadImagenes || []
      const seen = new Set(existing.map((img) => Number(img?.id)).filter((n) => n > 0))
      const toAdd = []
      for (const row of archivosNuevos) {
        const tipo = String(row?.tipo_archivo || '').trim().toUpperCase()
        if (tipo !== 'HISTORICO_GWM') continue
        const id = Number(row?.id || 0)
        if (!id || seen.has(id)) continue
        const url = row.url || row.archivo_url
        if (!url) continue
        seen.add(id)
        toAdd.push({
          id,
          evidencia_id: Number(row.evidencia_id || 0) || null,
          tipo_archivo: String(row.tipo_archivo || '').trim(),
          orden: row.orden,
          url,
          extension: row.extension ?? row.extension_archivo,
        })
      }
      if (!toAdd.length) return false
      this.galeriaUnidadImagenes = [...existing, ...toAdd]
      return true
    },
    async subirHistoricoGwmDetalleArchivos(files) {
      if (!files || !files.length) return true
      this.guardandoHistoricoGwmDetalle = true
      try {
        let evidenciaId = Number(this.resolverEvidenciaIdGaleria() || 0)
        if (!evidenciaId) {
          const ok = await this.asegurarEvidenciaGarantiaSiFalta()
          evidenciaId = Number(this.resolverEvidenciaIdGaleria() || 0)
          if (!ok || !evidenciaId) {
            this.mostrarSnackbar('No se pudo vincular una evidencia de garantía a la orden de servicio.', 'warning')
            return false
          }
        }
        const archivos = []
        const nombreArchivos = []
        let idx = 0
        for (const f of files) {
          if (!f || !f.type || !f.type.startsWith('image/')) continue
          idx += 1
          archivos.push(await this.fileToBase64(f))
          nombreArchivos.push(`historico_gwm_${String(idx).padStart(2, '0')}${this.extFromFile(f)}`)
        }
        if (!archivos.length) {
          this.mostrarSnackbar('No hay imágenes válidas para subir.', 'warning')
          return false
        }
        const payload = {
          evidencia_id: evidenciaId,
          archivos,
          nombreArchivos,
          archivos_eliminar_ids: [],
          ...this.payloadCamposTextoGarantiaEvidencia(),
        }
        const res = await this.$store.dispatch('postventaTickets/actualizarGarantiasEvidencias', payload)
        if (res.exito) {
          try {
            if (this.ticketSeleccionado) {
              await this.cargarDetalleTicket(this.ticketSeleccionado, { force: true })
            }
            this.limpiarHistoricoGwmDetallePendiente()
            this.mostrarSnackbar(res.message || 'Imágenes actualizadas.', 'success')
            return true
          } catch (e) {
            const merged = this.mergeHistoricoGwmArchivosRespuestaActualizar(res.data?.archivos_nuevos)
            if (merged) {
              this.limpiarHistoricoGwmDetallePendiente()
              this.mostrarSnackbar(res.message || 'Imágenes actualizadas.', 'success')
              return true
            }
            this.mostrarSnackbar(
              'Las imágenes se guardaron pero no se pudo actualizar la vista. Reintentá o recargá la página.',
              'warning'
            )
            return true
          }
        }
        this.mostrarSnackbar(res.message || 'No se pudieron subir las imágenes.', 'error')
        return false
      } finally {
        this.guardandoHistoricoGwmDetalle = false
      }
    },
    async eliminarHistoricoGwmDetalle(imgItem) {
      const id = Number(imgItem?.id || imgItem?.archivo_id || 0)
      if (!id) return
      const evidenciaId = Number(this.resolverEvidenciaIdGaleria() || 0)
      if (!evidenciaId) {
        this.mostrarSnackbar('No hay evidencia de garantía vinculada.', 'warning')
        return
      }
      this.guardandoHistoricoGwmDetalle = true
      try {
        const payload = {
          evidencia_id: evidenciaId,
          archivos: [],
          nombreArchivos: [],
          archivos_eliminar_ids: [id],
          ...this.payloadCamposTextoGarantiaEvidencia(),
        }
        const res = await this.$store.dispatch('postventaTickets/actualizarGarantiasEvidencias', payload)
        if (res.exito) {
          this.mostrarSnackbar('Imagen eliminada.', 'success')
          if (this.ticketSeleccionado) await this.cargarDetalleTicket(this.ticketSeleccionado, { force: true })
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo eliminar.', 'error')
        }
      } finally {
        this.guardandoHistoricoGwmDetalle = false
      }
    },
    onPickCatDetalle(e) {
      const files = Array.from(e.target.files || []).filter((f) => f.type && f.type.startsWith('image/'))
      e.target.value = ''
      for (const f of files) {
        this.catDetallePendienteArchivos.push(f)
        this.catDetallePendientePreviews.push(URL.createObjectURL(f))
      }
    },
    limpiarCatDetallePendiente() {
      (this.catDetallePendientePreviews || []).forEach((u) => {
        if (u && String(u).startsWith('blob:')) URL.revokeObjectURL(u)
      })
      this.catDetallePendienteArchivos = []
      this.catDetallePendientePreviews = []
    },
    removeCatDetallePendiente(i) {
      const u = this.catDetallePendientePreviews[i]
      if (u && String(u).startsWith('blob:')) URL.revokeObjectURL(u)
      this.catDetallePendientePreviews.splice(i, 1)
      this.catDetallePendienteArchivos.splice(i, 1)
    },
    mergeCatArchivosRespuestaActualizar(archivosNuevos) {
      if (!Array.isArray(archivosNuevos) || !archivosNuevos.length) return false
      const existing = this.galeriaUnidadImagenes || []
      const seen = new Set(existing.map((img) => Number(img?.id)).filter((n) => n > 0))
      const toAdd = []
      for (const row of archivosNuevos) {
        const tipo = String(row?.tipo_archivo || '').trim().toUpperCase()
        if (tipo !== 'CONSULTA_CAT' && tipo !== 'CAT') continue
        const id = Number(row?.id || 0)
        if (!id || seen.has(id)) continue
        const url = row.url || row.archivo_url
        if (!url) continue
        seen.add(id)
        toAdd.push({
          id,
          evidencia_id: Number(row.evidencia_id || 0) || null,
          tipo_archivo: String(row.tipo_archivo || '').trim(),
          orden: row.orden,
          url,
          extension: row.extension ?? row.extension_archivo,
        })
      }
      if (!toAdd.length) return false
      this.galeriaUnidadImagenes = [...existing, ...toAdd]
      return true
    },
    async subirCatDetalleArchivos(files) {
      if (!files || !files.length) return true
      this.guardandoCatDetalle = true
      try {
        let evidenciaId = Number(this.resolverEvidenciaIdGaleria() || 0)
        if (!evidenciaId) {
          const ok = await this.asegurarEvidenciaGarantiaSiFalta()
          evidenciaId = Number(this.resolverEvidenciaIdGaleria() || 0)
          if (!ok || !evidenciaId) {
            this.mostrarSnackbar('No se pudo vincular una evidencia de garantía a la orden de servicio.', 'warning')
            return false
          }
        }
        const archivos = []
        const nombreArchivos = []
        let idx = 0
        for (const f of files) {
          if (!f || !f.type || !f.type.startsWith('image/')) continue
          idx += 1
          archivos.push(await this.fileToBase64(f))
          nombreArchivos.push(`consulta_cat_${String(idx).padStart(2, '0')}${this.extFromFile(f)}`)
        }
        if (!archivos.length) {
          this.mostrarSnackbar('No hay imágenes válidas para subir.', 'warning')
          return false
        }
        const payload = {
          evidencia_id: evidenciaId,
          archivos,
          nombreArchivos,
          archivos_eliminar_ids: [],
          ...this.payloadCamposTextoGarantiaEvidencia(),
        }
        const res = await this.$store.dispatch('postventaTickets/actualizarGarantiasEvidencias', payload)
        if (res.exito) {
          try {
            if (this.ticketSeleccionado) {
              await this.cargarDetalleTicket(this.ticketSeleccionado, { force: true })
            }
            this.limpiarCatDetallePendiente()
            this.mostrarSnackbar(res.message || 'Imágenes actualizadas.', 'success')
            return true
          } catch (e) {
            const merged = this.mergeCatArchivosRespuestaActualizar(res.data?.archivos_nuevos)
            if (merged) {
              this.limpiarCatDetallePendiente()
              this.mostrarSnackbar(res.message || 'Imágenes actualizadas.', 'success')
              return true
            }
            this.mostrarSnackbar(
              'Las imágenes se guardaron pero no se pudo actualizar la vista. Reintentá o recargá la página.',
              'warning'
            )
            return true
          }
        }
        this.mostrarSnackbar(res.message || 'No se pudieron subir las imágenes.', 'error')
        return false
      } finally {
        this.guardandoCatDetalle = false
      }
    },
    async eliminarCatDetalle(imgItem) {
      const id = Number(imgItem?.id || imgItem?.archivo_id || 0)
      if (!id) return
      const evidenciaId = Number(this.resolverEvidenciaIdGaleria() || 0)
      if (!evidenciaId) {
        this.mostrarSnackbar('No hay evidencia de garantía vinculada.', 'warning')
        return
      }
      this.guardandoCatDetalle = true
      try {
        const payload = {
          evidencia_id: evidenciaId,
          archivos: [],
          nombreArchivos: [],
          archivos_eliminar_ids: [id],
          ...this.payloadCamposTextoGarantiaEvidencia(),
        }
        const res = await this.$store.dispatch('postventaTickets/actualizarGarantiasEvidencias', payload)
        if (res.exito) {
          this.mostrarSnackbar('Imagen eliminada.', 'success')
          if (this.ticketSeleccionado) await this.cargarDetalleTicket(this.ticketSeleccionado, { force: true })
        } else {
          this.mostrarSnackbar(res.message || 'No se pudo eliminar.', 'error')
        }
      } finally {
        this.guardandoCatDetalle = false
      }
    },
    onPickEditSingleGaleria(e, tipo) {
      const file = (e.target.files || [])[0]
      e.target.value = ''
      if (!file || !file.type || !file.type.startsWith('image/')) return
      const map = {
        ODOMETRO: ['nuevoArchivoOdometro', 'previewNuevoOdometro'],
        VIN: ['nuevoArchivoVin', 'previewNuevoVin'],
        PATENTE: ['nuevoArchivoPatente', 'previewNuevoPatente'],
        REMITO_FRENTE: ['nuevoArchivoRemitoFrente', 'previewNuevoRemitoFrente'],
        REMITO_DORSO: ['nuevoArchivoRemitoDorso', 'previewNuevoRemitoDorso'],
        REMITO_CAMION: ['nuevoArchivoRemitoCamion', 'previewNuevoRemitoCamion'],
      }
      const pair = map[String(tipo || '').toUpperCase()]
      if (!pair) return
      const [fileKey, previewKey] = pair
      const prev = this.editGaleriaForm[previewKey]
      if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev)
      const existente = this.getEditSingleActivoGaleria(tipo)
      if (existente?.id) {
        this.marcarArchivoEliminarGaleria(existente.id)
        if (!this.editGaleriaForm.autoDeleteArchivoIds.includes(existente.id)) {
          this.editGaleriaForm.autoDeleteArchivoIds.push(existente.id)
        }
      }
      this.editGaleriaForm[fileKey] = file
      this.editGaleriaForm[previewKey] = URL.createObjectURL(file)
    },
    clearEditSingleGaleria(tipo) {
      const t = String(tipo || '').toUpperCase()
      const map = {
        ODOMETRO: ['nuevoArchivoOdometro', 'previewNuevoOdometro'],
        VIN: ['nuevoArchivoVin', 'previewNuevoVin'],
        PATENTE: ['nuevoArchivoPatente', 'previewNuevoPatente'],
        REMITO_FRENTE: ['nuevoArchivoRemitoFrente', 'previewNuevoRemitoFrente'],
        REMITO_DORSO: ['nuevoArchivoRemitoDorso', 'previewNuevoRemitoDorso'],
        REMITO_CAMION: ['nuevoArchivoRemitoCamion', 'previewNuevoRemitoCamion'],
      }
      const pair = map[t]
      if (pair) {
        const [fileKey, previewKey] = pair
        const prev = this.editGaleriaForm[previewKey]
        const teniaPreviewNueva = !!prev
        if (prev && prev.startsWith('blob:')) URL.revokeObjectURL(prev)
        this.editGaleriaForm[fileKey] = null
        this.editGaleriaForm[previewKey] = ''
        if (teniaPreviewNueva) {
          const original = this.getEditSingleOriginalGaleria(t)
          if (original?.id && this.editGaleriaForm.autoDeleteArchivoIds.includes(original.id)) {
            this.desmarcarArchivoEliminarGaleria(original.id)
            this.editGaleriaForm.autoDeleteArchivoIds = this.editGaleriaForm.autoDeleteArchivoIds.filter((id) => id !== original.id)
            return
          }
        }
      }
      const existente = this.getEditSingleActivoGaleria(t)
      if (existente?.id) this.marcarArchivoEliminarGaleria(existente.id)
    },
    validarEdicionGaleriaFotosObligatorias() {
      if (this.editGaleriaTipo === 'garantia' && (this.editGaleriaSoloHistoricoGwm || this.editGaleriaSoloCatConsulta)) {
        return null
      }
      if (this.editGaleriaTipo === 'transporte') {
        const danosCount = this.getEditGaleriaDanosActivos().length + (this.editGaleriaForm.nuevosArchivosDano || []).length
        const hasVin = !!this.getEditSingleActivoGaleria('VIN') || !!this.editGaleriaForm.nuevoArchivoVin
        const hasFrente = !!this.getEditSingleActivoGaleria('REMITO_FRENTE') || !!this.editGaleriaForm.nuevoArchivoRemitoFrente
        const hasDorso = !!this.getEditSingleActivoGaleria('REMITO_DORSO') || !!this.editGaleriaForm.nuevoArchivoRemitoDorso
        const hasCamion = !!this.getEditSingleActivoGaleria('REMITO_CAMION') || !!this.editGaleriaForm.nuevoArchivoRemitoCamion
        if (danosCount < 1 || !hasVin || !hasFrente || !hasDorso || !hasCamion) {
          return 'No se puede guardar: deben quedar al menos una foto de daños, VIN, frente y dorso del remito del vehículo, y remito del camión / carta de porte.'
        }
        return null
      }
      const fallasCount = this.getEditGaleriaFallasActivas().length + (this.editGaleriaForm.nuevosArchivosFalla || []).length
      const hasOdometro = !!this.getEditSingleActivoGaleria('ODOMETRO') || !!this.editGaleriaForm.nuevoArchivoOdometro
      const hasVin = !!this.getEditSingleActivoGaleria('VIN') || !!this.editGaleriaForm.nuevoArchivoVin
      if (fallasCount < 1 || !hasOdometro || !hasVin) {
        return 'No se puede guardar: deben quedar al menos una foto de la falla, odómetro y VIN.'
      }
      return null
    },
    async guardarEdicionGaleria() {
      const errFotos = this.validarEdicionGaleriaFotosObligatorias()
      if (errFotos) {
        this.mostrarSnackbar(errFotos, 'warning')
        return
      }
      this.guardandoEdicionGaleria = true
      try {
        if (this.editGaleriaTipo === 'transporte') {
          const recepcionId = Number(this.editGaleriaForm.recepcion_id || 0)
          if (!recepcionId) {
            this.mostrarSnackbar('No hay recepción vinculada para actualizar imágenes de transporte.', 'warning')
            return
          }
          const archivos = []
          const nombreArchivos = []
          let idxDano = 0
          for (const f of this.editGaleriaForm.nuevosArchivosDano || []) {
            if (!f || !f.type || !f.type.startsWith('image/')) continue
            idxDano += 1
            archivos.push(await this.fileToBase64(f))
            nombreArchivos.push(`dano_${String(idxDano).padStart(2, '0')}${this.extFromFile(f)}`)
          }
          const pushSingleTransporte = async (file, nombreBase) => {
            if (!file || !file.type || !file.type.startsWith('image/')) return
            archivos.push(await this.fileToBase64(file))
            nombreArchivos.push(`${nombreBase}${this.extFromFile(file)}`)
          }
          await pushSingleTransporte(this.editGaleriaForm.nuevoArchivoVin, 'vin')
          await pushSingleTransporte(this.editGaleriaForm.nuevoArchivoRemitoFrente, 'remito_vehiculo_frente')
          await pushSingleTransporte(this.editGaleriaForm.nuevoArchivoRemitoDorso, 'remito_vehiculo_dorso')
          await pushSingleTransporte(this.editGaleriaForm.nuevoArchivoRemitoCamion, 'remito_camion_carta_porte')
          const payload = {
            recepcion_id: recepcionId,
            vin_ultimos_6: String(this.editGaleriaForm.vin_ultimos_6 || '').trim().toUpperCase().slice(0, 6),
            archivos,
            nombreArchivos,
            archivos_eliminar_ids: this.editGaleriaForm.archivosEliminarIds,
          }
          const resTransporte = await this.$store.dispatch('postventaTickets/actualizarRecepcion0km', payload)
          if (resTransporte.exito) {
            this.mostrarSnackbar(resTransporte.message || 'Imágenes de transporte actualizadas.', 'success')
            this.cerrarEditarGaleria()
            if (this.ticketSeleccionado) await this.cargarDetalleTicket(this.ticketSeleccionado, { force: true })
          } else {
            this.mostrarSnackbar(resTransporte.message || 'No se pudieron guardar las imágenes.', 'error')
          }
          return
        }
        const evidenciaId = Number(this.editGaleriaForm.evidencia_id || 0)
        if (!evidenciaId) {
          this.mostrarSnackbar('No hay evidencia de garantía para actualizar imágenes.', 'warning')
          return
        }
        const archivos = []
        const nombreArchivos = []
        if (this.editGaleriaSoloCatConsulta) {
          let idxCatSolo = 0
          for (const f of this.editGaleriaForm.nuevosArchivosCat || []) {
            if (!f || !f.type || !f.type.startsWith('image/')) continue
            idxCatSolo += 1
            archivos.push(await this.fileToBase64(f))
            nombreArchivos.push(`consulta_cat_${String(idxCatSolo).padStart(2, '0')}${this.extFromFile(f)}`)
          }
        } else {
          if (!this.editGaleriaSoloHistoricoGwm) {
            let idxFalla = 0
            for (const f of this.editGaleriaForm.nuevosArchivosFalla || []) {
              if (!f || !f.type || !f.type.startsWith('image/')) continue
              idxFalla += 1
              archivos.push(await this.fileToBase64(f))
              nombreArchivos.push(`falla_${String(idxFalla).padStart(2, '0')}${this.extFromFile(f)}`)
            }
            let idxCat = 0
            for (const f of this.editGaleriaForm.nuevosArchivosCat || []) {
              if (!f || !f.type || !f.type.startsWith('image/')) continue
              idxCat += 1
              archivos.push(await this.fileToBase64(f))
              nombreArchivos.push(`consulta_cat_${String(idxCat).padStart(2, '0')}${this.extFromFile(f)}`)
            }
          }
          let idxHistoricoGwm = 0
          for (const f of this.editGaleriaForm.nuevosArchivosHistoricoGwm || []) {
            if (!f || !f.type || !f.type.startsWith('image/')) continue
            idxHistoricoGwm += 1
            archivos.push(await this.fileToBase64(f))
            nombreArchivos.push(`historico_gwm_${String(idxHistoricoGwm).padStart(2, '0')}${this.extFromFile(f)}`)
          }
          if (!this.editGaleriaSoloHistoricoGwm) {
            const pushSingle = async (file, nombreBase) => {
              if (!file || !file.type || !file.type.startsWith('image/')) return
              archivos.push(await this.fileToBase64(file))
              nombreArchivos.push(`${nombreBase}${this.extFromFile(file)}`)
            }
            await pushSingle(this.editGaleriaForm.nuevoArchivoOdometro, 'odometro')
            await pushSingle(this.editGaleriaForm.nuevoArchivoVin, 'vin')
            await pushSingle(this.editGaleriaForm.nuevoArchivoPatente, 'patente')
          }
        }
        let idsEliminar
        if (this.editGaleriaSoloHistoricoGwm) {
          idsEliminar = (this.editGaleriaForm.archivosEliminarIds || []).filter((id) =>
            (this.editGaleriaForm.archivos || []).some(
              (a) => Number(a.id) === Number(id) && String(a.tipo_archivo || '').toUpperCase() === 'HISTORICO_GWM'
            )
          )
        } else if (this.editGaleriaSoloCatConsulta) {
          idsEliminar = (this.editGaleriaForm.archivosEliminarIds || []).filter((id) =>
            (this.editGaleriaForm.archivos || []).some((a) => {
              const t = String(a.tipo_archivo || '').toUpperCase()
              return Number(a.id) === Number(id) && (t === 'CONSULTA_CAT' || t === 'CAT')
            })
          )
        } else {
          idsEliminar = this.editGaleriaForm.archivosEliminarIds
        }
        const payload = {
          evidencia_id: evidenciaId,
          archivos,
          nombreArchivos,
          archivos_eliminar_ids: idsEliminar,
          ...(this.editGaleriaSoloHistoricoGwm || this.editGaleriaSoloCatConsulta
            ? {}
            : {
                repuestos: (this.galeriaGarantiasRepuestos || [])
                  .map((r) => ({
                    numero_parte: String(r?.numero_parte || '').trim(),
                    cantidad: this.cantidadRepuestoGarantia(r),
                  }))
                  .filter((r) => r.numero_parte),
              }),
        }
        const res = await this.$store.dispatch('postventaTickets/actualizarGarantiasEvidencias', payload)
        if (res.exito) {
          this.mostrarSnackbar(res.message || 'Evidencias actualizadas.', 'success')
          this.cerrarEditarGaleria()
          if (this.ticketSeleccionado) await this.cargarDetalleTicket(this.ticketSeleccionado, { force: true })
          return
        }
        this.mostrarSnackbar(res.message || 'No se pudieron guardar las imágenes.', 'error')
      } finally {
        this.guardandoEdicionGaleria = false
      }
    },

    normalizarExtensionArchivo(archivo) {
      const extRaw = archivo?.extension_archivo || archivo?.extension || ''
      const ext = String(extRaw).trim().toLowerCase()
      if (!ext) return ''
      return ext.startsWith('.') ? ext : `.${ext}`
    },

    esImagenExtension(ext) {
      return ['.png', '.jpg', '.jpeg', '.jfif', '.webp'].includes(ext)
    },

    verArchivoComentario(archivo) {
      const url = archivo?.archivo_url || archivo?.url
      if (!url) return
      const ext = this.normalizarExtensionArchivo(archivo)
      const nombre = archivo?.nombre_archivo || archivo?.nombre || ext || 'Adjunto'
      this.nombre_ver = nombre
      if (this.esImagenExtension(ext)) {
        this.img = url
        this.dialog_img = true
      } else if (ext === '.pdf') {
        this.pdf = url
        this.dialog_pdf = true
      } else {
        window.open(url, '_blank')
      }
    },

    openUnidadGaleriaImage(imgItem) {
      const url = imgItem?.url || imgItem?.archivo_url
      if (!url) return
      const idRef = imgItem?.recepcion_id || imgItem?.ticket_id || ''
      this.nombre_ver = this.tipoArchivoLabel(imgItem?.tipo_archivo, imgItem?.orden) || `Imagen VIN - ${idRef}`.trim()
      this.galeriaImagenActualUrl = url
      this.galeriaImagenActualItem = imgItem
      this.dialog_galeria_img = true
    },

    abrirDialogProformaGarantia() {
      const imgs = this.galeriaUnidadImagenes || []
      const has = (t) =>
        imgs.some((i) => String(i?.tipo_archivo || '').trim().toUpperCase() === t)
      this.proformaIncluir = {
        odometer: has('ODOMETRO'),
        vin: has('VIN'),
        patente: has('PATENTE'),
        historicoGwm: has('HISTORICO_GWM'),
        cat: has('CAT') || has('CONSULTA_CAT'),
        falla: has('FALLA') || has('DANO'),
      }
      const km = this.proformaKmTexto
      const hs = this.proformaHorasMoLinea
      this.proformaEdicion = {
        modelo: String(
          this.ticketSeleccionado.unidad_modelo_descripcion ||
            this.ticketSeleccionado.unidad_modelo_codigo ||
            ''
        ),
        anio: '',
        kmTexto: km === '—' ? '' : String(km),
        horasMoLinea: hs === '—' ? '' : String(hs),
        resumenDiagnostico: String(this.garantiasDetalleForm?.resumen_diagnostico || ''),
      }
      this.dialogProformaGarantia = true
    },
    armarOpcionesPdfProformaGarantia() {
      const ticket = this.ticketSeleccionado
      const ed = this.proformaEdicion
      const modeloT = String(ed?.modelo ?? '').trim()
      const anioT = String(ed?.anio ?? '').trim()
      const kmT = String(ed?.kmTexto ?? '').trim()
      const hsT = String(ed?.horasMoLinea ?? '').trim()
      return {
        assetBaseUrl: `${window.location.origin}/postventa`,
        bac: '279744',
        concesionario: 'BORIGEN BETZEL SRL',
        cliente: ticket.nombre_cliente || '',
        modelo: modeloT || '—',
        anio: anioT || '—',
        vin: ticket.unidad_vin || '',
        fechaDocumento: this.fechaActualProforma,
        fechaAperturaOr: this.proformaFechaAperturaOrTexto,
        numeroOrden: this.galeriaGarantiasOrdenServicio,
        kmTexto: kmT || '—',
        patente: ticket.unidad_patente || '',
        horasMoLinea: hsT || '—',
        repuestos: this.galeriaGarantiasRepuestos || [],
        resumenDiagnostico: String(ed?.resumenDiagnostico ?? ''),
        includeSections: { ...this.proformaIncluir },
        galleryImages: (this.galeriaUnidadImagenes || []).map((i) => ({
          url: i.url,
          tipo_archivo: i.tipo_archivo,
        })),
      }
    },
    uint8PdfToDataUrl(bytes) {
      const u8 = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes)
      let binary = ''
      const chunk = 0x8000
      for (let i = 0; i < u8.length; i += chunk) {
        binary += String.fromCharCode.apply(null, u8.subarray(i, Math.min(i + chunk, u8.length)))
      }
      return `data:application/pdf;base64,${btoa(binary)}`
    },
    verProformaPdfGenerado() {
      const url = this.proformaUltima?.archivo_url
      if (!url) return
      this.nombre_ver = `Pro forma – ticket #${this.ticketSeleccionado?.id || ''}`
      this.pdf = url
      this.dialog_pdf = true
    },
    async ejecutarGuardarProformaGarantia() {
      if (!this.puedeGenerarProformaGarantia || !this.ticketSeleccionado) return
      this.guardandoProformaGarantia = true
      try {
        const ticket = this.ticketSeleccionado
        const opts = this.armarOpcionesPdfProformaGarantia()
        const buf = await pdfProformaGarantiaUnico(opts)
        const dataUrl = this.uint8PdfToDataUrl(buf)
        const res = await this.$store.dispatch('postventaTickets/guardarGarantiasProforma', {
          ticket_id: ticket.id,
          orden_servicio_id: this.galeriaGarantiasOrdenServicio,
          modelo: opts.modelo,
          anio: opts.anio,
          km_texto: opts.kmTexto,
          horas_mo_linea: opts.horasMoLinea,
          resumen_diagnostico: opts.resumenDiagnostico,
          include_sections: opts.includeSections,
          pdf: dataUrl,
        })
        if (!res.exito) {
          this.mostrarSnackbar(res.message || 'No se pudo guardar la pro forma en el servidor.', 'error')
          return
        }
        this.proformaUltima = res.data
        const blob = new Blob([buf], { type: 'application/pdf' })
        const objectUrl = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = objectUrl
        a.download = `Proforma_garantia_ticket_${ticket.id}.pdf`
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(objectUrl)
        this.dialogProformaGarantia = false
        this.mostrarSnackbar('PDF generado y guardado en el servidor.', 'success')
      } catch (e) {
        console.error(e)
        this.mostrarSnackbar(
          e?.message ? `No se pudo generar el PDF: ${e.message}` : 'No se pudo generar el PDF.',
          'error'
        )
      } finally {
        this.guardandoProformaGarantia = false
      }
    },
    async descargarArchivoDesdeUrl(url, nombreSugerido) {
      if (!url) return
      const nombre = String(nombreSugerido || 'imagen').trim()
      try {
        const resp = await fetch(url)
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
        const blob = await resp.blob()
        const objectUrl = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = objectUrl
        a.download = nombre
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(objectUrl)
      } catch (e) {
        window.open(url, '_blank')
        this.mostrarSnackbar('No se pudo forzar descarga; se abrió la imagen en otra pestaña.', 'warning')
      }
    },

    nombreDescargaImagenGaleria(imgItem, idx = 0) {
      const tipo = String(imgItem?.tipo_archivo || 'imagen').toLowerCase()
      const ext = this.normalizarExtensionArchivo(imgItem) || '.jpg'
      const orden = Number(imgItem?.orden || idx + 1)
      return `recepcion_${tipo}_${String(orden).padStart(2, '0')}${ext}`
    },
    formatCurrencyARS(value) {
      const n = Number(value || 0)
      return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(Number.isNaN(n) ? 0 : n)
    },
    /** Precio unitario en UI/BD: como máximo 2 decimales (truncado hacia cero; tolera floats binarios). */
    truncarPrecioEstimadoRepuesto(val) {
      const n = Number(val)
      if (!Number.isFinite(n)) return 0
      const sign = n < 0 ? -1 : 1
      return (sign * Math.floor(Math.abs(n) * 100 + 1e-9)) / 100
    },
    cantidadRepuestoGarantia(rep) {
      const q = Number(rep?.cantidad)
      if (Number.isInteger(q) && q >= 1) return q
      return 1
    },
    subtotalRepuestoGarantia(rep) {
      const precio = this.truncarPrecioEstimadoRepuesto(rep?.precio_estimado)
      return precio * this.cantidadRepuestoGarantia(rep)
    },
    normalizarRepuestosGarantiaParaEdicion(list) {
      return (list || []).map((r) => {
        const saved = Number(r.precio_estimado)
        const brutoGuardado = Number.isNaN(saved) ? 0 : saved
        const numGuardado = this.truncarPrecioEstimadoRepuesto(brutoGuardado)
        const sug = Number(r.precio_sugerido_sai)
        const tienePrecioGuardado = numGuardado > 0
        const mostrarBruto = tienePrecioGuardado ? numGuardado : (!Number.isNaN(sug) ? sug : 0)
        const mostrar = this.truncarPrecioEstimadoRepuesto(mostrarBruto)
        return { ...r, precio_estimado: mostrar, _precioGuardado: numGuardado }
      })
    },
    async guardarDetalleGarantia() {
      const ticketId = Number(this.ticketSeleccionado?.id)
      const evidenciaId = Number(this.garantiasDetalleForm.evidencia_id)
      if (!ticketId) return false
      if (!evidenciaId || Number.isNaN(evidenciaId)) {
        this.mostrarSnackbar('No hay evidencia de garantía para actualizar el detalle unificado.', 'warning')
        return false
      }

      if (!this.hayCambiosResumenOAccionesGarantia) {
        this.mostrarSnackbar('No hay cambios para guardar.', 'info')
        return false
      }

      const estadoActual = this.normalizarId(this.estadoSeleccionado)
      const prioridadActual = this.normalizarId(this.prioridadSeleccionada)
      const subEstadoActual = this.normalizarId(this.subEstadoSeleccionado)
      const estadoFinalizadoId = 3

      if (!estadoActual) {
        this.mostrarSnackbar('Seleccione un estado válido.', 'warning')
        return false
      }
      if (!prioridadActual) {
        this.mostrarSnackbar('Seleccione una prioridad válida.', 'warning')
        return false
      }
      if (estadoActual === estadoFinalizadoId && !this.puedeFinalizarTicketConCambios(this.ticketSeleccionado)) {
        const aviso = this.esModoReparacion0km
          ? 'Solo se puede finalizar tickets en estado ASIGNADO.'
          : 'Solo se puede finalizar en estado ASIGNADO y sub-estado FACTURADO o NO FACTURADO - RECLAMO NO ACEPTADO.'
        this.mostrarSnackbar(aviso, 'warning')
        return false
      }

      this.guardandoDetalleGarantia = true
      try {
        const resumenPayload = this.resumenDiagnosticoTocado
          ? String(this.garantiasDetalleForm.resumen_diagnostico || '')
          : String(this.resumenDiagnosticoOriginal || '')
        const rawHorasMo = String(this.garantiasDetalleForm.horas_mo ?? '').replace(',', '.').trim()
        let horasMoPayload = null
        if (rawHorasMo !== '') {
          const nh = Number(rawHorasMo)
          if (Number.isFinite(nh) && nh >= 0) horasMoPayload = nh
        }
        const payload = {
          ticket_id: ticketId,
          evidencia_id: evidenciaId,
          resumen_diagnostico: resumenPayload,
          horas_mo: horasMoPayload,
          codigo_mo: String(this.garantiasDetalleForm.codigo_mo || '').trim(),
          estado_id: estadoActual,
          prioridad_id: prioridadActual,
          sub_estado_id: estadoActual === estadoFinalizadoId ? null : subEstadoActual,
        }
        const res = await this.$store.dispatch('postventaTickets/guardarDetalleTicket', payload)
        if (res.exito) {
          await this.refrescarTicketSeleccionado(ticketId)
          if (this.ticketSeleccionado) await this.cargarDetalleTicket(this.ticketSeleccionado, { force: true })
          this.mostrarSnackbar(res.message || 'Detalle del ticket actualizado.', 'success')
          return true
        }
        this.mostrarSnackbar(res.message || 'No se pudo guardar el detalle del ticket.', 'error')
        return false
      } finally {
        this.guardandoDetalleGarantia = false
      }
    },
    async guardarPreciosRepuestosGarantiaPendientes() {
      const list = this.galeriaGarantiasRepuestos || []
      const pendientes = list.filter((rep) => {
        const id = Number(rep?.id)
        if (!id) return false
        const raw = rep.precio_estimado
        const parsed = raw === '' || raw === null ? NaN : Number(raw)
        if (Number.isNaN(parsed) || parsed < 0) return false
        const nuevo = this.truncarPrecioEstimadoRepuesto(parsed)
        const guardadoTrunc = this.truncarPrecioEstimadoRepuesto(rep._precioGuardado)
        return nuevo !== guardadoTrunc
      })
      if (pendientes.length === 0) return true

      this.guardandoRepuestosGarantiaBatch = true
      try {
        for (const rep of pendientes) {
          const raw = rep.precio_estimado
          const parsed = raw === '' || raw === null ? NaN : Number(raw)
          if (Number.isNaN(parsed) || parsed < 0) {
            this.$set(rep, 'precio_estimado', rep._precioGuardado)
            this.mostrarSnackbar('Ingrese un precio válido (≥ 0).', 'warning')
            return false
          }
          const nuevo = this.truncarPrecioEstimadoRepuesto(parsed)
          if (nuevo !== rep.precio_estimado) {
            this.$set(rep, 'precio_estimado', nuevo)
          }
          const id = Number(rep.id)
          const res = await this.$store.dispatch('postventaTickets/actualizarPrecioRepuestoGarantia', {
            id,
            precio_estimado: nuevo,
          })
          if (!res.exito) {
            this.$set(rep, 'precio_estimado', rep._precioGuardado)
            this.mostrarSnackbar(res.message || 'No se pudo guardar el precio.', 'error')
            return false
          }
          this.$set(rep, 'precio_estimado', nuevo)
          this.$set(rep, '_precioGuardado', nuevo)
        }
        this.mostrarSnackbar('Precios de repuestos actualizados.', 'success')
        return true
      } finally {
        this.guardandoRepuestosGarantiaBatch = false
      }
    },

    async descargarImagenActualGaleria() {
      if (!this.galeriaImagenActualUrl) return
      await this.descargarArchivoDesdeUrl(this.galeriaImagenActualUrl, 'recepcion_imagen.jpg')
    },

    async descargarTodasImagenesGaleria() {
      const lista =
        this.esTabReclamoGarantia && !this.esModoReparacion0km
          ? (this.galeriaUnidadImagenesParaCarouselGarantia || [])
          : (this.galeriaUnidadImagenes || [])
      if (!lista.length) return
      for (let i = 0; i < lista.length; i += 1) {
        const item = lista[i]
        const nombre = this.nombreDescargaImagenGaleria(item, i)
        // secuencial para evitar bloquear el navegador con múltiples descargas simultáneas
        // eslint-disable-next-line no-await-in-loop
        await this.descargarArchivoDesdeUrl(item.url, nombre)
      }
    },

    async cargarDetalleTicket(ticket, { force = false } = {}) {
      if (!ticket?.id) return
      const ticketId = ticket.id
      const prevId = this.detalleTicketId
      if (prevId != null && prevId !== ticketId) {
        this.nuevoComentarioTexto = ''
        this.limpiarHistoricoGwmDetallePendiente()
        this.limpiarCatDetallePendiente()
        this.$nextTick(() => {
          this.$refs.composerMenciones?.clear()
        })
      }
      const yaCargado = !force && this.detalleTicketId === ticketId && !this.comentariosCargando
      // Si ya lo tenemos cargado, solo aseguramos el sub-estado.
      if (yaCargado) {
        this.subEstadoSeleccionado = ticket.sub_estado_id
        return
      }

      this.detalleTicketId = ticketId
      this.ticketSeleccionado = ticket
      this.subEstadoSeleccionado = ticket.sub_estado_id
      this.prioridadSeleccionada = ticket.prioridad_id
      this.snapshotAccionesRapidas(ticket)

      this.comentariosDelTicket = []
      this.archivosDelTicket = []
      this.galeriaUnidadImagenes = []
      this.galeriaGarantiasRepuestos = []
      this.galeriaGarantiasOrdenServicio = null
      this.ordenAperturaSai = null
      this.ordenOdometroValor = null
      this.sucursalNombreDesdeOrdenServicio = null
      this.dialogEditarGaleria = false
      this.editGaleriaSoloHistoricoGwm = false
      this.editGaleriaSoloCatConsulta = false
      this.editGaleriaContexto = ''
      this.editGaleriaTipo = 'garantia'
      this.editGaleriaForm = {
        evidencia_id: null,
        recepcion_id: null,
        vin_ultimos_6: '',
        archivos: [],
        archivosEliminarIds: [],
        autoDeleteArchivoIds: [],
        nuevosArchivosDano: [],
        previewNuevosDano: [],
        nuevosArchivosFalla: [],
        previewNuevosFalla: [],
        nuevosArchivosCat: [],
        previewNuevosCat: [],
        nuevosArchivosHistoricoGwm: [],
        previewNuevosHistoricoGwm: [],
        nuevoArchivoRemitoFrente: null,
        previewNuevoRemitoFrente: '',
        nuevoArchivoRemitoDorso: null,
        previewNuevoRemitoDorso: '',
        nuevoArchivoRemitoCamion: null,
        previewNuevoRemitoCamion: '',
        nuevoArchivoOdometro: null,
        previewNuevoOdometro: '',
        nuevoArchivoVin: null,
        previewNuevoVin: '',
        nuevoArchivoPatente: null,
        previewNuevoPatente: '',
      }
      this.resumenDiagnosticoTocado = false
      this.horasMoOriginal = ''
      this.codigoMoOriginal = ''
      this.garantiasDetalleForm = {
        evidencia_id: null,
        encabezado_incidente_cliente: '',
        encabezado_resultado_tecnico: '',
        mecanico_nombre: '',
        resumen_diagnostico: '',
        horas_mo: '',
        codigo_mo: '',
      }
      this.comentariosCargando = true
      this.galeriaUnidadCargando = true
      try {
        const actionGaleria = this.usarGaleriaEvidenciasOrdenServicio(ticket)
          ? 'postventaTickets/getGaleriaGarantiasPorOrden'
          : 'postventaTickets/getGaleriaUnidadGarantias'
        const [resC, resA, resG, resProforma] = await Promise.all([
          this.$store.dispatch('postventaTickets/getComentarios', { ticket_id: ticketId }),
          this.$store.dispatch('postventaTickets/getArchivos', { ticket_id: ticketId }),
          this.$store.dispatch(actionGaleria, { ticket_id: ticketId }),
          this.$store
            .dispatch('postventaTickets/getGarantiasProformaUltima', { ticket_id: ticketId })
            .catch(() => ({ exito: false, data: null })),
        ])
        this.proformaUltima = resProforma.exito ? resProforma.data : null
        this.comentariosDelTicket = resC.exito ? resC.data : []
        this.archivosDelTicket = resA.exito ? resA.data : []
        this.galeriaUnidadImagenes = resG.exito ? (resG.data?.imagenes || []) : []
        this.galeriaGarantiasRepuestos = this.normalizarRepuestosGarantiaParaEdicion(
          resG.exito ? (resG.data?.repuestos || []) : []
        )
        this.galeriaGarantiasOrdenServicio = resG.exito ? (resG.data?.orden_servicio_id || null) : null
        this.ordenAperturaSai = resG.exito ? (resG.data?.orden_apertura ?? null) : null
        const odoSrv = resG.exito ? resG.data?.orden_odometro_valor : null
        this.ordenOdometroValor =
          odoSrv !== undefined && odoSrv !== null && odoSrv !== '' && Number.isFinite(Number(odoSrv))
            ? Number(odoSrv)
            : null
        const nomSucOrden = resG.exito ? String(resG.data?.sucursal_nombre_desde_orden || '').trim() : ''
        this.sucursalNombreDesdeOrdenServicio = nomSucOrden || null
        const resumenServidor = resG.exito ? String(resG.data?.resumen_diagnostico || '') : ''
        this.resumenDiagnosticoOriginal = resumenServidor
        this.resumenDiagnosticoTocado = false
        const horasSrv =
          resG.exito && resG.data?.horas_mo != null && resG.data?.horas_mo !== ''
            ? String(resG.data.horas_mo)
            : ''
        const codigoSrv = resG.exito ? String(resG.data?.codigo_mo || '').trim() : ''
        this.horasMoOriginal = horasSrv
        this.codigoMoOriginal = codigoSrv
        this.garantiasDetalleForm = {
          evidencia_id: resG.exito ? Number(resG.data?.evidencia_id || 0) || null : null,
          encabezado_incidente_cliente: resG.exito ? String(resG.data?.incidente_cliente || '') : '',
          encabezado_resultado_tecnico: resG.exito ? String(resG.data?.resultado_tecnico || '') : '',
          mecanico_nombre: resG.exito ? String(resG.data?.mecanico_nombre || '') : '',
          resumen_diagnostico: resumenServidor,
          horas_mo: horasSrv,
          codigo_mo: codigoSrv,
        }
      } finally {
        this.comentariosCargando = false
        this.galeriaUnidadCargando = false
      }
    },

    rowClick(item) {
      if (!item?.id) return
      // Toggle: si ya está seleccionado, lo cerramos.
      if (this.selected.length > 0 && this.selected[0].id === item.id) {
        this.cerrarDetalle()
        return
      }

      this.selected = [item]
      this.ticketSeleccionado = item

      this.$nextTick(() => {
        // Primero mostramos el detalle y luego cargamos datos en paralelo al scroll.
        this.$vuetify.goTo('#detalle')
        this.cargarDetalleTicket(item).catch(() => { })
      })
    },
    verMemoDano(item) {
      const memo = this.memoDanoTicket(item)
      this.nombre_ver = `Memo daño - Ticket #${item?.id || ''}`.trim()
      this.img = null
      this.pdf = null
      this.dialogMemoDano = true
      this.memoDanoTexto = memo
    },

    cerrarDetalle() {
      this.selected = []
      this.detalleTicketId = null
      this.ticketSeleccionado = null
      this.subEstadoSeleccionado = null
      this.prioridadSeleccionada = null
      this.estadoSeleccionado = null
      this.ticketOriginalAccionesRapidas = { prioridad_id: null, sub_estado_id: null, estado_id: null }
      this.comentariosDelTicket = []
      this.archivosDelTicket = []
      this.galeriaUnidadImagenes = []
      this.galeriaGarantiasRepuestos = []
      this.galeriaGarantiasOrdenServicio = null
      this.ordenAperturaSai = null
      this.ordenOdometroValor = null
      this.sucursalNombreDesdeOrdenServicio = null
      this.dialogEditarGaleria = false
      this.editGaleriaSoloHistoricoGwm = false
      this.editGaleriaSoloCatConsulta = false
      this.editGaleriaContexto = ''
      this.editGaleriaTipo = 'garantia'
      this.editGaleriaForm = {
        evidencia_id: null,
        recepcion_id: null,
        vin_ultimos_6: '',
        archivos: [],
        archivosEliminarIds: [],
        autoDeleteArchivoIds: [],
        nuevosArchivosDano: [],
        previewNuevosDano: [],
        nuevosArchivosFalla: [],
        previewNuevosFalla: [],
        nuevosArchivosCat: [],
        previewNuevosCat: [],
        nuevosArchivosHistoricoGwm: [],
        previewNuevosHistoricoGwm: [],
        nuevoArchivoRemitoFrente: null,
        previewNuevoRemitoFrente: '',
        nuevoArchivoRemitoDorso: null,
        previewNuevoRemitoDorso: '',
        nuevoArchivoRemitoCamion: null,
        previewNuevoRemitoCamion: '',
        nuevoArchivoOdometro: null,
        previewNuevoOdometro: '',
        nuevoArchivoVin: null,
        previewNuevoVin: '',
        nuevoArchivoPatente: null,
        previewNuevoPatente: '',
      }
      this.resumenDiagnosticoTocado = false
      this.horasMoOriginal = ''
      this.codigoMoOriginal = ''
      this.garantiasDetalleForm = {
        evidencia_id: null,
        encabezado_incidente_cliente: '',
        encabezado_resultado_tecnico: '',
        mecanico_nombre: '',
        resumen_diagnostico: '',
        horas_mo: '',
        codigo_mo: '',
      }
      this.nuevoComentarioTexto = ''
      this.$nextTick(() => {
        this.$refs.composerMenciones?.clear()
      })
      this.esComentarioInterno = false
      this.archivosSeleccionados = []
      this.limpiarHistoricoGwmDetallePendiente()
      this.limpiarCatDetallePendiente()
      this.proformaUltima = null
    },
  },
}
</script>

<style scoped>
/* Colores: var(--v-*-base) desde plugins/vuetify.js (theme.customProperties).
   Radios: 4px alineado con $card-border-radius de Vuetify 2. */

/* Título de diálogo con botón de cierre: el texto se ajusta y el botón queda en la primera fila, a la derecha. */
.dialog-title-closable {
  flex-wrap: nowrap;
}

.dialog-title-text {
  flex: 1 1 auto;
  min-width: 0;
}

.ticket-detail-card {
  border: thin solid var(--v-tab-base);
  border-radius: 4px;
  background: var(--v-swalBkg-base);
  /* Elevación 1 (misma idea que v-card) */
  box-shadow:
    0 2px 1px -1px rgba(0, 0, 0, 0.2),
    0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
  padding: 16px;
}

.ticket-detail-card--dark {
  border-color: var(--v-tab-base);
  background: var(--v-swalBkg-base);
  box-shadow:
    0 2px 1px -1px rgba(0, 0, 0, 0.4),
    0 1px 1px 0 rgba(0, 0, 0, 0.3),
    0 1px 3px 0 rgba(0, 0, 0, 0.25);
}

.ticket-detail-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.ticket-title-wrap {
  min-width: 0;
}

.ticket-title-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.ticket-kicker {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--v-primary-base);
  opacity: 0.9;
}

.ticket-number {
  font-size: 18px;
  font-weight: 700;
}

.ticket-subject {
  margin-top: 4px;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
  max-width: 75ch;
}

.detail-close-btn {
  min-width: 44px;
  min-height: 44px;
}

.ticket-meta-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 8px;
}

.meta-item {
  border: thin solid var(--v-tab-base);
  border-radius: 4px;
  padding: 8px 10px;
  background: var(--v-swalBkg-base);
  background: color-mix(in srgb, var(--v-primary-base) 5%, var(--v-swalBkg-base));
}

.ticket-detail-card--dark .meta-item {
  background: var(--v-secondary-base);
  background: color-mix(in srgb, var(--v-primary-base) 14%, var(--v-secondary-base));
}

.meta-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--v-tabText-base);
  opacity: 0.85;
}

.meta-value {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  margin-top: 2px;
}

.memos-list {
  margin-top: 6px;
  max-height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}

.memo-item {
  border: thin solid var(--v-tab-base);
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 8px;
  background: color-mix(in srgb, var(--v-primary-base) 4%, var(--v-swalBkg-base));
}

.memo-head {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.memo-id {
  font-size: 11px;
  font-weight: 700;
  color: var(--v-primary-base);
}

.memo-tipo {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  border: 1px solid var(--v-tab-base);
  border-radius: 999px;
  padding: 1px 6px;
}

.memo-fecha {
  font-size: 11px;
  opacity: 0.85;
}

.memo-body {
  white-space: pre-wrap;
  font-size: 13px;
  line-height: 1.4;
  max-height: 96px;
  overflow-y: auto;
  overflow-x: hidden;
}

.memos-panel .memos-list {
  max-height: min(360px, 55vh);
}

.memos-y-acciones-row {
  align-items: stretch;
}

.section-card {
  border: thin solid var(--v-tab-base);
  border-radius: 4px;
  padding: 12px;
  height: 100%;
  background: var(--v-swalBkg-base);
  background: color-mix(in srgb, var(--v-primary-base) 5%, var(--v-swalBkg-base));
}

.ticket-detail-card--dark .section-card {
  background: var(--v-secondary-base);
  background: color-mix(in srgb, var(--v-primary-base) 14%, var(--v-secondary-base));
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--v-tabText-base);
}

.section-description {
  font-size: 14px;
  line-height: 1.55;
  max-width: 68ch;
  white-space: pre-line;
}

.nombre-cliente-celda {
  display: inline-block;
  max-width: 100%;
  vertical-align: middle;
  cursor: default;
}

.vin-celda-tabla {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.reparacion-1visita-group {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
}

.reparacion-1visita-btn {
  min-width: 0 !important;
  padding: 0 8px !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  letter-spacing: 0.01em;
  text-transform: none !important;
  transition: box-shadow 0.18s ease, transform 0.12s ease, opacity 0.18s ease;
}

.reparacion-1visita-btn.reparacion-1visita-btn--active {
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.reparacion-1visita-btn:not(.v-btn--disabled):active {
  transform: scale(0.97);
}

::v-deep .reparacion-1visita-group .v-btn--outlined {
  border-width: 1.5px !important;
  opacity: 0.92;
}

.galeria-vin-img {
  width: calc((100% - (12px * 2)) / 3);
  height: 180px;
  object-fit: cover;
  border-radius: 4px;
  cursor: zoom-in;
}

.galeria-vin-grid {
  display: flex;
  gap: 12px;
}

.galeria-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.galeria-download-all-btn {
  white-space: nowrap;
}

.galeria-dialog-img {
  width: 100%;
  max-height: 72vh;
  object-fit: contain;
  border-radius: 4px;
}

.field-label {
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 8px;
  color: var(--v-tabText-base);
}

.galeria-banner-titulo {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 4px;
}

.galeria-seccion-titulo-texto {
  font-size: 0.9375rem;
  font-weight: 600;
  line-height: 1.4;
  padding: 10px 12px;
  background: #eeeeee;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  color: var(--v-tabText-base, rgba(0, 0, 0, 0.87));
}

.ticket-detail-card--dark .galeria-seccion-titulo-texto {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.22);
  color: rgba(255, 255, 255, 0.92);
}

.thumb-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.hist-gwm-detalle-thumb-grid .thumb-cell {
  width: 158px;
  height: 158px;
}

.hist-gwm-detalle-thumb-grid .upload-placeholder--hist-gwm {
  min-height: 158px;
  align-self: stretch;
}

.thumb-cell {
  width: 110px;
  height: 110px;
  border: thin solid var(--v-tab-base);
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  background: var(--v-swalBkg-base);
}

.thumb-cell img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: zoom-in;
}

.thumb-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.55) !important;
}

.thumb-kind {
  position: absolute;
  left: 4px;
  top: 4px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 10px;
  max-width: calc(100% - 8px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edit-delete-btn {
  position: absolute;
  left: 4px;
  bottom: 4px;
  min-width: 0 !important;
  padding: 0 8px !important;
  height: 24px !important;
  font-size: 11px !important;
  line-height: 24px !important;
}

.thumb-add {
  width: 110px;
  height: 110px;
  border: 1px dashed var(--v-tab-base);
  border-radius: 6px;
  background: transparent;
  color: var(--v-primary-base);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.thumb-add span {
  font-size: 46px;
  line-height: 1;
  transform: translateY(-2px);
}

.upload-placeholder {
  border: 2px dashed rgba(0, 0, 0, 0.38);
  border-radius: 8px;
  width: 100%;
  max-width: 280px;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.02);
  transition: border-color 0.2s ease, background 0.2s ease;
  padding: 12px;
}

.upload-placeholder:hover {
  border-color: var(--v-primary-base, #1976d2);
  background: rgba(25, 118, 210, 0.04);
}

.upload-placeholder--hist-gwm {
  width: 100%;
}

.upload-hint {
  margin-top: 8px;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.54);
}

.ticket-detail-card--dark .upload-placeholder {
  border-color: rgba(255, 255, 255, 0.32);
  background: rgba(255, 255, 255, 0.04);
}

.ticket-detail-card--dark .upload-placeholder:hover {
  border-color: var(--v-primary-base, #1976d2);
  background: rgba(25, 118, 210, 0.18);
}

.ticket-detail-card--dark .upload-hint {
  color: rgba(255, 255, 255, 0.72);
}

::v-deep .galeria-vin-carousel .v-window__prev,
::v-deep .galeria-vin-carousel .v-window__next {
  top: 50%;
  transform: translateY(-50%);
  margin: 0;
}

::v-deep .galeria-vin-carousel .v-window__prev .v-btn,
::v-deep .galeria-vin-carousel .v-window__next .v-btn {
  min-width: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45) !important;
  border: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
  transition: background-color 180ms ease, transform 180ms ease;
}

::v-deep .galeria-vin-carousel .v-window__prev .v-btn .v-icon,
::v-deep .galeria-vin-carousel .v-window__next .v-btn .v-icon,
::v-deep .galeria-vin-carousel .v-window__prev .v-btn .v-btn__content .v-icon,
::v-deep .galeria-vin-carousel .v-window__next .v-btn .v-btn__content .v-icon {
  color: #fff !important;
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  line-height: 16px !important;
  min-width: 16px !important;
}

::v-deep .galeria-vin-carousel .v-window__prev .v-btn:hover,
::v-deep .galeria-vin-carousel .v-window__next .v-btn:hover {
  background: rgba(25, 118, 210, 0.82) !important;
  transform: scale(1.04);
}

::v-deep .galeria-vin-carousel .v-window__prev {
  left: 8px;
}

::v-deep .galeria-vin-carousel .v-window__next {
  right: 8px;
}

@media (max-width: 960px) {
  .galeria-vin-img {
    width: calc((100% - 12px) / 2);
  }
}

@media (max-width: 600px) {
  .galeria-vin-img {
    width: 100%;
  }

  .galeria-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

.comment-body-html {
  white-space: pre-wrap;
  word-break: break-word;
}

.comentarios-container {
  max-height: 260px;
  overflow-y: auto;
  padding-right: 4px;
}

.comment-item {
  border: thin solid var(--v-tab-base);
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 8px;
  background: var(--v-swalBkg-base);
  background: color-mix(in srgb, var(--v-primary-base) 3%, var(--v-swalBkg-base));
}

.ticket-detail-card--dark .comment-item {
  background: var(--v-secondary-base);
  background: color-mix(in srgb, var(--v-primary-base) 10%, var(--v-secondary-base));
}

.ticket-garantia-comments-box {
  border: thin solid var(--v-tab-base);
  border-radius: 4px;
  padding: 10px;
}

.ticket-garantia-comment-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  border: thin solid var(--v-tab-base);
  border-radius: 4px;
  padding: 6px 8px;
  margin-bottom: 6px;
  color: var(--v-tabText-base);
}

.ticket-garantia-comment-item--readonly {
  flex-direction: column;
  align-items: flex-start;
}

.ticket-garantia-comment-item--readonly small {
  opacity: 0.7;
}

.comment-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.action-btn {
  min-height: 40px;
  transition: background-color 200ms ease, box-shadow 200ms ease, border-color 200ms ease;
}

/* Iconos Font Awesome + texto: alinear eje vertical (evita icono “flotando” arriba). */
.action-btn--icon-label ::v-deep .v-btn__content {
  align-items: center;
  justify-content: center;
}

.action-btn__icon-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 1.25;
}

.action-btn__leading-icon {
  flex-shrink: 0;
  align-self: center;
  line-height: 1 !important;
  margin: 0 !important;
}

.action-btn:focus-visible,
.detail-close-btn:focus-visible {
  outline: 2px solid var(--v-info-base);
  outline-offset: 2px;
}

.repuesto-precio-input {
  max-width: 132px;
  margin-left: auto;
}

.repuesto-precio-input ::v-deep input {
  text-align: right;
}

.ticket-finalizados-switch-col {
  min-height: 56px;
}

.ticket-finalizados-switch {
  margin-top: 0;
}

.ticket-finalizados-switch ::v-deep .v-input--selection-controls__input {
  margin-top: 0;
}

::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr {
  cursor: pointer;
  transition: background-color 180ms ease;
}

::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr:hover {
  background-color: var(--v-rowsel-base) !important;
}

@media (max-width: 960px) {
  .ticket-subject {
    font-size: 16px;
  }
}

@media (prefers-reduced-motion: reduce) {

  .action-btn,
  ::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr {
    transition: none !important;
  }
}
</style>
